(function () {
  "use strict";

  var e = {
      n: function n(t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, {
          a: n
        }), n;
      },
      d: function d(t, n) {
        for (var r in n) {
          e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: n[r]
          });
        }
      },
      o: function o(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      },
      r: function r(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      },
      p: ""
    },
    t = {};
  e.r(t), e.d(t, {
    BasicDetails: function BasicDetails() {
      return Qc;
    },
    CreditCardTypes: function CreditCardTypes() {
      return gi;
    },
    Fulfilment: function Fulfilment() {
      return so;
    },
    Fulfilmentv2: function Fulfilmentv2() {
      return ic;
    },
    InfoList: function InfoList() {
      return Zc;
    },
    InsurancePDPA: function InsurancePDPA() {
      return $i;
    },
    LAYOUT: function LAYOUT() {
      return rc;
    },
    ORDER_CONFIRMATION: function ORDER_CONFIRMATION() {
      return Mr;
    },
    OrderConfirmation: function OrderConfirmation() {
      return ua;
    },
    OrderSummary: function OrderSummary() {
      return ba;
    },
    OrderSummaryRewamp: function OrderSummaryRewamp() {
      return Ji;
    },
    OrderSummaryV2: function OrderSummaryV2() {
      return ja;
    },
    PaymentMethodDisplayModeTypes: function PaymentMethodDisplayModeTypes() {
      return fi;
    },
    PaymentMethodSelector: function PaymentMethodSelector() {
      return Ni;
    },
    PaymentMethodTypes: function PaymentMethodTypes() {
      return Ei;
    },
    PaymentMethodViewMode: function PaymentMethodViewMode() {
      return Fi;
    },
    ShoppingCart: function ShoppingCart() {
      return rr;
    }
  });
  var n = require("react");
  var r = e.n(n);
  function l(e, t, n) {
    return void 0 === t && (t = 2), void 0 === n && (n = "0"), String(e).padStart(t, n);
  }
  var A = require("@wec-core/helpers"),
    o = JSON.parse('{"PAGE_TITLE_YOUR_CART":"Your cart","VIEW_AVAILABLE_OPTIONS":"View available options","DEVICE_OUT_OF_STOCK":"The {device} is no longer available and has been removed from your cart","VOUCHER_EXCEEDS_PAYABLE_AMOUNT":"Please note your voucher exceeds the value of item(s) in your cart and the difference is non-refundable.","NO_OF_BAG":"Bag {number}","SECTION_TITLE_MONTHLY_BILL":"Monthly bill","SECTION_TITLE_ADDITION_BILL":"In addition to your first bill","SECTION_DESCRIPTION_ADDITION_BILL":"Only require a one-time payment on your first bill","UPFRONT_TOTAL":"You pay total","MONTHLY_TOTAL":"Monthly total","ADDITION_TOTAL":"Additional charges on first bill","ACTION_BUTTON_CHECKOUT":"Check out","ACTION_ON_LINK":"Continue shopping","VOUCHER_TITLE":"Your voucher(s)","VOUCHER_UNAVAILABLE_TITLE":"Voucher unavailable","VOUCHER_NUMBER":"You have {count} voucher(s)","VOUCHER_NUMBER_HAVE_APPLIED":"You\'ve applied {count} voucher(s)","VOUCHER_GET_VOUCHER":"Got a voucher?","VOUCHER_EMPTY_TITLE":"Voucher(s) unavailable","VOUCHER_EMPTY_MESSAGE":"You do not have any existing voucher(s) with us currently.","VOUCHER_MODAL_ERROR_TITLE":"Our apologies","VOUCHER_MODAL_ERROR_MESSAGE":"Sorry, voucher(s) unavailable at the moment. Please try again later.","VOUCHER_APPLY":"Apply","VOUCHER_REMOVE":"Remove","VOUCHER_NOT_AVAILABLE":"Not available","VOUCHER_EXPIRY_DATE":"Valid till {date}","VOUCHER_AMOUNT_OFF":"{amount} OFF","VOUCHER_UNAVAILABLE":"Voucher(s) unavailable","VOUCHER_YOU_HAVE_NO_VOUCHER":"You do not have any existing voucher.","DISCOUNT_APPLIED":"Discount applied","TOTAL_SAVINGS":"Total savings","BROWSE_ACCESSORIES_LINK":"Start browsing","BROWSE_ACCESSORIES_TEXT":"Your ${amount} credits expire with this order","BROWSE_ACCESSORIES_DESC":"Don’t miss out — apply your vouchers to save on accessories","CART_TODAY_PAY":"Payable today","CART_GST_INCLUSIVE":"(GST-inclusive)","CART_TOTAL_SAVE":"YOU SAVE {amount}","CART_YOU_WILL_PAY":"You will pay","TRADE_IN_TITLE":"Trade-in","TRADE_IN_PHRASE":"Got a phone to trade-in?","TRADE_IN_UNAVAILABLE_PHRASE":"Trade-in unavailable","TRADE_IN_BRAND":"Device Brand","TRADE_IN_MODEL":"Device Model","TRADE_IN_CHECKBOX_TITLE":"Check that your mobile device matches these criteria","TRADE_IN_PRICE":"Trade-in {price}","TRADE_IN_BUTTON_REMOVE":"Remove","TRADE_IN_BUTTON_PROCEED":"Proceed","TRADE_IN_ERROR_DEVICE_BRAND_NOT_SELECTED":"Choose a brand","TRADE_IN_ERROR_DEVICE_MODEL_NOT_SELECTED":"Choose a model","TRADE_IN_ERROR_DEVICE_BRAND_AND_MODEL_NOT_MATCHING":"Device brand and model do not match","TRADE_IN_ERROR_LEFT_UNCHECKED":"To proceed with the trade-in, please ensure your phone meets all the conditions.","TRADE_IN_NOTE_1":"Please ensure you have read the full ","TRADE_IN_NOTE_2":" before trade-in.","TNC":"T&Cs","MODAL_CHANGE_PRODUCT_TITLE":"Change Item?","MODAL_CHANGE_PRODUCT_DESCRIPTION":"This will start a new order and all items in your cart will be removed.","MODAL_CHANGE_PLAN_TITLE":"Change Postpaid plan?","MODAL_CHANGE_PLAN_DESCRIPTION":"This will start a new order and all items in your cart will be removed.","MODAL_CHANGE_NUMBER_TITLE":"Start a new order?","MODAL_CHANGE_NUMBER_DESCRIPTION":"By proceeding, all you previous choices will be cleared.","ACTION_BUTTON_SAVE":"Save","ACTION_BUTTON_SUBMIT":"Submit","ACTION_BUTTON_VIEW_MORE":"View More","ACTION_BUTTON_NEXT":"Next","ACTION_BUTTON_SHOW_MORE_BRANDS":"Show more brands","ACTION_BUTTON_CLEAR":"Clear","ACTION_BUTTON_APPLY":"Apply","ACTION_BUTTON_ADD":"Add","ACTION_BUTTON_BACK":"Back","ACTION_BUTTON_EMPTY_CART":"Empty Cart","ACTION_BUTTON_COPY":"Copy","ACTION_BUTTON_COPIED":"Copied","ACTION_BUTTON_BACK_TO_HOME":"Back to Home","ACTION_BUTTON_SHARE_FEEDBACK":"Share Feedback","ACTION_BUTTON_DISMISS":"Dismiss","ORDER_STATUS_TITLE":"Order submitted","ORDER_STATUS_FAILURE_TITLE":"Order incomplete","ORDER_STATUS_BOLD_TEXT":" ","ORDER_STATUS_BODY_TEXT":" ","ORDER_INFO_SUBTITLE":"Reference ID","ORDER_INFO_SUBTITLE_LOADING":"Please wait","ORDER_INFO_TITLE_LOADING":"Generating policy number...","ORDER_NEXT_STEP_TITLE":"What\'s next","ORDER_NEXT_STEP_TEXT":" Order confirmation emial will be sent to {customerEmail}.","ORDER_WHAT_NEXT_TITLE":"What’s next","ORDER_WHAT_NEXT_TEXT":"An order confirmation will be sent to {customerEmail}","ORDER_PROMOTION_TITLE":"You might be interested in","ORDER_FEEDBACK_TEXT":"How was your experience today?","ORDER_HELP_TITLE":"Need Help?","ORDER_HELP_SUBTITLE":"For enquiries regarding your policy","ORDER_HELP_CALL_FROM_SINGAPORE":"Call from Singapore","ORDER_HELP_EMAIL":"Email","ORDER_HELP_CALL_FROM_OVERSEAS":"Call from overseas","VOUCHER_MESSAGE":"VOUCHER_MESSAGE","NOTIFY_MESSAGE":"NOTIFY_MESSAGE","SUBTOTAL":"Subtotal","ERROR_MESSAGE":"Cart error","ORDER_STATUS_INFO":"An order confirmation will be sent to {customerEmail}.","ORDER_TOTAL":"Total","ORDER_TOTAL_PROMO_DISCOUNT":"Promo code discount","ORDER_TOTAL_DELIVERY_FEE":"Delivery fee","OUT_OF_STOCK_MESSAGE":"The following item(s) are currently out of stock:"}'),
    a = JSON.parse('{"VOUCHER_TEXT_LINK":"Voucher Terms and Conditions"}'),
    i = JSON.parse('{"BUTTON_PROCEED":"Review order","BUTTON_LINK_SHOW_MORE_COUNT":"More ({count})","BUTTON_LINK_SHOW_LESS":"Show less","TEXT_FREE":"FREE","BAG_NUMBER":"Bag {count}","PAGE_TITLE_DELIVERY":"How would you like to get your order?","PICKUP_TYPE_DOORSTEP_DELVIERY":"Doorstep Delivery","PICKUP_TYPE_POPSTATION":"POPStation","PICKUP_TYPE_PARTNER_DELIVERY":"Delivery via partners","PICKUP_TYPE_COLLECT_AT_STORE":"Collect at store","ADDRESS_FORM_DELIVERY_ADDRESS":"Delivery address","ADDRESS_FORM_POSTAL_CODE":"Postal Code","ADDRESS_FORM_POSTAL_CODE_PLACEHOLDER":"Enter a valid 6-digit postal code","ADDRESS_FORM_HOUSE_AND_BLOCK":"House / Block no.","ADDRESS_FORM_STREET":"Street address","USE_ANOTHER_ADDRESS":"Use another address","ADDRESS_FORM_BUILDING":"Building / Estate name","ADDRESS_FORM_FLOOR":"Floor no.","ADDRESS_FORM_UNIT":"Unit no.","ADDRESS_FORM_DONT_HAVE_FLOOR_AND_UNIT":"My address doesn’t have a floor no. and unit no.","ADDRESS_FORM_ERROR_POSTAL_CODE_INVALID":"Enter a valid 6-digit postal code","DELIVERY_DATE":"Delivery date","DELIVERY_TIME":"Delivery time","DATE_PICKER_LABEL":"Pick-up date","POPSTATION_UNAVAILABLE":"There is no POPStation near: {postalCode}","POPSTATION_AVAILABLE":"Available at {count} POPStation(s) near: {postalCode}","PRE_ORDER_NOTIFICATION_TITLE":"What to expect for order in this bag?","PRE_ORDER_NOTIFICATION_CONTENT_1":"Pre-order item(s) will be delivered together with other items in your order (if any). You will be notified via email and SMS when your order is ready to be shipped.","PRE_ORDER_NOTIFICATION_CONTENT_2":"Want your items sooner for those that are available? Please purchase them in a separate order.","STORE_AVAILABLE":"Available at {numOfSearchResults} store(s) near {postalCode}","STORE_LOCATION":"Postal code","SEARCH_MORE":"More","SEARCH_LESS":"Less","STORE_POSTAL":"This must consist of 6 digits","STORE_VALID_POSTAL":"Make sure this is a valid postal code","INVALID_POSTAL_CODE":"Enter a valid 6-digit postal code","ENTER_POSTAL_CODE":"Enter a postal code","ENTER_POSTAL_CODE_FOR_ADDRESS":"Enter the postal code of your address","CC_E_API_POSTAL_FLOOR":"Enter valid floor","CC_E_API_POSTAL_UNIT":"Enter valid unit number","ENTER_YOUR_FLOOR":"Enter your floor","ENTER_YOUR_UNIT_NO":"Enter your unit no","CONFIRM":"Confirm","ADDED_FOR_THIS_ADDRESS":"Added for this order","CHANGE_ADDRESS":"Change","GOT_PROMO":"Got a promo code?","PROMO_CODE_PLACEHOLDER":"Promo code","ADD_TEXT":"Add","REMOVE_TEXT":"Remove"}'),
    c = JSON.parse('{"ORDER_SUMMARY_PAGE_TITLE":"Review order","PLACE_ORDER":"Place order","ORDER_SUMMARY_TNC_LABEL":"By submitting, I have read and agree to the Terms & Conditions and Singtel Data Protection Policy.","ORDER_SUMMARY_TNC_ERROR_MESSAGE":"To continue, we need your consent","PROCEED":"Proceed","PERSONAL_DETAILS":"Personal details","BILLING_ADDRESS":"Billing address","YOUR_ORDER":"Your order","DOORSTEP_DELIVERY":"Doorstep delivery","E_SIM_DELIVERY":"eSIM will be emailed to","PERSONAL_DETAILS_TITLE":"Update my personal details","PERSONAL_DETAILS_FULL_NAME":"Full name","PERSONAL_DETAILS_NRIC_OR_FIN":"NRIC/FIN","PERSONAL_DETAILS_DOB":"Date of birth","PERSONAL_DETAILS_CONTACT_NUMBER":"Contact Number","PERSONAL_DETAILS_EMAIL":"Email","PERSONAL_DETAILS_INFO":"Please ensure your contact details are accurate. All official Singtel documents (e.g. eBills, policies, service agreement, etc.) will be sent to the contacts stated above.","PLACE_ORDER_TITLE":"Payment Method","CONFIRM_PAYMENT_METHOD_BUTTON":"Confirm","PAYMENT_BY_CASH":"Pay by cash","PAYMENT_THROUGH_ONLINE":"Pay online","CHAT_ON_WHATS_APP":"Chat on WhatsApp","ENTER_VALID_MEMBERSHIP_ID":"Enter a valid membership ID","MEMBERSHIP_ID":"Membership ID","PAYMENT_INFO_TITLE":"Payment"}'),
    u = JSON.parse('{"CTA_INSURANCE_PDPA":"Agree to proceed"}'),
    s = JSON.parse('{"THANK_YOU_A_LITTLE_SOMETHING_FOR_YOU":"A little something for you","THANK_YOU_VALID_UNTIL_DATE":"Valid until {endDate}","THANK_YOU_LOADING_PROMO_CODE":"Loading Promo Code","THANK_YOU_PROMO_CODE":"Promo code","THANK_YOU_COPY":"Copy","THANK_YOU_COPIED":"Copied","THANK_YOU_PAGE_SIGNUP_NOW":"Sign up now","THANK_YOU_MAY_ALSO_CONSIDER":"You may also consider","THANK_YOU_COMPLIMENTARY_BILL_RELIEF":"Get complimentary bill relief","THANK_YOU_MOBILE_BILLS_COVERED":"Have your mobile bills covered in any unforeseen events"}');
  var _d = function d() {
    return _d = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var l in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }
      return e;
    }, _d.apply(this, arguments);
  };
  var m = _d(_d(_d(_d(_d(_d({}, o), a), i), u), c), s);
  var _E = function E() {
      return _E = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _E.apply(this, arguments);
    },
    g = {
      en: m
    },
    f = {},
    p = function p(e) {
      f = _E(_E({}, f), e);
    },
    v = function v(e, t) {
      var n = (0, A.getLocaleData)(g, (0, A.getLocale)("lang")),
        r = _E(_E({}, n), f)[e];
      return null !== r && (0, A.translate)(r || e, t);
    };
  var w = require("styled-components");
  var h = e.n(w);
  var C = require("react-sticky-el");
  var B = e.n(C);
  var y = require("@dls/web"),
    x = function x(e) {
      return (0, A.remCalc)(8 * e);
    };
  var I = function I(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _b = function b() {
      return _b = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _b.apply(this, arguments);
    },
    O = (0, y.withTheme)(h().div(S || (S = I(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme,
        n = e.p;
      return (0, w.css)(D || (D = I(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (e) {
        return x(e.top);
      }, function (e) {
        return x(e.bottom);
      }, (null == n ? void 0 : n.topMd) && "\n      @media (min-width: ".concat(t.brk_md, ") {\n        margin-top: ").concat(x(n.topMd), ";\n      }"), (null == n ? void 0 : n.bottomMd) && "\n      @media (min-width: ".concat(t.brk_md, ") {\n        margin-bottom: ").concat(x(n.bottomMd), ";\n      }\n      "), (null == n ? void 0 : n.bottomLg) && "\n      @media (min-width: ".concat(t.brk_lg, ") {\n        margin-bottom: ").concat(x(n.bottomLg), ";\n      }\n      "));
    }));
  var T = function T(e) {
    var t = e.top,
      n = void 0 === t ? 0 : t,
      l = e.bottom,
      A = void 0 === l ? 0 : l,
      o = e.topMd,
      a = void 0 === o ? 0 : o,
      i = e.bottomMd,
      c = void 0 === i ? 0 : i,
      u = e.topLg,
      s = void 0 === u ? 0 : u,
      d = e.bottomLg,
      m = void 0 === d ? 0 : d,
      E = e.children,
      g = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, ["top", "bottom", "topMd", "bottomMd", "topLg", "bottomLg", "children"]);
    return r().createElement(O, _b({
      top: n,
      bottom: A,
      topMd: a,
      bottomMd: c,
      topLg: s,
      bottomLg: m
    }, g), E);
  };
  var D,
    S,
    R,
    k,
    L,
    P,
    M,
    Q,
    N,
    H,
    F,
    X,
    V,
    G,
    z = function z(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    U = {
      default: "padding: 12px 0px;",
      small: "padding: 2px 0px;",
      large: "padding: 24px 0px;"
    },
    j = (0, y.withTheme)(h().li(R || (R = z(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px 0;\n  color: ", ";\n\n  & > *:first-child {\n    margin-right: 16px;\n  }\n  & > *:last-child {\n    margin-right: 0px;\n  }\n  & > *:nth-child(2) {\n    flex: none;\n  }\n\n  ", ";\n\n  ", "\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px 0;\n  color: ", ";\n\n  & > *:first-child {\n    margin-right: 16px;\n  }\n  & > *:last-child {\n    margin-right: 0px;\n  }\n  & > *:nth-child(2) {\n    flex: none;\n  }\n\n  ", ";\n\n  ", "\n"])), function (e) {
      return e.coreTheme.cl_ter_base;
    }, function (e) {
      return e.customSpacing && "padding: ".concat(e.customSpacing, "px 0");
    }, function (e) {
      return e.nounderline && "border-bottom: none !important; padding-bottom: 0 !important;";
    })),
    J = (0, y.withTheme)(h().div(function (e) {
      var t = e.bordered,
        n = e.size,
        r = e.noPadding,
        l = e.coreTheme;
      return (0, w.css)(k || (k = z(["\n      box-sizing: border-box;\n      margin: 0;\n      padding: 0;\n      color: ", ";\n      font-size: 14px;\n      list-style: none;\n      position: relative;\n\n      & * {\n        outline: none;\n      }\n\n      & ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n      }\n\n      ", "\n\n      ", "\n\n    ", "\n\n  ", "\n    "], ["\n      box-sizing: border-box;\n      margin: 0;\n      padding: 0;\n      color: ", ";\n      font-size: 14px;\n      list-style: none;\n      position: relative;\n\n      & * {\n        outline: none;\n      }\n\n      & ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n      }\n\n      ", "\n\n      ", "\n\n    ", "\n\n  ", "\n    "])), l.cl_ter_base, t && "border: 1px solid #d9d9d9;\n      border-radius: 2px;\n   ", n && "".concat(j, " {\n      ").concat(U[n], "\n\n      ").concat("large" === n && "\n      padding: 8px 0px;\n      ", "\n    }"), "default" === n && t && "".concat(j, "{\n            padding-left: 24px;\n            padding-right: 24px;\n            }"), r && "".concat(j, "{\n    padding-left: 0px;\n    padding-right: 0px;\n    }"));
    })),
    Y = h().div(L || (L = z(["\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  max-width: 100%;\n"], ["\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  max-width: 100%;\n"]))),
    K = h().div(P || (P = z(["\n  margin-right: 16px;\n"], ["\n  margin-right: 16px;\n"]))),
    Z = (0, y.withTheme)(h().span(M || (M = z(["\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-size: 14px;\n  line-height: 1.5715;\n  list-style: none;\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n  min-width: 32px;\n  min-height: 32px;\n  max-width: 80px;\n  max-height: 80px;\n  line-height: 32px;\n  //   background: #ccc;\n  overflow: hidden;\n  //   border-radius: 50%;\n"], ["\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-size: 14px;\n  line-height: 1.5715;\n  list-style: none;\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n  min-width: 32px;\n  min-height: 32px;\n  max-width: 80px;\n  max-height: 80px;\n  line-height: 32px;\n  //   background: #ccc;\n  overflow: hidden;\n  //   border-radius: 50%;\n"])), function (e) {
      return e.coreTheme.cl_ter_base;
    })),
    q = (0, y.withTheme)(h().div(Q || (Q = z(["\n  flex: 1 0;\n  width: 0;\n  color: ", ";\n  line-height: 1.5715;\n  font-size: 14px;\n"], ["\n  flex: 1 0;\n  width: 0;\n  color: ", ";\n  line-height: 1.5715;\n  font-size: 14px;\n"])), function (e) {
      return e.coreTheme.cl_ter_base;
    })),
    W = h().h4(N || (N = z(["\n  margin-top: 0;\n  margin-bottom: 4px;\n  font-weight: 500;\n  break-word: break-all;\n"], ["\n  margin-top: 0;\n  margin-bottom: 4px;\n  font-weight: 500;\n  break-word: break-all;\n"]))),
    _ = (0, y.withTheme)(h().div(H || (H = z(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (e) {
      return e.coreTheme.cl_ter_l3;
    })),
    $ = h().div(F || (F = z(["\n  display: flex;\n  margin-left: -8px;\n"], ["\n  display: flex;\n  margin-left: -8px;\n"]))),
    ee = h().div(X || (X = z(["\n  margin-top: -4px;\n"], ["\n  margin-top: -4px;\n"]))),
    te = h().div(V || (V = z(["\n  display: flex;\n  padding-top: 8px;\n  gap: 8px;\n"], ["\n  display: flex;\n  padding-top: 8px;\n  gap: 8px;\n"]))),
    ne = h().img(G || (G = z(["\n  height: 56px;\n  width: 56px;\n  border-radius: 6px;\n  overflow: hidden;\n  border-radius: 6px;\n"], ["\n  height: 56px;\n  width: 56px;\n  border-radius: 6px;\n  overflow: hidden;\n  border-radius: 6px;\n"]))),
    re = {
      CH: "Change",
      RM: "Remove"
    },
    le = "mobile-number",
    Ae = function Ae(e) {
      var t = e.header,
        n = void 0 === t ? null : t,
        l = e.footer,
        A = void 0 === l ? null : l,
        o = e.total,
        a = e.discount,
        i = void 0 === a ? null : a,
        c = e.subtotal,
        u = void 0 === c ? null : c,
        s = e.dataSource,
        d = void 0 === s ? [] : s,
        m = e.renderItem,
        E = e.bordered,
        g = void 0 !== E && E,
        f = e.size,
        p = void 0 === f ? "default" : f,
        v = e.noPadding,
        w = void 0 !== v && v,
        h = e.children,
        C = e.footerhasDivider,
        B = void 0 === C || C,
        x = e["data-testid"],
        I = "dataSource";
      return Object.entries({
        total: o,
        discount: i,
        subtotal: u,
        footer: A
      }).forEach(function (e) {
        var t = e[0];
        e[1] && (I = t);
      }), r().createElement(J, {
        bordered: g,
        size: p,
        noPadding: w,
        "data-testid": x || "list"
      }, r().createElement("ul", null, n && r().createElement(oe, {
        nounderline: !0
      }, n), d.map(function (e, t, n) {
        return r().createElement("span", {
          key: t
        }, m(e, t, n.length - 1 === t));
      }), "dataSource" !== I && B && r().createElement(y.Divider, null), o && r().createElement(oe, {
        nounderline: "total" === I
      }, o), i && r().createElement(oe, {
        nounderline: !0
      }, i), u && r().createElement(oe, {
        nounderline: "subtotal" === I
      }, u), A && r().createElement(y.Spacing, {
        top: 0
      }, r().createElement(oe, {
        nounderline: "footer" === I
      }, A))), h);
    },
    oe = function oe(e) {
      var t = e.children,
        n = e.nounderline,
        l = void 0 !== n && n,
        A = e.customSpacing,
        o = void 0 === A ? null : A;
      return r().createElement(r().Fragment, null, r().createElement(j, {
        customSpacing: o,
        "data-testid": "list-item"
      }, t), !l && r().createElement(y.Divider, null));
    };
  (Ae.Item = oe).Meta = function (e) {
    var t = e.titleType,
      n = e.title,
      l = e.highlightedText,
      A = e.extraText,
      o = e.description,
      a = e.avatar,
      i = e.bundleImages,
      c = e.quantity,
      u = e.onChangeQuantity;
    return r().createElement(Y, null, a && r().createElement(K, null, r().createElement(Z, null, a)), r().createElement(q, null, n && (t === le ? r().createElement("div", {
      className: "fs-mask"
    }, r().createElement(W, null, n)) : r().createElement(W, null, n)), l && r().createElement(ee, null, "variant1" === l.variant ? r().createElement(y.Ribbon.Variant1, {
      color: l.color
    }, l.text) : r().createElement(y.Ribbon.Variant2, {
      color: l.color
    }, l.text)), o && r().createElement(_, null, o), c && r().createElement($, null, r().createElement(y.QuantityInput, {
      value: c.value,
      minValue: (null == c ? void 0 : c.disableDecrease) ? c.value : c.min,
      maxValue: (null == c ? void 0 : c.disableIncrease) ? c.value : c.max,
      onValueChange: function onValueChange(e, t) {
        u && u(e, t);
      }
    })), A && r().createElement(_, null, A), (null == i ? void 0 : i.length) > 0 && r().createElement(te, null, null == i ? void 0 : i.map(function (e, t) {
      return r().createElement(ne, {
        key: t,
        src: null == e ? void 0 : e.src,
        alt: null == e ? void 0 : e.alt,
        "data-testid": "bundle-image"
      });
    }))));
  };
  var ae = Ae,
    ie = function ie(e, t) {
      if (void 0 === t && (t = 2), isNaN(Number(e))) return e;
      e = Number(e);
      var n = Math.abs(e).toFixed(t);
      return e < 0 ? "-$".concat(n) : "$".concat(n);
    },
    ce = require("@dls/assets/dist/icons/web");
  var ue,
    se,
    de,
    me,
    Ee,
    ge,
    fe,
    pe,
    ve,
    we,
    he,
    Ce,
    Be,
    ye,
    xe,
    Ie,
    be,
    Oe,
    Te,
    De,
    Se,
    Re,
    ke = function ke(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Le = (0, y.withTheme)(h().div(se || (se = ke(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t,
        n,
        r = e.coreTheme;
      return (0, w.css)(ue || (ue = ke(["\n    padding: 0px 16px;\n    padding-top: 8px;\n    border-radius: 8px;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: ", ";\n    @media (min-width: ", ") {\n      padding: 0px 16px;\n      padding-top: 8px;\n    }\n    @media (min-width: ", ") {\n      padding: 0px 16px;\n      padding-top: 8px;\n    }\n\n    ", "\n  "], ["\n    padding: 0px 16px;\n    padding-top: 8px;\n    border-radius: 8px;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: ", ";\n    @media (min-width: ", ") {\n      padding: 0px 16px;\n      padding-top: 8px;\n    }\n    @media (min-width: ", ") {\n      padding: 0px 16px;\n      padding-top: 8px;\n    }\n\n    ", "\n  "])), null === (n = null === (t = null == r ? void 0 : r.color) || void 0 === t ? void 0 : t.background) || void 0 === n ? void 0 : n.subtle2, r.brk_md, r.brk_lg, function (e) {
        var t = e.padding;
        return "\n    padding: ".concat(t, ";\n      ");
      });
    })),
    Pe = (0, y.withTheme)(h()(y.Text)(de || (de = ke(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (e) {
      var t = e.error,
        n = e.coreTheme;
      return t ? n.cl_pri_d3 : n.cl_ter_l3;
    })),
    Me = (0, y.withTheme)(h().div(me || (me = ke(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.disabled,
        n = e.coreTheme;
      return t && "\n    background-color: ".concat(n.cl_ter_l6, ";\n    border-radius: ").concat(n.space_2, ";\n  ");
    })),
    Qe = (0, y.withTheme)(h()(y.Text)(Ee || (Ee = ke(["\n  text-decoration: line-through;\n  color: ", ";\n"], ["\n  text-decoration: line-through;\n  color: ", ";\n"])), function (e) {
      return e.coreTheme.cl_ter_l3;
    })),
    Ne = h().div(ge || (ge = ke(["\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n"], ["\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n"]))),
    He = (0, y.withTheme)(h()(ce.Search)(fe || (fe = ke(["\n  width: 24px;\n  height: 24px;\n\n  & > path {\n    fill: ", ";\n  }\n"], ["\n  width: 24px;\n  height: 24px;\n\n  & > path {\n    fill: ", ";\n  }\n"])), function (e) {
      return e.coreTheme.cl_sec_d1;
    })),
    Fe = h()(y.Layout.Inline)(pe || (pe = ke(["\n  flex-wrap: nowrap;\n"], ["\n  flex-wrap: nowrap;\n"]))),
    Xe = (0, w.css)(ve || (ve = ke(["\n  width: 80px;\n  height: 80px;\n"], ["\n  width: 80px;\n  height: 80px;\n"]))),
    Ve = (0, w.css)(we || (we = ke(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]))),
    Ge = h().img(he || (he = ke(["\n  ", "\n"], ["\n  ", "\n"])), Xe),
    ze = (0, y.withTheme)(h().div(Ce || (Ce = ke(["\n  width: 60px;\n  height: 60px;\n  border-radius: 16px;\n  ", "\n  border: 2px solid ", ";\n  margin-top: 1px;\n"], ["\n  width: 60px;\n  height: 60px;\n  border-radius: 16px;\n  ", "\n  border: 2px solid ", ";\n  margin-top: 1px;\n"])), Ve, function (e) {
      return e.coreTheme.cl_ter_l5;
    })),
    Ue = h().div(Be || (Be = ke(["\n  ", "\n  ", "\n  align-items: flex-start;\n"], ["\n  ", "\n  ", "\n  align-items: flex-start;\n"])), Xe, Ve),
    je = h()(y.Text)(ye || (ye = ke(["\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n"], ["\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n"])), function (e) {
      return e.maxLine;
    }),
    Je = (0, y.withTheme)(h()(y.Grid)(Ie || (Ie = ke(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme,
        n = e.noBottomSpacing;
      return (0, w.css)(xe || (xe = ke(["\n    padding-top: 32px;\n    margin-bottom: ", ";\n    @media (min-width: ", ") {\n      padding-top: 32px;\n    }\n    @media (min-width: ", ") {\n      padding-bottom: ", ";\n    }\n  "], ["\n    padding-top: 32px;\n    margin-bottom: ", ";\n    @media (min-width: ", ") {\n      padding-top: 32px;\n    }\n    @media (min-width: ", ") {\n      padding-bottom: ", ";\n    }\n  "])), n ? 0 : "64px", t.brk_md, t.brk_sm, n ? 0 : "40px");
    })),
    Ye = h().div(be || (be = ke(["\n  & > div:not(:last-child) {\n    margin-bottom: 32px;\n  }\n"], ["\n  & > div:not(:last-child) {\n    margin-bottom: 32px;\n  }\n"]))),
    Ke = (0, y.withTheme)(h()(y.Spacing)(Te || (Te = ke(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(Oe || (Oe = ke(["\n    display: none;\n    @media (min-width: ", ") {\n      display: block;\n    }\n  "], ["\n    display: none;\n    @media (min-width: ", ") {\n      display: block;\n    }\n  "])), t.brk_sm);
    })),
    Ze = (0, y.withTheme)(h()(y.Spacing)(Se || (Se = ke(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(De || (De = ke(["\n    display: block;\n    @media (min-width: ", ") {\n      display: none;\n    }\n  "], ["\n    display: block;\n    @media (min-width: ", ") {\n      display: none;\n    }\n  "])), t.brk_sm);
    })),
    qe = h().div(Re || (Re = ke(["\n  text-align: right;\n"], ["\n  text-align: right;\n"]))),
    We = function We(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _e = h().div(et || (et = We(["\n  > svg {\n    width: 24px;\n    height: 24px;\n    vertical-align: -webkit-baseline-middle;\n  }\n"], ["\n  > svg {\n    width: 24px;\n    height: 24px;\n    vertical-align: -webkit-baseline-middle;\n  }\n"])));
  var $e = {
    CardSectionButton: h().div(tt || (tt = We(["\n    flex: 1;\n    flex-direction: column;\n    display: flex;\n    align-self: stretch;\n    align-items: flex-end;\n  "], ["\n    flex: 1;\n    flex-direction: column;\n    display: flex;\n    align-self: stretch;\n    align-items: flex-end;\n  "])))
  };
  var et,
    tt,
    nt = function nt(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _rt = function rt() {
      return _rt = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _rt.apply(this, arguments);
    },
    lt = h().div(at || (at = nt(["\n  display: inline-block;\n  width: 10px;\n"], ["\n  display: inline-block;\n  width: 10px;\n"]))),
    At = h().div(it || (it = nt(["\n  margin: -4px;\n"], ["\n  margin: -4px;\n"])));
  var ot = function ot(e) {
    var t = e.modalTitle,
      l = e.defaultSelectedItemId,
      A = e.items,
      o = e.actions,
      a = e.onClose,
      i = (0, n.useState)(null),
      c = i[0],
      u = i[1];
    return (0, n.useEffect)(function () {
      u(l);
    }, [l]), r().createElement(y.Modal, {
      visible: !0,
      title: t,
      onClose: a,
      "data-testid": "selection-modal"
    }, r().createElement(y.Modal.Content, null, A && A.map(function (e) {
      return r().createElement(T, {
        top: 2,
        key: e.id
      }, r().createElement(y.Selector, {
        alignment: "row",
        selected: e.id === c,
        onClick: function onClick() {
          u(e.id);
        }
      }, r().createElement(At, null, r().createElement(y.Text, {
        type: "boldBody"
      }, e.name), r().createElement(y.Text, {
        type: "smallBody",
        lineHeight: "compact"
      }, e.description), r().createElement(y.Text, {
        type: "smallBody",
        lineHeight: "compact"
      }, e.extraText))));
    }), r().createElement(T, {
      top: 3
    }, null == o ? void 0 : o.map(function (e) {
      return r().createElement(r().Fragment, {
        key: e.text
      }, r().createElement(y.Button, _rt({}, e, {
        onClick: function onClick() {
          var t;
          a(), null === (t = e.onClick) || void 0 === t || t.call(e, c);
        }
      })), r().createElement(lt, null));
    }))));
  };
  var at, it;
  var ct = function ct(e) {
    var t = e.data,
      n = void 0 === t ? {} : t,
      l = e.hasColorContainer,
      A = n.totalAmount,
      o = n.dataSource,
      a = void 0 === o ? [] : o,
      i = function i() {
        return r().createElement(ae, {
          header: r().createElement(y.Text, {
            type: "boldBody"
          }, v("DISCOUNT_APPLIED")),
          footer: r().createElement(r().Fragment, null, r().createElement(y.Text, {
            type: "boldBody"
          }, v("TOTAL_SAVINGS")), r().createElement(y.Text, {
            type: "boldBody"
          }, ie(A))),
          footerhasDivider: !1,
          size: "small",
          dataSource: a,
          renderItem: function renderItem(e) {
            return r().createElement(ae.Item, {
              nounderline: !0,
              key: null == e ? void 0 : e.name,
              customSpacing: "8"
            }, r().createElement(y.Text, {
              type: "smallBody"
            }, e.name), r().createElement(y.Text, {
              type: "smallBody"
            }, ie(e.price)));
          }
        });
      };
    return l ? r().createElement(Le, null, i()) : i();
  };
  var ut = function ut(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    st = h().div(vt || (vt = ut(["\n  display: flex;\n  width: 100%;\n  background-color: #f7f7f7;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e1e1e1;\n"], ["\n  display: flex;\n  width: 100%;\n  background-color: #f7f7f7;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e1e1e1;\n"]))),
    dt = h().div(wt || (wt = ut(["\n  flex: 1;\n"], ["\n  flex: 1;\n"]))),
    mt = h().div(ht || (ht = ut(["\n  display: flex;\n"], ["\n  display: flex;\n"]))),
    Et = h().div(Ct || (Ct = ut(["\n  display: flex;\n  border-radius: 8px;\n  background-color: #f7f7f7;\n  min-height: 56px;\n  height: 56px;\n  width: 56px;\n  overflow: hidden;\n  min-width: 56px;\n  min-height: 56px;\n  position: relative;\n  margin-top: 10px;\n  margin-right: 8px;\n"], ["\n  display: flex;\n  border-radius: 8px;\n  background-color: #f7f7f7;\n  min-height: 56px;\n  height: 56px;\n  width: 56px;\n  overflow: hidden;\n  min-width: 56px;\n  min-height: 56px;\n  position: relative;\n  margin-top: 10px;\n  margin-right: 8px;\n"]))),
    gt = h()(y.Text)(Bt || (Bt = ut(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"]))),
    ft = h().div(yt || (yt = ut(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
  var pt = function pt(e) {
    var t,
      n = e.item,
      l = e.handleClick;
    return r().createElement(st, {
      className: "bundle-card-container",
      "data-testid": "bundle-card"
    }, r().createElement(dt, null, r().createElement(mt, null, n.name && r().createElement(y.Text, {
      type: "boldBody",
      lineHeight: "compact",
      "data-testid": "bundle-card-name"
    }, n.name), n.price && r().createElement(gt, {
      type: "boldBody",
      lineHeight: "compact",
      "data-testid": "bundle-card-price"
    }, isNaN(n.price) ? n.price : ie(n.price))), n.description && r().createElement(y.Text, {
      type: "smallBody",
      css: {
        marginTop: 4
      },
      lineHeight: "compact",
      "data-testid": "bundle-card-description"
    }, n.description), (null === (t = null == n ? void 0 : n.bundleImages) || void 0 === t ? void 0 : t.length) > 0 && r().createElement(mt, null, n.bundleImages.map(function (e, t) {
      return r().createElement(Et, {
        key: t,
        "data-testid": "bundle-card-image-".concat(t)
      }, r().createElement("img", {
        src: e.src,
        alt: e.alt
      }));
    })), r().createElement(ft, null, re[n.action] && r().createElement(y.TextLink, {
      "data-testid": "bundle-card-action",
      onClick: function onClick() {
        return function (e) {
          l(e);
        }(n);
      }
    }, re[n.action]))));
  };
  var vt,
    wt,
    ht,
    Ct,
    Bt,
    yt,
    _xt = function xt() {
      return _xt = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _xt.apply(this, arguments);
    },
    It = function It(e) {
      var t = e.icon,
        n = e.descriptionTitle,
        l = e.descriptionContent;
      return n || l || t ? r().createElement(T, {
        bottom: 4
      }, r().createElement(y.Row, null, t && r().createElement(y.Column, {
        noGutter: !0,
        style: {
          flexGrow: 0,
          marginRight: 12
        }
      }, r().createElement(_e, null, t)), r().createElement(y.Column, {
        noGutter: !0
      }, n && r().createElement(y.Text, {
        type: "boldBody"
      }, n), l && r().createElement(y.Text, {
        type: "smallBody"
      }, l)))) : null;
    };
  var bt = function bt(e) {
      var t = e.data,
        l = void 0 === t ? {} : t,
        A = e.sectionConfig,
        o = void 0 === A ? {} : A,
        a = e.discount,
        i = void 0 === a ? null : a,
        c = e.subtotal,
        u = void 0 === c ? null : c,
        s = e.border,
        d = void 0 === s || s,
        m = e.padding,
        E = void 0 === m || m,
        g = e.onChangePhone,
        f = e.onChangePlan,
        p = e.onChangeNumber,
        w = e.onRemoveItem,
        h = e.onChangeQuantity,
        C = l.title,
        B = l.description,
        x = l.dataSource,
        I = void 0 === x ? [] : x,
        b = l.totalText,
        O = l.totalAmount,
        D = l.footer,
        S = l.descriptionTitle,
        R = l.descriptionContent,
        k = l.notification,
        L = (0, n.useState)(null),
        P = L[0],
        M = L[1],
        Q = function Q(e) {
          e.modalName ? M(e.modalName) : w(e);
        },
        N = function N(e) {
          var t, n;
          return (null == e ? void 0 : e.image) ? r().createElement("img", _xt({}, {
            width: 80,
            height: 80
          }, {
            src: null === (t = e.image) || void 0 === t ? void 0 : t.src,
            alt: null === (n = e.image) || void 0 === n ? void 0 : n.alt
          })) : null;
        },
        H = function H(e) {
          var t = e.item,
            n = e.nounderline,
            l = void 0 !== n && n,
            A = e.headerText,
            o = void 0 !== A && A;
          return r().createElement(r().Fragment, {
            key: null == t ? void 0 : t.name
          }, "CHANGE_PRODUCT" === P && t.modalName === P && r().createElement(y.Modal, {
            visible: !0,
            title: v("MODAL_CHANGE_PRODUCT_TITLE"),
            onClose: function onClose() {
              return M(null);
            }
          }, r().createElement(y.Modal.Content, null, v("MODAL_CHANGE_PRODUCT_DESCRIPTION"), r().createElement(T, {
            top: 4
          }, r().createElement(y.Row, null, r().createElement(y.Column, {
            xs: 12
          }, r().createElement(y.Button, {
            text: "Proceed",
            fullWidth: !0,
            onClick: function onClick() {
              M(null), g(t);
            }
          })))))), "CHANGE_PLAN" === P && t.modalName === P && r().createElement(y.Modal, {
            visible: !0,
            title: v("MODAL_CHANGE_PLAN_TITLE"),
            onClose: function onClose() {
              return M(null);
            }
          }, r().createElement(y.Modal.Content, null, v("MODAL_CHANGE_PLAN_DESCRIPTION"), r().createElement(T, {
            top: 4
          }, r().createElement(y.Row, null, r().createElement(y.Column, {
            xs: 12
          }, r().createElement(y.Button, {
            text: "Proceed",
            fullWidth: !0,
            onClick: function onClick() {
              M(null), f(t);
            }
          })))))), "CHANGE_NUMBER" === P && t.modalName === P && r().createElement(y.Modal, {
            visible: !0,
            title: v("MODAL_CHANGE_NUMBER_TITLE"),
            onClose: function onClose() {
              return M(null);
            }
          }, r().createElement(y.Modal.Content, null, v("MODAL_CHANGE_NUMBER_DESCRIPTION"), r().createElement(T, {
            top: 4
          }, r().createElement(y.Row, null, r().createElement(y.Column, {
            xs: 12
          }, r().createElement(y.Button, {
            text: "Proceed",
            fullWidth: !0,
            onClick: function onClick() {
              M(null), p(t);
            }
          })))))), "SELECTION_MODAL" === P && t.modalName === P && r().createElement(ot, _xt({}, t.selectionModalData, {
            onClose: function onClose() {
              M(null);
            }
          })), "Bundle" !== t.type ? r().createElement(ae.Item, {
            nounderline: l
          }, r().createElement(ae.Item.Meta, {
            avatar: N(t),
            titleType: t.type,
            title: r().createElement(r().Fragment, null, r().createElement(y.Text, {
              type: o ? "header" : "body"
            }, t.ribbon && r().createElement("span", null, "".concat(t.ribbon, " ")), t.name)),
            highlightedText: t.highlightedText,
            description: t.description && r().createElement(y.Text, {
              type: "smallBody"
            }, t.description),
            extraText: t.extraText && r().createElement(y.Text, {
              type: "smallBody"
            }, t.extraText),
            quantity: null == t ? void 0 : t.quantity,
            onChangeQuantity: function onChangeQuantity(e) {
              return h(e, t);
            }
          }), r().createElement($e.CardSectionButton, null, r().createElement("div", {
            style: {
              textAlign: "right"
            }
          }, r().createElement(y.Text, {
            type: "boldBody"
          }, isNaN(t.price) ? t.price : ie(t.price)), t.slashPrice && r().createElement(Qe, {
            type: "body"
          }, isNaN(t.slashPrice) ? t.slashPrice : ie(t.slashPrice)), t.priceDescription && r().createElement(y.Text, {
            type: "smallBody"
          }, t.priceDescription)), re[t.action] && r().createElement(y.TextLink, {
            onClick: function onClick() {
              return Q(t);
            }
          }, re[t.action]))) : F(t, l));
        },
        F = function F(e, t) {
          return r().createElement(ae.Item, {
            nounderline: t
          }, r().createElement(pt, {
            item: e,
            handleClick: function handleClick() {
              return Q(e);
            }
          }));
        },
        X = function X() {
          var e;
          return r().createElement(r().Fragment, null, r().createElement(ae, {
            size: "large",
            dataSource: I,
            noPadding: !E,
            total: !!Number(O) && r().createElement(r().Fragment, null, r().createElement(y.Text, {
              type: "header"
            }, b), r().createElement(y.Text, {
              type: "header"
            }, ie(O))),
            subtotal: u && r().createElement(r().Fragment, null, r().createElement(y.Text, {
              type: "boldBody"
            }, v("SUBTOTAL")), r().createElement("div", {
              style: {
                textAlign: "right"
              }
            }, r().createElement(y.Text, {
              type: "boldBody"
            }, ie(null == u ? void 0 : u.price)), r().createElement(Qe, {
              type: "body"
            }, ie(null == u ? void 0 : u.slashPrice)))),
            discount: i && r().createElement(ct, {
              hasColorContainer: !0,
              data: i
            }),
            footer: D && r().createElement("div", null, r().createElement(y.Text, {
              type: "boldBody"
            }, null == D ? void 0 : D.title), r().createElement(y.Text, {
              type: "smallBody"
            }, D.description)),
            renderItem: function renderItem(e, t, n) {
              return r().createElement(r().Fragment, {
                key: "key_".concat(t, "_").concat(null == e ? void 0 : e.name)
              }, "group" === e.type ? e.dataSource.map(function (e, t) {
                return H({
                  item: e,
                  nounderline: n,
                  headerText: e.type === le
                });
              }) : H({
                item: e,
                nounderline: n,
                headerText: e.type === le
              }));
            }
          }), k && r().createElement("div", {
            "data-testid": "cart-section-notification"
          }, r().createElement(T, {
            top: 2,
            bottom: 4
          }, r().createElement(y.StatusAlert, _xt({}, k)))), !d && r().createElement(T, {
            top: null !== (e = o.dividerTopSpacing) && void 0 !== e ? e : 0
          }, r().createElement(y.Divider, null)));
        };
      return 0 === I.length ? null : r().createElement("div", {
        "data-testid": "cart-section"
      }, (C || B) && r().createElement(T, {
        bottom: 2
      }, r().createElement(y.Text, {
        type: "sectionTitle02"
      }, C), r().createElement(y.Text, {
        type: "body"
      }, B)), (S || R) && r().createElement(It, {
        icon: o.showDescriptionHeaderIcon ? r().createElement(ce.Shop, null) : null,
        descriptionTitle: S,
        descriptionContent: R
      }), r().createElement(T, {
        bottom: 2
      }, d ? r().createElement(Le, {
        "data-testid": "color-container",
        type: "tertiary"
      }, X()) : X()));
    },
    Ot = function Ot(e) {
      var t = e.data || {},
        n = t.payTotalAmount,
        l = t.beforeDiscountAmount,
        A = t.saveAmount;
      return r().createElement("div", {
        "data-testid": "total-section"
      }, r().createElement(y.Row, {
        between: "xs"
      }, A ? r().createElement(y.Ribbon.Variant1, {
        color: "primary"
      }, v("CART_TOTAL_SAVE", {
        amount: "".concat(ie(A))
      })) : null), r().createElement(y.Row, {
        between: "xs"
      }, r().createElement(y.Text, {
        type: "header"
      }, v("CART_TODAY_PAY")), r().createElement(y.Spacing, {
        left: 1
      }, r().createElement(y.Text, {
        type: "header"
      }, ie(n)))), r().createElement(y.Row, {
        between: "xs"
      }, r().createElement(y.Text, {
        type: "boldBody"
      }, v("CART_GST_INCLUSIVE")), l ? r().createElement(Qe, {
        type: "body"
      }, ie(l)) : null));
    };
  var Tt,
    Dt,
    St,
    Rt,
    kt,
    Lt,
    Pt = function Pt(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Mt = (h()(y.Spacing)(Tt || (Tt = Pt(["\n  position: relative;\n  & > div {\n    width: 100%;\n   & > div {\n      width: 100%;\n    }\n  }\n"], ["\n  position: relative;\n  & > div {\n    width: 100%;\n   & > div {\n      width: 100%;\n    }\n  }\n"]))), (0, y.withTheme)(h()(y.Spacing)(Dt || (Dt = Pt(["\n  background:  ", ";\n  border-radius: 8px;\n"], ["\n  background:  ", ";\n  border-radius: 8px;\n"])), function (e) {
      return e.coreTheme.cl_ter_l6;
    }))),
    Qt = h().div(St || (St = Pt(["\n  margin-bottom: 16px;\n"], ["\n  margin-bottom: 16px;\n"]))),
    Nt = h()(y.Column)(Rt || (Rt = Pt(["\n  padding: 8px 0;\n"], ["\n  padding: 8px 0;\n"]))),
    Ht = h()(y.Row)(kt || (kt = Pt(["\n  margin-bottom: 3rem;\n"], ["\n  margin-bottom: 3rem;\n"]))),
    Ft = (0, y.withTheme)(h()(y.Spacing)(Lt || (Lt = Pt(["\n  @media (max-width: ", ") {\n    padding-bottom: 8px;\n  }\n"], ["\n  @media (max-width: ", ") {\n    padding-bottom: 8px;\n  }\n"])), function (e) {
      return e.coreTheme.brk_xs;
    })),
    _Xt = function Xt() {
      return _Xt = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Xt.apply(this, arguments);
    },
    Vt = [{
      id: 1,
      label: "Device is in good working condition",
      checked: !1
    }, {
      id: 2,
      label: "No cosmetic damage",
      checked: !1
    }, {
      id: 3,
      label: "No damage on LCD screen, display is sharp and clear",
      checked: !1
    }, {
      id: 4,
      label: "Personal information has been deleted by factory reset",
      checked: !1
    }, {
      id: 5,
      label: "Comes with original battery, charger and accompanying accessories ",
      checked: !1
    }];
  var Gt = function Gt(e) {
      var t = e.visible,
        l = e.brands,
        A = e.modelByBrand,
        o = e.onClose,
        a = e.onSubmit,
        i = e.onTncClicked,
        c = void 0 === i ? function () {} : i,
        u = (0, n.useState)(null),
        s = u[0],
        d = u[1],
        m = (0, n.useState)(null),
        E = m[0],
        g = m[1],
        f = (0, n.useState)(Vt),
        p = f[0],
        w = f[1],
        h = (0, n.useState)(void 0),
        C = h[0],
        B = h[1];
      return (0, n.useEffect)(function () {
        t || (d(null), g(null), B(null));
      }, [t]), r().createElement(y.Modal, {
        "data-testid": "trade-in-modal",
        visible: t,
        title: v("TRADE_IN_TITLE"),
        onClose: o,
        scrollable: !0
      }, r().createElement(y.Modal.Content, null, r().createElement(Ft, {
        bottom: 1
      }, r().createElement(y.Row, null, r().createElement(Nt, {
        xs: 12
      }, r().createElement(y.DropdownInput, {
        label: v("TRADE_IN_BRAND"),
        bgColor: "haze",
        items: l,
        value: null == s ? void 0 : s.value,
        onChange: function onChange(e) {
          e.value !== (null == s ? void 0 : s.value) && d(e);
        },
        error: !!(null == C ? void 0 : C.brandDropdown),
        hintMessage: null == C ? void 0 : C.brandDropdown
      })), r().createElement(Nt, {
        xs: 12
      }, r().createElement(y.DropdownInput, {
        label: v("TRADE_IN_MODEL"),
        bgColor: "haze",
        items: A[null == s ? void 0 : s.value],
        value: null == E ? void 0 : E.value,
        onChange: function onChange(e) {
          g(e);
        },
        error: !!(null == C ? void 0 : C.modelDropdown),
        hintMessage: null == C ? void 0 : C.modelDropdown
      })))), r().createElement(Ft, {
        bottom: 1
      }, r().createElement(y.Row, null, r().createElement(Nt, {
        xs: 12
      }, r().createElement(Ft, null, r().createElement(y.Text, {
        type: "boldBody"
      }, v("TRADE_IN_CHECKBOX_TITLE"))))), (null == C ? void 0 : C.checklist) && r().createElement(y.Row, null, r().createElement(Nt, {
        xs: 12
      }, r().createElement(Le, {
        type: "primary"
      }, r().createElement(y.Text, {
        type: "smallBody"
      }, null == C ? void 0 : C.checklist)))), r().createElement(y.Row, null, r().createElement(Nt, null, p.map(function (e) {
        return r().createElement(Qt, {
          key: e.id
        }, r().createElement(y.Checkbox.Input, {
          label: e.label,
          onChange: function onChange(t, n) {
            return function (e, t) {
              var n = p.map(function (n) {
                return n.id === e ? _Xt(_Xt({}, n), {
                  checked: t
                }) : n;
              });
              w(n);
            }(e.id, n);
          }
        }));
      })))), r().createElement(y.Row, null, r().createElement(Nt, null, r().createElement(T, {
        bottom: 2
      }, r().createElement(y.Text, {
        type: "body"
      }, v("TRADE_IN_NOTE_1"), r().createElement(y.TextLink, {
        inline: !0,
        onClick: c
      }, v("TNC")), v("TRADE_IN_NOTE_2"))))), r().createElement(Ht, null, r().createElement(Nt, null, r().createElement(y.Button, {
        fullWidth: !0,
        text: v("TRADE_IN_BUTTON_PROCEED"),
        onClick: function onClick() {
          var e = !1,
            t = null,
            n = null,
            r = null;
          if (s || (e = !0, n = v("TRADE_IN_ERROR_DEVICE_BRAND_NOT_SELECTED")), E || (e = !0, r = v("TRADE_IN_ERROR_DEVICE_MODEL_NOT_SELECTED")), s && E) {
            var l = A[s.value];
            (null == l ? void 0 : l.find(function (e) {
              return e.value === E.value;
            })) || (e = !0, r = v("TRADE_IN_ERROR_DEVICE_BRAND_AND_MODEL_NOT_MATCHING"));
          }
          p.length && p.some(function (e) {
            return !e.checked;
          }) && (e = !0, t = v("TRADE_IN_ERROR_LEFT_UNCHECKED")), e ? B({
            checklist: t,
            brandDropdown: n,
            modelDropdown: r
          }) : (B(null), o(), a({
            brand: s.value,
            model: E.value,
            tradeinPrice: E.tradeinPrice
          }));
        }
      })))));
    },
    zt = require("dayjs");
  var Ut = e.n(zt);
  var jt = require("@babel/runtime/helpers/extends");
  var Jt = e.n(jt);
  var Yt = require("@babel/runtime/helpers/objectWithoutProperties");
  var Kt = e.n(Yt),
    Zt = ["styles"],
    qt = ["styles"],
    Wt = function Wt(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _t = "SELECTED",
    $t = "DISABLED",
    en = h()(function (e) {
      e.styles;
      var t = Kt()(e, Zt);
      return r().createElement("svg", Jt()({
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 128",
        fill: "#efedfd"
      }, t), r().createElement("path", {
        d: "M8 0h8v128H8a8 8 0 01-8-8V8a8 8 0 018-8z"
      }));
    })(dn || (dn = Wt(["\n  height: 100%;\n"], ["\n  height: 100%;\n"]))),
    tn = h()(function (e) {
      e.styles;
      var t = Kt()(e, qt);
      return r().createElement("svg", Jt()({
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 124 128",
        fill: "#efedfd"
      }, t), r().createElement("g", {
        "data-name": "Layer 2"
      }, r().createElement("g", {
        "data-name": "Layer 1-2"
      }, r().createElement("path", {
        d: "M14 0a8 8 0 0016 0h86a8 8 0 018 8v112a8 8 0 01-8 8H30a8 8 0 00-16 0H0V0zm8 115a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-7a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-7a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1zm0-6a1 1 0 101 1 1 1 0 00-1-1z",
        "data-name": "voucher right"
      }))));
    })(mn || (mn = Wt(["\n  height: 100%;\n  width: 124px;\n"], ["\n  height: 100%;\n  width: 124px;\n"]))),
    nn = h().div(En || (En = Wt(["\n  min-width: 100px;\n  flex-wrap: nowrap;\n  flex: 1 1 auto;\n  margin-left: -1px;\n  display: flex;\n  align-items: center;\n"], ["\n  min-width: 100px;\n  flex-wrap: nowrap;\n  flex: 1 1 auto;\n  margin-left: -1px;\n  display: flex;\n  align-items: center;\n"]))),
    rn = h()(y.Text)(gn || (gn = Wt(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      return "link" !== e.type ? "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  \n  " : "\n  word-break: keep-all;\n  ";
    }),
    ln = h()(y.Text)(fn || (fn = Wt([""], [""]))),
    An = h().div(pn || (pn = Wt(["\n  position: relative;\n  display: flex;\n  height: 128px;\n\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  height: 128px;\n\n  ", "\n\n  ", "\n"])), function (e) {
      var t = e.type;
      return t === $t ? "\n      ".concat(rn, " {\n        opacity: 0.65;\n        color: #222222;\n      }\n      ").concat(ln, " {\n        opacity: 0.65;\n        color: #222222;\n      }\n      \n      ") : t === _t ? "\n      ".concat(rn, " {\n        color: white;\n      }\n      ").concat(ln, " {\n        color: white;\n      }\n    ") : "".concat(ln, " {\n        color: #5c50bb;\n      }\n      ");
    }, function (e) {
      var t = e.color;
      return "\n      ".concat(en, " {\n        fill: ").concat(t, ";\n      }\n      ").concat(nn, " {\n        background-color: ").concat(t, ";\n      }\n      ").concat(tn, " {\n        fill: ").concat(t, ";\n      }\n    ");
    }),
    on = h().div(vn || (vn = Wt(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"]))),
    an = h().div(wn || (wn = Wt(["\n  position: relative;\n"], ["\n  position: relative;\n"]))),
    cn = h().div(hn || (hn = Wt(["\n  position: relative;\n  margin-left: -1px;\n  text-align: center;\n  cursor: pointer;\n"], ["\n  position: relative;\n  margin-left: -1px;\n  text-align: center;\n  cursor: pointer;\n"]))),
    un = h().div(Cn || (Cn = Wt(["\n  position: absolute;\n  color: red;\n  left: 65%;\n  top: 50%;\n  transform: translate(-60%, -50%);\n"], ["\n  position: absolute;\n  color: red;\n  left: 65%;\n  top: 50%;\n  transform: translate(-60%, -50%);\n"])));
  var sn = function sn(e) {
    var t,
      l = e.id,
      A = e.name,
      o = e.price,
      a = e.expiryDate,
      i = e.selected,
      c = void 0 !== i && i,
      u = e.disabled,
      s = void 0 !== u && u,
      d = e.onChange,
      m = (0, n.useState)(""),
      E = m[0],
      g = m[1],
      f = (0, n.useState)(""),
      p = f[0],
      w = f[1],
      h = (0, y.useTheme)().theme,
      C = {
        DEFAULT: h.cl_sec_l2,
        SELECTED: "#108668",
        DISABLED: h.cl_ter_l5
      };
    return (0, n.useEffect)(function () {
      c ? (w(C.SELECTED), g(_t)) : s ? (w(C.DISABLED), g($t)) : (w(C.DEFAULT), g("DEFAULT"));
    }, [c, s]), r().createElement(An, {
      color: p,
      type: E,
      "data-testid": "voucher-section"
    }, r().createElement(an, null, r().createElement(en, null)), r().createElement(nn, null, r().createElement(on, null, r().createElement(rn, {
      type: "boldBody"
    }, A), r().createElement(ln, {
      type: "sectionTitle"
    }, v("VOUCHER_AMOUNT_OFF", {
      amount: ie(o, 0)
    })), r().createElement(rn, {
      type: "smallBody"
    }, v("VOUCHER_EXPIRY_DATE", {
      date: Ut()(a).format("DD MMM YYYY")
    })))), r().createElement(cn, {
      "data-testid": "voucher-action",
      onClick: function onClick() {
        s || d(l);
      }
    }, r().createElement(un, null, (t = v(c ? "VOUCHER_REMOVE" : s ? "VOUCHER_NOT_AVAILABLE" : "VOUCHER_APPLY"), r().createElement(rn, {
      type: "link"
    }, t))), r().createElement(tn, null)));
  };
  var dn,
    mn,
    En,
    gn,
    fn,
    pn,
    vn,
    wn,
    hn,
    Cn,
    Bn,
    yn,
    _xn = function xn() {
      return _xn = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _xn.apply(this, arguments);
    },
    In = (0, y.withTheme)(h()(y.Text)(Tn || (Bn = ["\n  color: ", ";\n"], yn = ["\n  color: ", ";\n"], Object.defineProperty ? Object.defineProperty(Bn, "raw", {
      value: yn
    }) : Bn.raw = yn, Tn = Bn), function (e) {
      return e.coreTheme.cl_ter_l3;
    })),
    bn = function bn(e) {
      var t = e.url,
        n = e.target,
        l = void 0 === n ? "_blank" : n;
      return t ? r().createElement(y.TextLink, {
        "data-testid": "voucher-link",
        href: t,
        target: l
      }, v("VOUCHER_TEXT_LINK")) : null;
    };
  var On = function On(e) {
    var t = e.data,
      l = t.dataSource,
      A = t.link,
      o = t.addVoucher,
      a = t.removeVoucher,
      i = t.retrieveVoucher,
      c = (0, n.useState)(!1),
      u = c[0],
      s = c[1],
      d = (0, y.useDevice)(),
      m = d.isDesktop,
      E = d.isTV,
      g = m || E,
      f = l.length > 0,
      p = v(f ? "VOUCHER_TITLE" : "VOUCHER_UNAVAILABLE_TITLE"),
      w = function w(e) {
        l.find(function (t) {
          return t.id === e;
        }).selected ? a(e) : o(e);
      },
      h = function h(e) {
        return r().createElement(T, {
          key: e.id,
          bottom: 1
        }, r().createElement(sn, _xn({
          onChange: w
        }, e)));
      },
      C = v("VOUCHER_MESSAGE");
    return 1 === l.length ? r().createElement("div", null, h(l[0]), r().createElement(bn, _xn({}, A))) : r().createElement(r().Fragment, null, r().createElement("div", {
      "data-testid": "voucher-group",
      onClick: function onClick() {
        i ? i() : s(!0);
      }
    }, r().createElement(y.ListItem, {
      body: [{
        title: function () {
          var e = null == l ? void 0 : l.reduce(function (e, t) {
              return t.selected ? e + 1 : e;
            }, 0),
            t = "";
          switch (!0) {
            case "function" == typeof i:
              t = v("VOUCHER_GET_VOUCHER");
              break;
            case !f:
              t = v("VOUCHER_UNAVAILABLE");
              break;
            case e > 0:
              t = v("VOUCHER_NUMBER_HAVE_APPLIED", {
                count: e
              });
              break;
            case f:
              t = v("VOUCHER_NUMBER", {
                count: l.length
              });
          }
          return t;
        }()
      }],
      leftContent: r().createElement(y.ListItem.Icon, {
        icon: ce.Voucher
      })
    })), r().createElement(y.Modal, {
      wide: g,
      visible: u,
      title: p,
      onClose: function onClose() {
        return s(!1);
      }
    }, r().createElement(y.Modal.Content, null, f && C && r().createElement(y.Row, {
      "data-testid": "voucher-notification"
    }, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.StatusAlert, {
      type: "info",
      bodyContent: C
    }))), !f && r().createElement(y.Text, {
      type: "body"
    }, v("VOUCHER_YOU_HAVE_NO_VOUCHER")), r().createElement(y.Row, null, l.map(function (e, t) {
      return r().createElement(y.Column, {
        xs: 12,
        md: g ? 6 : 12,
        key: t
      }, h(e));
    })), A && r().createElement(y.Row, null, r().createElement(y.Column, null, r().createElement(bn, _xn({}, A)))))));
  };
  var Tn,
    Dn = h().div(Rn || (Rn = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  padding: 0 16px 0 0;\n"], ["\n  padding: 0 16px 0 0;\n"])));
  var Sn = function Sn(e) {
    var t = e.brands,
      l = e.modelByBrand,
      A = e.device,
      o = e.onAddItem,
      a = e.onRemoveItem,
      i = e.isTradeInUnAvailable,
      c = void 0 !== i && i,
      u = e.onTncClicked,
      s = (0, n.useState)(!1),
      d = s[0],
      m = s[1],
      E = !1,
      g = null;
    return A ? (E = !0, g = [{
      title: v("TRADE_IN_PRICE", {
        price: ie(A.tradeinPrice, 0)
      })
    }, {
      subTitle: A.model
    }]) : g = [{
      title: v(c ? "TRADE_IN_UNAVAILABLE_PHRASE" : "TRADE_IN_PHRASE")
    }], r().createElement("div", {
      "data-testid": "trade-in"
    }, r().createElement(T, {
      bottom: 1,
      onClick: function onClick() {
        A || m(!0);
      }
    }, r().createElement(y.ListItem, {
      body: g,
      leftContent: r().createElement(y.ListItem.Icon, {
        icon: ce.Mobilephone
      }),
      rightContent: E ? r().createElement(Dn, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, r().createElement(y.TextLink, {
        onClick: a
      }, v("TRADE_IN_BUTTON_REMOVE"))) : null
    }), c ? null : r().createElement(T, {
      top: 2,
      bottom: 2
    }, r().createElement(In, {
      type: "smallBody"
    }, v("TRADE_IN_MESSAGE")))), c ? r().createElement(y.Modal, {
      onClose: function onClose() {
        return m(!1);
      },
      title: v("TRADE_IN_UNAVAILABLE_PHRASE"),
      visible: d
    }, r().createElement(y.Modal.Content, null, r().createElement(y.Text, {
      type: "body"
    }, v("TRADE_IN_MESSAGE")))) : A ? null : r().createElement(Gt, {
      visible: d,
      brands: t,
      modelByBrand: l,
      onClose: function onClose() {
        return m(!1);
      },
      onSubmit: o,
      onTncClicked: u
    }));
  };
  var Rn;
  var kn = require("react-loading-overlay");
  var Ln = e.n(kn),
    _Pn = function Pn() {
      return _Pn = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Pn.apply(this, arguments);
    };
  var Mn = function Mn(e) {
    return r().createElement(Ln(), {
      styles: {
        wrapper: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          zIndex: 2e3
        },
        overlay: function overlay(e) {
          return _Pn(_Pn({}, e), {
            background: "rgba(255, 255, 255, 0.6)"
          });
        },
        spinner: function spinner(e) {
          return _Pn(_Pn({}, e), {
            "& svg circle": {
              stroke: "red"
            }
          });
        }
      },
      active: !0,
      spinner: !0
    });
  };
  var Qn = h().div(Hn || (Hn = function (e, t) {
    return Object.defineProperty ? Object.defineProperty(e, "raw", {
      value: t
    }) : e.raw = t, e;
  }(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", " ", ";\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", " ", ";\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n"])), x(3), x(2));
  var Nn = function Nn(e) {
    var t = e.data,
      n = void 0 === t ? {} : t,
      l = e.children,
      A = n || {},
      o = A.payTotalAmount,
      a = A.beforeDiscountAmount,
      i = A.saveAmount;
    return r().createElement(Qn, null, r().createElement(y.Column, null, i ? r().createElement(y.Ribbon.Variant1, {
      color: "primary"
    }, v("CART_TOTAL_SAVE", {
      amount: "".concat(ie(i))
    })) : r().createElement(y.Text, {
      type: "smallBody"
    }, v("CART_YOU_WILL_PAY")), r().createElement(y.Row, null, a ? r().createElement(Qe, {
      style: {
        marginRight: "8px"
      }
    }, ie(a)) : null, r().createElement(y.Text, {
      type: "header"
    }, ie(o)))), r().createElement(y.Column, {
      style: {
        textAlign: "right"
      }
    }, l));
  };
  var Hn,
    Fn = function Fn(e) {
      var t = e.promoCodeResult,
        l = void 0 === t ? {} : t,
        A = e.applyPromo,
        o = (0, y.useTheme)(),
        a = l || {},
        i = a.appliedPromoCode,
        c = a.disabled,
        u = void 0 !== c && c,
        s = a.isSuccess,
        d = (0, n.useState)(null),
        m = d[0],
        E = d[1],
        g = (0, n.useState)(-1),
        f = g[0],
        p = g[1],
        w = (0, n.useState)(!1),
        h = w[0],
        C = w[1],
        B = (0, n.useState)(""),
        x = B[0],
        I = B[1],
        b = (0, n.useState)(!1),
        O = b[0],
        T = b[1],
        D = (0, n.useState)(i),
        S = D[0],
        R = D[1],
        k = (0, n.useRef)(""),
        L = (0, n.useRef)(""),
        P = (0, n.useRef)(!1);
      (0, n.useEffect)(function () {
        if (s) {
          E(r().createElement(ce.Completed, {
            size: 24
          }));
          var e = setTimeout(function () {
            E({
              text: v("REMOVE_TEXT")
            });
          }, 3e3);
          return function () {
            clearTimeout(e);
          };
        }
        E({
          text: v("ADD_TEXT")
        });
      }, [s]), (0, n.useEffect)(function () {
        var e = l || {},
          t = e.appliedPromoCode,
          n = e.isLoading,
          r = void 0 !== n && n,
          A = e.isSuccess,
          o = void 0 !== A && A,
          a = e.errorMessage,
          i = void 0 === a ? "" : a,
          c = e.keepPromoOpen,
          u = void 0 !== c && c,
          s = e.promoText,
          d = void 0 === s ? "" : s,
          m = "EMPTY" !== t ? t : "";
        T(r), r || (C(!!i), I(i), R(m)), L.current = m, P.current = o, k.current = d, u && p(0);
      }, [l]);
      var M = function M() {
          T(!1), C(!1), I("");
        },
        Q = (0, n.isValidElement)(m),
        N = !s && u;
      return r().createElement(r().Fragment, null, r().createElement(y.Accordion, {
        title: r().createElement(r().Fragment, null, r().createElement(y.Layout.Inline, {
          alignY: "center"
        }, r().createElement(ce.Discount, {
          size: 22,
          color: o.cl_sec_d1
        }), r().createElement(y.Text, {
          type: "body"
        }, r().createElement(y.Text, {
          fontWeight: "bold"
        }, v("GOT_PROMO"))))),
        desc: r().createElement(r().Fragment, null, r().createElement(Me, {
          disabled: u
        }, r().createElement(y.TextInput, {
          value: S,
          bgColor: "haze",
          placeholder: v("PROMO_CODE_PLACEHOLDER"),
          label: v("PROMO_CODE_PLACEHOLDER"),
          error: h,
          hintMessage: x,
          loading: O,
          suffix: Q && m,
          rightTextLink: !N && {
            text: null == m ? void 0 : m.text,
            onClick: function onClick() {
              M(), A(s ? "CLEAR" : S);
            }
          },
          onChange: function onChange(e) {
            R((e.target.value + "").trim()), M();
          },
          disabled: s || u
        })), k.current && (u ? r().createElement(y.Spacing, {
          type: "margin",
          top: .5
        }, r().createElement(Pe, {
          error: !0,
          type: "smallBody"
        }, k.current)) : r().createElement(y.Spacing, {
          topBottom: 1
        }, r().createElement(Pe, {
          type: "smallBody"
        }, k.current)))),
        selected: 0 === f,
        value: 0,
        onClick: function onClick(e, t) {
          p(f === t ? -1 : t);
        },
        dividerNeeded: !1
      }));
    };
  var Xn = Fn;
  var Vn = (0, y.withTheme)(h()(y.Text)(zn || (zn = function (e, t) {
    return Object.defineProperty ? Object.defineProperty(e, "raw", {
      value: t
    }) : e.raw = t, e;
  }(["\n  text-decoration: line-through;\n  color: ", ";\n"], ["\n  text-decoration: line-through;\n  color: ", ";\n"])), function (e) {
    return e.coreTheme.cl_ter_l3;
  }));
  var Gn = function Gn(e) {
    var t = e.total,
      l = e.upFrontCosts,
      A = e.promoDetails,
      o = (0, n.useState)(),
      a = o[0],
      i = o[1],
      c = t || {},
      u = c.payTotalAmount,
      s = void 0 === u ? 0 : u,
      d = c.beforeDiscountAmount,
      m = void 0 === d ? 0 : d;
    return (0, n.useEffect)(function () {
      var e = null == l ? void 0 : l.find(function (e) {
        return "Standard Delivery" === e.name;
      });
      i(e);
    }, [l]), r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      top: 2
    }, r().createElement("div", {
      "data-testid": "total-promo-section"
    }, a && r().createElement(r().Fragment, null, r().createElement(y.Row, {
      between: "xs"
    }, r().createElement(y.Text, {
      type: "body"
    }, v("ORDER_TOTAL_DELIVERY_FEE")), r().createElement(y.Text, {
      type: "body"
    }, ie(a.price)))), (null == A ? void 0 : A.promoCode) && r().createElement(r().Fragment, null, r().createElement(y.Row, {
      between: "xs"
    }, r().createElement(y.Text, {
      type: "body"
    }, "".concat(v("ORDER_TOTAL_PROMO_DISCOUNT"), " ").concat(A.promoCode)), r().createElement(y.Text, {
      type: "body"
    }, ie(A.price)))), r().createElement(y.Row, {
      between: "xs"
    }, r().createElement(y.Text, {
      type: "boldBody"
    }, v("ORDER_TOTAL")), r().createElement(y.Text, {
      type: "boldBody"
    }, ie(s))), r().createElement(y.Row, {
      between: "xs"
    }, r().createElement(y.Text, {
      type: "body"
    }, ""), m > 0 && r().createElement(Vn, {
      type: "body"
    }, ie(m)))), r().createElement(y.Spacing, {
      top: 2,
      bottom: 2
    }, r().createElement(y.Divider, null))));
  };
  var zn,
    Un = function Un(e) {
      var t = e.outOfStockItem;
      return r().createElement(y.StatusAlert, {
        icon: "alert",
        type: "alert",
        title: v("OUT_OF_STOCK_MESSAGE"),
        bodyContent: r().createElement(r().Fragment, null, t.dataSource.map(function (e, t) {
          return r().createElement(y.BulletList, {
            size: "small",
            key: t
          }, e.name);
        }))
      });
    },
    jn = function jn(e) {
      var t,
        n,
        l = (0, y.useTheme)().theme,
        A = e.data || {},
        o = A.title,
        a = A.subTittle,
        i = A.customLiner,
        c = A.hintMessage,
        u = A.status,
        s = A.isApplied,
        d = A.imei,
        m = e.onClick,
        E = void 0 === m ? function () {} : m;
      if (!e.data) return null;
      var g = "error" === u,
        f = "loading" === u,
        p = !f && s || "success" === u,
        w = p ? "success" : f ? "inProgress" : "";
      return r().createElement("div", {
        "data-testid": "bib-trade-in"
      }, r().createElement(Mt, {
        responseive: !1,
        topBottom: 2,
        leftRight: 2
      }, r().createElement(y.Spacing, {
        responsive: !1,
        bottom: 1
      }, r().createElement(y.Text, {
        type: "boldBody"
      }, o), r().createElement(y.Text, {
        type: "boldBody"
      }, a)), i && r().createElement(y.Spacing, {
        bottom: 2,
        responsive: !1
      }, r().createElement(y.Text, {
        type: "smallBody"
      }, i)), r().createElement("div", {
        onClick: function onClick() {
          E(d);
        }
      }, r().createElement(y.Button, {
        secondary: !0,
        "data-testid": "bibButton",
        fullWidth: !0,
        loading: w
      }, v("ADD"))), r().createElement(y.Spacing, {
        top: 1,
        responsive: !1
      }, r().createElement(y.Text, {
        color: g ? null === (n = null === (t = l.color) || void 0 === t ? void 0 : t.text) || void 0 === n ? void 0 : n.alert : null,
        type: "smallBody"
      }, (p || g) && c))));
    };
  var Jn = JSON.parse('{"nm":"39 - Okay","ddd":0,"h":500,"w":500,"meta":{"g":"@lottiefiles/toolkit-js 0.33.2"},"layers":[{"ty":3,"nm":"Main Stroke width - Color Ctrl","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":0,"ix":11}},"ef":[{"ty":5,"mn":"ADBE Slider Control","nm":"Stroke width","ix":1,"en":1,"ef":[{"ty":0,"mn":"ADBE Slider Control-0001","nm":"Slider","ix":1,"v":{"a":0,"k":16,"ix":1}}]},{"ty":5,"mn":"ADBE Color Control","nm":"HIghlight","ix":2,"en":1,"ef":[{"ty":2,"mn":"ADBE Color Control-0001","nm":"Color","ix":1,"v":{"a":0,"k":[1,1,1],"ix":1}}]},{"ty":5,"mn":"ADBE Color Control","nm":"Base Color","ix":3,"en":1,"ef":[{"ty":2,"mn":"ADBE Color Control-0001","nm":"Color","ix":1,"v":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":1}}]}],"ind":1,"parent":12},{"ty":4,"nm":"Bracelet","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[28.5,181,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[27.5,184,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-69,181],[126,181]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":16,"ix":5},"c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'Base Color\')(\'Color\');"}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2,"parent":5},{"ty":4,"nm":"Highlight","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.88,"y":1},"s":[50,78,0],"t":30,"ti":[0,11.167,0],"to":[0,-4.667,0]},{"o":{"x":0.12,"y":0},"i":{"x":0.91,"y":1},"s":[50,50,0],"t":38.947,"ti":[0,6.5,0],"to":[0,-11.167,0]},{"s":[50,11,0],"t":47}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.196,"y":0.196},"i":{"x":0.886,"y":1},"s":[0],"t":30},{"o":{"x":0.12,"y":0},"i":{"x":0.91,"y":1},"s":[100],"t":38.947},{"s":[12],"t":47}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[24.853,0],[0,24.853],[-24.853,0],[0,-24.853]],"o":[[24.853,0],[0,24.853],[-24.853,0],[0,-24.853]],"v":[[-175.002,-113],[-130.002,-158],[-85.002,-113],[-130.002,-68]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":16,"ix":5,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'Stroke width\')(\'Slider\');"},"c":{"a":0,"k":[0.9608,0.9608,0.9725],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'HIghlight\')(\'Color\');"}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":3,"parent":1},{"ty":4,"nm":"Bracelet mask","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"td":1,"ao":0,"ks":{"a":{"a":0,"k":[28.5,181,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[27.5,184,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[126,181],[-69,181],[-69,246],[131,246]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":3}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":4,"parent":5},{"ty":4,"nm":"Hand base","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"tt":2,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[24,166,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[74,216,0],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[0],"t":6},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[-22.487],"t":14},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[15.849],"t":19},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[-13.517],"t":26},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[4.135],"t":32.667},{"s":[0],"t":38}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":1,"k":[{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[{"c":true,"i":[[4.929,4.565],[0,0],[7.607,-1.755],[0,0],[0,0],[3.372,-6.743],[0,0],[-3.672,0],[-4.28,8.56],[0,0],[0,0],[0,-12.215],[0,0],[26.983,-0.045],[36.644,0],[0,0],[-24.429,-30.537],[-36.644,-43.445],[0,0],[0,0]],"o":[[0,0],[-5.899,-5.112],[0,0],[0,0],[-7.393,1.478],[0,0],[0,0],[8.96,0],[0,0],[0,0],[0,0],[0,1.527],[0,24.429],[-42.684,0.072],[-22.712,0],[0,0],[29.825,37.282],[0,0],[0,0],[0.768,-6.674]],"v":[[120.583,18.075],[15.933,-79.545],[-5.559,-84.888],[-4.787,-85.04],[-84.182,-66.718],[-101.242,-53.688],[-128.249,6.096],[-97.713,18.31],[-75.862,4.806],[-62.884,-21.151],[-6.677,-30.685],[30.473,18.241],[30.473,24.348],[-12.278,73.204],[-97.713,18.31],[-128.249,42.74],[-91.606,91.598],[-37.855,201.803],[109.935,201.902],[128.149,38.509]]}],"t":6},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[{"c":true,"i":[[4.929,4.565],[0,0],[7.464,2.286],[0,0],[0,0],[6.293,-4.152],[0,0],[-3.179,-1.837],[-7.989,5.27],[0,0],[0,0],[0,-12.215],[0,0],[26.983,-0.045],[36.644,0],[0,0],[-24.429,-30.537],[-36.644,-43.445],[0,0],[0,0]],"o":[[0,0],[-2.55,-7.378],[0,0],[0,0],[-7.141,-2.419],[0,0],[0,0],[7.758,4.483],[0,0],[0,0],[0,0],[0,1.527],[0,24.429],[-42.684,0.072],[-22.712,0],[0,0],[29.825,37.282],[0,0],[0,0],[0.768,-6.674]],"v":[[120.583,18.075],[60.926,-54.464],[44.99,-69.843],[45.734,-69.588],[-32.176,-93.446],[-53.467,-90.698],[-106.761,-52.447],[-86.432,-26.594],[-60.757,-27.354],[-36.533,-43.336],[16.903,-23.47],[30.473,18.241],[30.473,24.348],[-12.278,73.204],[-97.713,18.31],[-128.249,42.74],[-91.606,91.598],[-35.839,204.116],[102.892,206.692],[128.149,38.509]]}],"t":19},{"s":[{"c":true,"i":[[4.929,4.565],[0,0],[7.607,-1.755],[0,0],[0,0],[3.372,-6.743],[0,0],[-3.672,0],[-4.28,8.56],[0,0],[0,0],[0,-12.215],[0,0],[26.983,-0.045],[36.644,0],[0,0],[-24.429,-30.537],[-36.644,-43.445],[0,0],[0,0]],"o":[[0,0],[-5.899,-5.112],[0,0],[0,0],[-7.393,1.478],[0,0],[0,0],[8.96,0],[0,0],[0,0],[0,0],[0,1.527],[0,24.429],[-42.684,0.072],[-22.712,0],[0,0],[29.825,37.282],[0,0],[0,0],[0.768,-6.674]],"v":[[120.583,18.075],[15.933,-79.545],[-5.559,-84.888],[-4.787,-85.04],[-84.182,-66.718],[-101.242,-53.688],[-128.249,6.096],[-97.713,18.31],[-75.862,4.806],[-62.884,-21.151],[-6.677,-30.685],[30.473,18.241],[30.473,24.348],[-12.278,73.204],[-97.713,18.31],[-128.249,42.74],[-91.606,91.598],[-37.855,201.803],[109.935,201.902],[128.149,38.509]]}],"t":26}],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":16,"ix":5},"c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'Base Color\')(\'Color\');"}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":5,"parent":1},{"ty":4,"nm":"Hand base fill","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[256,256,0],"ix":1},"s":{"a":0,"k":[75,75,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.94,0],[0,0],[0,0],[-9.84,1.969],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-5.7,11.4],[-4.89,0],[0,0],[4.49,-8.98],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.084,178.938],[-65.084,178.889],[-122.023,55.948],[-170.833,-9.122],[-130.164,-41.662],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[-8.913,-106.912],[-83.773,-94.212],[-101.064,-59.642],[-130.164,-41.662],[-170.833,-57.922],[-134.863,-137.552],[-112.143,-154.901],[-13.137,-178.938],[33.62,-163.085],[155.367,-51.451]]}],"t":6},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.854,1.01],[0,0],[0,0],[-9.84,1.969],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-5.7,11.4],[-8.267,-0.999],[0,0],[4.49,-8.98],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.084,178.938],[-65.084,178.889],[-122.023,55.948],[-170.833,-9.122],[-127.753,-41.386],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[1.633,-103.629],[-75.898,-100.166],[-97.828,-68.509],[-123.43,-53.725],[-165.453,-74.629],[-123.238,-147.926],[-105.634,-162.12],[18.153,-175.457],[31.893,-167.641],[155.367,-51.451]]}],"t":10},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.768,2.019],[0,0],[0,0],[-9.84,1.969],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-5.7,11.4],[-11.644,-1.998],[0,0],[4.49,-8.98],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.084,178.938],[-65.084,178.889],[-122.023,55.948],[-170.833,-9.122],[-125.342,-41.109],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[12.179,-100.345],[-57.049,-113.453],[-87.549,-92.289],[-116.712,-79.386],[-151.73,-112.787],[-94.627,-168.517],[-72.205,-181.66],[42.132,-162.553],[57.644,-153.141],[155.367,-51.451]]}],"t":14},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.39,3.582],[0,0],[0,0],[-8.97,-3.089],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-12.024,11.17],[-17.927,-5.638],[0,0],[6.935,-7.452],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.084,178.938],[-65.084,178.889],[-122.023,55.948],[-170.833,-9.122],[-125.342,-41.109],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[23.342,-95.199],[-50.255,-123.698],[-78.19,-103.262],[-112.65,-99.25],[-139.876,-136.942],[-70.969,-187.708],[-42.887,-190.677],[69.408,-154.357],[83.715,-136.98],[165.145,-38.98]]}],"t":19},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.547,2.559],[0,0],[0,0],[-9.219,-1.644],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-10.217,11.236],[-14.202,-4.027],[0,0],[6.237,-7.889],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.084,178.938],[-65.084,178.889],[-122.023,55.948],[-170.833,-9.122],[-126.719,-41.267],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[14.126,-98.545],[-59.832,-115.274],[-82.054,-98.1],[-112.462,-89.877],[-145.669,-126.314],[-89.225,-173.378],[-57.787,-186.824],[45.415,-162.251],[66.064,-151.869],[162.351,-42.543]]}],"t":21},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.783,1.024],[0,0],[0,0],[-9.591,0.524],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-7.507,11.334],[-8.615,-1.611],[0,0],[5.189,-8.544],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.083,178.938],[-65.083,178.889],[-122.023,55.948],[-170.833,-9.122],[-128.786,-41.504],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[0.302,-103.565],[-74.197,-102.637],[-94.528,-72.105],[-125.786,-49.446],[-165.45,-70.907],[-116.608,-151.882],[-92.356,-165.123],[9.426,-174.091],[30.397,-169.044],[158.161,-47.888]]}],"t":24},{"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[39.72,49.66],[0,0],[-30.25,0],[-56.85,0.09],[0,32.529],[0,0],[0,0],[0,0],[0,0],[11.94,0],[0,0],[0,0],[-9.84,1.969],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-48.81,-57.861],[-32.54,-40.67],[0,0],[48.81,0],[35.94,-0.06],[0,0],[0,-16.27],[0,0],[0,0],[-5.7,11.4],[-4.89,0],[0,0],[4.49,-8.98],[0,0],[0,0],[0,0],[0,0]],"v":[[170.833,-17.501],[146.406,178.889],[146.406,178.938],[-65.083,178.938],[-65.083,178.889],[-122.023,55.948],[-170.833,-9.122],[-130.164,-41.662],[-16.374,31.458],[40.566,-33.611],[40.566,-41.752],[-8.913,-106.912],[-83.773,-94.212],[-101.064,-59.642],[-130.164,-41.662],[-170.833,-57.922],[-134.863,-137.552],[-112.143,-154.901],[-13.137,-178.938],[33.62,-163.085],[155.367,-51.451]]}],"t":26}],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,1,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[256.013,322.062],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":6,"parent":5},{"ty":4,"nm":"Finger 1","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[92.001,15.237,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[92.001,15.237,0],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[0],"t":6},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[12],"t":16},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[-8],"t":29.9},{"s":[0],"t":36.400390625}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[-2.888,-3.789],[106.334,138.155],[10.692,-8.229],[-8.229,-10.692],[0,0]],"o":[[0.061,-0.047],[-8.229,-10.692],[-10.692,8.229],[0,0],[0,0]],"v":[[128.001,19.285],[-4.882,-155.137],[-39.141,-159.596],[-43.6,-125.337],[84.027,42.237]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":16,"ix":5},"c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'Base Color\')(\'Color\');"}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":7,"parent":5},{"ty":4,"nm":"Finger 1 fill","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[256,256,0],"ix":1},"s":{"a":0,"k":[75,75,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[127.12,164.61],[14.222,-10.983],[-10.983,-14.222],[0,0]],"o":[[-0.882,-1.24],[-10.984,-14.222],[-14.223,10.983],[0,0],[0,0]],"v":[[100.811,72.311],[-38.319,-107.851],[-83.962,-113.716],[-89.828,-68.073],[58.509,124.699]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9608,0.9608,0.9725],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[287.536,156.879],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":8,"parent":7},{"ty":4,"nm":"Finger 2","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100.082,23.637,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100.082,23.637,0],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[0],"t":6},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[12],"t":18},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[-4],"t":27.3},{"s":[0],"t":37.7001953125}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[-1.462,-4.534],[54.284,165.672],[12.821,-4.201],[-4.201,-12.821],[0,0]],"o":[[0.073,-0.024],[-4.201,-12.821],[-12.821,4.201],[0,0],[0,0]],"v":[[126.809,20.161],[66.005,-167.065],[35.184,-182.673],[19.575,-151.852],[80.703,35.168]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":16,"ix":5},"c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'Base Color\')(\'Color\');"}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":9,"parent":5},{"ty":4,"nm":"Finger 2 fill","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[256,256,0],"ix":1},"s":{"a":0,"k":[75,75,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 2","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[63.563,198.029],[17.11,-5.492],[-5.492,-17.111],[0,0]],"o":[[-0.407,-1.466],[-5.492,-17.11],[-17.111,5.492],[0,0],[0,0]],"v":[[68.513,104.195],[-1.055,-112.544],[-41.982,-133.582],[-63.021,-92.654],[10.916,139.074]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9608,0.9608,0.9725],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[345.447,145.261],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":10,"parent":9},{"ty":4,"nm":"Finger 3","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[103.841,36.637,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[103.841,36.637,0],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.58,"y":1},"s":[6.217],"t":6},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[12],"t":19},{"o":{"x":0.42,"y":0},"i":{"x":0.58,"y":1},"s":[2],"t":26},{"s":[6.217],"t":39}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[0.36,134.809],[13.492,0],[0,-13.492],[0,0]],"o":[[0,0],[-0.036,-13.492],[-13.492,0],[0,0],[0,0]],"v":[[128.245,36.632],[128.257,-134.372],[103.828,-158.802],[79.399,-134.372],[79.399,28]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":16,"ix":5},"c":{"a":0,"k":[0.2314,0.2314,0.2314],"ix":3,"x":"var $bm_rt;\\n$bm_rt = thisComp.layer(\'Main Stroke width - Color Ctrl\').effect(\'Base Color\')(\'Color\');"}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":11,"parent":5},{"ty":3,"nm":"Zero | troke width - Color Ctrl","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":0,"ix":11}},"ef":[],"ind":12},{"ty":4,"nm":"Finger 3 fill","sr":1,"st":0,"op":50,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[386.086,165.067,0],"ix":1},"s":{"a":0,"k":[75,75,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[98.297,-66.506,0],"ix":2},"r":{"a":0,"k":0.783,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 3","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,207.98],[17.97,0],[0,-17.97],[0,0]],"o":[[0.06,-1.52],[0,-17.97],[-17.97,0],[0,0],[0,0]],"v":[[32.51,130.085],[32.51,-97.545],[-0.03,-130.085],[-32.57,-97.545],[-32.57,110.705]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9608,0.9608,0.9725],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[394.31,174.595],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":13,"parent":11}],"v":"5.9.0","fr":25,"op":50,"ip":0,"assets":[]}'),
    Yn = require("lottie-react");
  var Kn = e.n(Yn),
    Zn = function Zn(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _qn = function qn() {
      return _qn = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _qn.apply(this, arguments);
    },
    Wn = h().div(lr || (lr = Zn(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 8px;\n  padding-top: 6px;\n  padding-bottom: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 8px;\n  padding-top: 6px;\n  padding-bottom: 12px;\n"]))),
    _n = h()(function (e) {
      return r().createElement(B(), _qn({}, e));
    })(Ar || (Ar = Zn(["\n  position: relative;\n  background-color: white;\n  z-index: 9;\n"], ["\n  position: relative;\n  background-color: white;\n  z-index: 9;\n"]))),
    $n = h()(function (e) {
      return r().createElement(y.Row, _qn({}, e));
    })(or || (or = Zn(["\n  margin: 0;\n"], ["\n  margin: 0;\n"]))),
    er = h()(function (e) {
      return r().createElement(y.Column, _qn({}, e));
    })(ar || (ar = Zn(["\n  padding: 0;\n"], ["\n  padding: 0;\n"]))),
    tr = {
      DESKTOP: {
        xs: !1,
        sm: !1,
        md: !0,
        lg: !0
      },
      MOBILE: {
        xs: !0,
        sm: !0,
        md: !1,
        lg: !1
      }
    },
    nr = {
      Completed: ce.Completed,
      Alert: ce.Alert
    },
    rr = function rr(e) {
      var t,
        A,
        o,
        a = e.data,
        i = a.rrp,
        c = a.upfront,
        u = a.sections,
        s = a.monthly,
        d = a.addition,
        m = a.note,
        E = a.checkoutNote,
        g = a.tradeIn,
        f = a.voucher,
        w = a.discount,
        h = a.total,
        C = a.outOfStockItem,
        x = a.notification,
        I = a.bibTradeIn,
        b = a.exceededDiscountAmount,
        O = e.configs,
        D = O.section,
        S = O.deviceOutOfStock,
        R = O.showOutOfStock,
        k = O.showTradeIn,
        L = O.showBibTradeIn,
        P = O.showVoucher,
        M = O.browseAccessories,
        Q = O.loading,
        N = (O.voucherAndTradeInNotAvailable, O.cartError),
        H = O.alert,
        F = O.type,
        X = O.toastIcon,
        V = O.stickyBoundaryElement,
        G = O.styles,
        z = e.callbacks,
        U = z.onChangePhone,
        j = z.onChangePlan,
        J = z.onChangeNumber,
        Y = (z.onAddItem, z.onRemoveItem),
        K = z.onViewAvailableProduct,
        Z = z.onCheckout,
        q = z.onLink,
        W = z.onEmptyCart,
        _ = z.onNotify,
        $ = z.onTradeInTncClicked,
        ee = z.onChangeQuantity,
        te = z.onBibTradeInClicked,
        ne = z.onBorwseAccessories,
        re = z.onVoucherModalClose,
        le = e.localisation;
      p(le);
      var Ae,
        oe = (0, n.useState)(!1),
        ae = oe[0],
        ie = oe[1],
        ue = (0, n.useState)(!!_),
        se = ue[0],
        de = ue[1],
        me = (0, n.useState)(!1),
        Ee = me[0],
        ge = me[1],
        fe = (0, n.useRef)(null),
        pe = (0, y.useWindowSize)(),
        ve = (0, y.useTheme)();
      S && (Ae = null === (A = null === (t = null == c ? void 0 : c.dataSource) || void 0 === t ? void 0 : t.find(function (e) {
        return "device" === e.type;
      })) || void 0 === A ? void 0 : A.name);
      var we = (Array.isArray(m) ? m : [m]).filter(Boolean);
      (0, n.useEffect)(function () {
        ge(null == f ? void 0 : f.error);
      }, [null == f ? void 0 : f.error]), (0, n.useEffect)(function () {
        var e;
        pe.height > (null === (e = null == fe ? void 0 : fe.current) || void 0 === e ? void 0 : e.offsetHeight) ? ie(!0) : ie(!1);
      }, [pe]);
      var he = function he(e) {
          return W ? r().createElement(y.Row, null, r().createElement(er, _qn({}, tr[e]), r().createElement(T, {
            bottom: 4
          }, r().createElement(y.TextLink, {
            onClick: W
          }, r().createElement(y.TextLink.Icon, {
            icon: ce.Trash
          }), r().createElement(y.TextLink.Text, null, v("ACTION_BUTTON_EMPTY_CART")))))) : null;
        },
        Ce = function Ce() {
          return Z ? r().createElement(y.Button, {
            text: v("ACTION_BUTTON_CHECKOUT"),
            fullWidth: !0,
            onClick: Z
          }) : null;
        },
        Be = function Be() {
          return E ? r().createElement(T, {
            top: 1,
            style: {
              textAlign: "center"
            }
          }, r().createElement(y.Text, {
            type: "smallBody",
            color: ve.cl_ter_l2
          }, E)) : null;
        },
        ye = function ye() {
          return q ? r().createElement(T, {
            top: 4,
            style: {
              textAlign: "center"
            }
          }, r().createElement(y.TextLink, {
            onClick: q
          }, v("ACTION_ON_LINK"))) : null;
        },
        xe = function xe() {
          return b ? r().createElement(Le, {
            type: "primary",
            "data-testid": "browse-accessories"
          }, r().createElement(Wn, null, r().createElement(T, null, r().createElement(Kn(), {
            animationData: Jn,
            loop: !0,
            style: {
              height: 68,
              width: 68
            }
          })), r().createElement(T, null, r().createElement(y.Text, {
            type: "boldBody"
          }, v("BROWSE_ACCESSORIES_TEXT", {
            amount: b
          })), r().createElement(y.Text, {
            type: "body"
          }, v("BROWSE_ACCESSORIES_DESC")), r().createElement(y.TextLink, {
            onClick: ne,
            type: "body"
          }, v("BROWSE_ACCESSORIES_LINK"))))) : null;
        };
      return r().createElement(r().Fragment, null, se && r().createElement(y.Toast, {
        "data-testid": "shopping-cart-notifier",
        visible: se,
        autoDismiss: !1,
        text: v("NOTIFY_MESSAGE"),
        icon: nr[X],
        action: {
          text: v("ACTION_BUTTON_DISMISS"),
          onPress: function onPress() {
            de(!1), _();
          }
        }
      }), P && Ee && r().createElement(y.Modal, {
        "data-testid": "voucher-error-modal",
        visible: Ee,
        title: v("VOUCHER_MODAL_ERROR_TITLE"),
        onClose: function onClose() {
          ge(!1), "function" == typeof re && re();
        }
      }, r().createElement(y.Modal.Content, null, v("VOUCHER_MODAL_ERROR_MESSAGE"))), r().createElement($n, null, r().createElement(er, {
        xs: 12,
        sm: 12,
        md: !1,
        lg: !1
      }, r().createElement(T, null, r().createElement(_n, {
        stickyStyle: {
          boxShadow: "0 2px 5px 0 grey",
          backgroundColor: "white"
        }
      }, r().createElement(Nn, {
        data: h
      }, Ce()))))), r().createElement(Je, {
        noBottomSpacing: null == G ? void 0 : G.noBottomSpacing,
        "data-testid": "shopping-cart-section"
      }, Q && r().createElement(Mn, null), r().createElement("div", {
        className: "fs-unmask stickyBoundary"
      }, r().createElement(y.Row, null, r().createElement(y.Column, null, r().createElement(T, {
        bottom: 2
      }, r().createElement(y.Text, {
        type: "pageTitle"
      }, v("PAGE_TITLE_YOUR_CART"))))), r().createElement(y.Row, {
        between: "md"
      }, r().createElement(y.Column, {
        xs: 12,
        md: 7
      }, R && (null === (o = null == C ? void 0 : C.dataSource) || void 0 === o ? void 0 : o.length) ? r().createElement(T, {
        bottom: 4
      }, r().createElement(Un, {
        outOfStockItem: C
      })) : null, !!x && r().createElement("div", {
        "data-testid": "generic-notification"
      }, r().createElement(T, {
        bottom: 4
      }, r().createElement(y.StatusAlert, _qn({}, x)))), S && r().createElement(T, {
        bottom: 4
      }, r().createElement(Le, {
        type: "primary",
        "data-testid": "device-out-of-stock"
      }, r().createElement(T, {
        bottom: 2
      }, r().createElement(y.Text, {
        type: "boldBody"
      }, v("DEVICE_OUT_OF_STOCK", {
        device: Ae
      }))), r().createElement(y.Button, {
        text: v("VIEW_AVAILABLE_OPTIONS"),
        onClick: K
      }))), N && r().createElement(T, {
        bottom: 4
      }, r().createElement(Le, {
        type: "primary",
        "data-testid": "cart-Error"
      }, r().createElement(y.Text, {
        type: "body"
      }, v("ERROR_MESSAGE")))), (null == H ? void 0 : H.visible) && r().createElement(T, {
        bottom: 4
      }, r().createElement(y.StatusAlert, {
        type: null == H ? void 0 : H.type,
        "data-testid": "cart-alert",
        bodyContent: r().createElement(y.Text, {
          type: "body"
        }, v("ALERT_MESSAGE"))
      })), null == i ? void 0 : i.map(function (e, t) {
        var n, A;
        return "RRP_FULLPRICE" === F && (n = v("NO_OF_BAG", {
          number: l(t + 1)
        }), A = e.descriptionContent), r().createElement(bt, {
          key: t,
          border: !1,
          padding: !1,
          data: {
            descriptionTitle: n,
            descriptionContent: A,
            dataSource: e.dataSource,
            totalText: v("UPFRONT_TOTAL")
          },
          discount: e.discount,
          subtotal: e.total,
          onRemoveItem: Y,
          onChangePhone: U,
          onChangeQuantity: ee
        });
      }), !S && c && r().createElement(bt, {
        border: !1,
        padding: !1,
        data: {
          dataSource: c.dataSource,
          totalAmount: c.totalAmount,
          footer: c.footer,
          totalText: v("UPFRONT_TOTAL")
        },
        onRemoveItem: Y,
        onChangePhone: U
      }), (null == u ? void 0 : u.length) && r().createElement("div", {
        "data-testid": "shopping-cart-dynamic-sections"
      }, null == u ? void 0 : u.map(function (e, t) {
        return r().createElement(bt, {
          key: t,
          border: !1,
          padding: !1,
          data: {
            dataSource: e.dataSource,
            descriptionTitle: e.descriptionTitle,
            descriptionContent: e.descriptionContent,
            notification: e.notification,
            totalText: v("UPFRONT_TOTAL")
          },
          sectionConfig: D,
          onRemoveItem: Y,
          onChangePhone: U
        });
      })), he("MOBILE"), r().createElement(y.Row, null, r().createElement(er, _qn({}, tr.MOBILE), L && I && r().createElement(T, {
        bottom: 3
      }, r().createElement(jn, {
        data: I,
        onClick: te
      })), k && g && r().createElement(T, {
        bottom: 3
      }, r().createElement(Sn, {
        isTradeInUnAvailable: null == g ? void 0 : g.tradeInNotAvailable,
        brands: g.brands,
        modelByBrand: g.modelByBrand,
        device: g.device,
        onAddItem: g.onAddTradeIn,
        onRemoveItem: g.onRemoveTradeIn,
        onTncClicked: $
      })), P && f && r().createElement(T, {
        bottom: 2
      }, r().createElement(On, {
        data: f
      })), w && r().createElement(T, {
        bottom: 2
      }, r().createElement(ct, {
        data: w
      })), M && r().createElement(T, {
        bottom: 2
      }, xe()), r().createElement(T, {
        bottom: 2
      }, r().createElement(Ot, {
        data: h
      })), r().createElement(T, {
        bottom: 2,
        type: "margin"
      }, r().createElement(y.Divider, null)))), he("DESKTOP"), s && r().createElement(r().Fragment, null, r().createElement(bt, {
        data: {
          title: v("SECTION_TITLE_MONTHLY_BILL"),
          dataSource: s.dataSource,
          totalAmount: s.totalAmount,
          footer: s.footer,
          totalText: v("MONTHLY_TOTAL")
        },
        onRemoveItem: Y,
        onChangePlan: j,
        onChangeNumber: J
      }), r().createElement(T, {
        top: 5,
        bottom: 5
      }, r().createElement(y.Divider, null))), d && r().createElement(r().Fragment, null, r().createElement(bt, {
        data: {
          title: v("SECTION_TITLE_ADDITION_BILL"),
          description: v("SECTION_DESCRIPTION_ADDITION_BILL"),
          dataSource: d.dataSource,
          totalAmount: d.totalAmount,
          footer: d.footer,
          totalText: v("ADDITION_TOTAL")
        },
        onRemoveItem: Y
      }), (null == G ? void 0 : G.noBottomSpacing) ? null : r().createElement(T, {
        top: 5,
        bottom: 5
      }, r().createElement(y.Divider, null))), we && r().createElement(r().Fragment, null, we.map(function (e, t) {
        return r().createElement(T, {
          bottom: 2,
          key: "note-".concat(t)
        }, r().createElement(y.Text, {
          type: "body"
        }, e));
      }))), r().createElement(y.Column, {
        xs: 12,
        md: 4
      }, r().createElement(y.Row, null, r().createElement(y.Column, _qn({}, tr.DESKTOP), r().createElement(B(), {
        topOffset: 32,
        stickyStyle: {
          transform: "translateY(32px)"
        },
        disabled: !ae,
        hideOnBoundaryHit: !1,
        boundaryElement: V
      }, r().createElement(y.Card, {
        padding: "lg",
        ref: fe
      }, r().createElement(y.Card.Content, null, r().createElement(Ye, null, L && I && r().createElement(jn, {
        data: I,
        onClick: te
      }), k && g && r().createElement(Sn, {
        isTradeInUnAvailable: null == g ? void 0 : g.tradeInNotAvailable,
        brands: g.brands,
        modelByBrand: g.modelByBrand,
        device: g.device,
        onAddItem: g.onAddTradeIn,
        onRemoveItem: g.onRemoveTradeIn,
        onTncClicked: $
      }), P && f && r().createElement(On, {
        data: f
      }), w && r().createElement(ct, {
        data: w
      }), M && xe(), r().createElement(Ot, {
        data: h
      }), Ce(), Be(), ye()))))), r().createElement(er, _qn({}, tr.MOBILE), Ce(), Be(), ye())))))));
    };
  rr.defaultProps = {
    data: {},
    configs: {
      type: "MOBILE",
      loading: !1,
      deviceOutOfStock: !1,
      showTradeIn: !1,
      showVoucher: !1
    },
    callbacks: {
      onChangePhone: function onChangePhone(e) {
        return console.log("changephone", e);
      },
      onChangePlan: function onChangePlan(e) {
        return console.log("changeplan", e);
      },
      onChangeNumber: function onChangeNumber(e) {
        return console.log("changenumber", e);
      },
      onAddItem: function onAddItem(e) {
        return console.log("additem", e);
      },
      onRemoveItem: function onRemoveItem(e) {
        return console.log("removeitem", e);
      },
      onViewAvailableProduct: function onViewAvailableProduct() {
        return console.log("viewavailableproduct");
      },
      onCheckout: function onCheckout() {
        return console.log("checkout");
      },
      onEmptyCart: function onEmptyCart() {
        return console.log("emptycart");
      },
      onNotify: null
    },
    localisation: {}
  };
  var lr,
    Ar,
    or,
    ar,
    _ir = function ir() {
      return _ir = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _ir.apply(this, arguments);
    },
    cr = (0, n.createContext)(null);
  var ur = cr;
  var sr = function sr(e) {
      var t = e.children,
        l = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["children"]),
        A = (0, n.useMemo)(function () {
          return _ir({}, l);
        });
      return r().createElement(cr.Provider, {
        value: A
      }, t);
    },
    dr = function dr(e) {
      switch (e) {
        case "message":
          return ce.Message;
        case "shop":
          return ce.Shop;
        case "delivery":
          return ce.Delivery;
        case "mail":
          return ce.Mail;
        default:
          return null;
      }
    };
  var mr = e.p + "99e9d07e48ef9bc878a7d2a09bc92604.png",
    Er = e.p + "8901b689e9e15443fd26eae656abe7a5.png";
  var gr = ["styles"];
  var fr = function fr(e) {
    e.styles;
    var t = Kt()(e, gr);
    return r().createElement("svg", Jt()({
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("circle", {
      cx: "20",
      cy: "20",
      r: "19",
      stroke: "#3B3B3B",
      strokeWidth: "2"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.392 10.834c.46 0 .834.372.834.833v1.137c1.987.302 3.858 1.68 3.888 3.992a.833.833 0 01-.823.844c-.44.021-.838-.361-.844-.822-.02-1.527-1.51-2.368-2.944-2.41a.7.7 0 01-.229 0l.118-.001c-1.238 0-2.477.09-3.167.752-.594.568-.73 1.515-.319 2.203.536.894 1.733 1.297 2.912 1.632l1.305.36c1.311.395 2.737.968 3.519 2.273.814 1.36.564 3.152-.596 4.263-.793.76-1.867 1.045-2.821 1.151v1.138a.834.834 0 01-1.666 0v-1.077c-2.22-.07-4.521-1.486-4.555-4.053a.834.834 0 01.824-.844.823.823 0 01.843.823c.02 1.566 1.59 2.41 3.055 2.41 1.238 0 2.478-.09 3.168-.751.593-.568.73-1.516.318-2.203-.488-.815-1.514-1.216-2.55-1.528l-1.294-.357c-1.441-.41-3.044-.965-3.892-2.381-.814-1.36-.564-3.153.596-4.263.985-.944 2.404-1.154 3.487-1.201v-1.087c0-.461.373-.833.833-.833z",
      fill: "#9A8EF2"
    }));
  };
  var pr = ["styles"];
  var vr = function vr(e) {
      e.styles;
      var t = Kt()(e, pr);
      return r().createElement("svg", Jt()({
        width: "40",
        height: "32",
        viewBox: "0 0 40 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r().createElement("g", {
        clipPath: "url(#prefix__clip0_4928_76661)"
      }, r().createElement("path", {
        d: "M39.132 7.32H1v8.675h38.132V7.32z",
        fill: "#9A8EF2"
      }), r().createElement("path", {
        d: "M12.136 22.877H7.205c-1.01 0-1.834.82-1.834 1.825s.823 1.824 1.834 1.824h4.942c1.01 0 1.834-.819 1.834-1.824a1.833 1.833 0 00-1.834-1.825h-.01z",
        fill: "#3B3B3B"
      }), r().createElement("path", {
        d: "M35.892 0L3.866.044C.835.044 0 2.797 0 5.812v20.725C0 29.553 2.46 32 5.491 32h29.017C37.54 32 40 29.553 40 26.537V5.812C40 2.797 38.913 0 35.892 0zM2.241 8.369h35.53v5.888H2.24V8.37zM33.608 30H6.03c-3.23 0-3.79-2.47-3.79-3.475V16.268h35.53v10.247c0 1.006-.955 3.639-4.162 3.475V30zM37.77 6.15H2.24v-.48c0-2.164.373-3.497 2.262-3.442h30.83c1.01 0 2.427.306 2.427 2.414l.021 1.508h-.01z",
        fill: "#3B3B3B"
      }), r().createElement("path", {
        d: "M31.818 26.516a2.739 2.739 0 002.745-2.732 2.739 2.739 0 00-2.745-2.731 2.739 2.739 0 00-2.746 2.731 2.739 2.739 0 002.746 2.732zM25.37 26.516a2.739 2.739 0 002.746-2.732 2.739 2.739 0 00-2.745-2.731 2.739 2.739 0 00-2.746 2.731 2.739 2.739 0 002.746 2.732z",
        fill: "#3B3B3B"
      })), r().createElement("defs", null, r().createElement("clipPath", {
        id: "prefix__clip0_4928_76661"
      }, r().createElement("path", {
        fill: "#fff",
        d: "M0 0h40v32H0z"
      }))));
    },
    wr = e.p + "bee835511bb3a080825d37433233d877.png",
    hr = e.p + "edb0859021e26ef335a765ab2b0736d1.png";
  var Cr,
    Br,
    yr = "doorstep-delivery",
    xr = "partner-delivery",
    Ir = "popstation",
    br = "collect-at-store",
    Or = "mailbox-delivery",
    Tr = "pay-by-cash",
    Dr = "pay-online",
    Sr = ((Cr = {})[Tr] = {
      imgSrc: fr,
      title: v("PAYMENT_BY_CASH")
    }, Cr[Dr] = {
      imgSrc: vr,
      title: v("PAYMENT_THROUGH_ONLINE")
    }, Cr),
    Rr = [yr, xr, Or],
    kr = ((Br = {})[yr] = {
      imgSrc: mr,
      title: v("PICKUP_TYPE_DOORSTEP_DELVIERY")
    }, Br[xr] = {
      imgSrc: wr,
      title: v("PICKUP_TYPE_PARTNER_DELIVERY")
    }, Br[Ir] = {
      imgSrc: Er,
      title: v("PICKUP_TYPE_POPSTATION")
    }, Br[br] = {
      imgSrc: hr,
      title: v("PICKUP_TYPE_COLLECT_AT_STORE")
    }, Br),
    Lr = {
      xs: !1,
      sm: !1,
      md: !0,
      lg: !0
    },
    Pr = {
      xs: !0,
      sm: !0,
      md: !1,
      lg: !1
    },
    Mr = {
      SECTION_TYPES: {
        YOU_MAY_NEED_TO_KNOW: "YouMayNeedToKnow",
        WHAT_NEXT: "WhatNext",
        HELP_BOX: "HelpBox",
        BACK_HOME: "BackHome",
        FEEDBACK_CARD: "FeedBackCard",
        PROMOTION_CARD: "PromotionCard",
        NEXT_STEP: "NextStep",
        ORDER_INFO: "OrderInfo",
        ORDER_STATUS: "OrderStatus",
        INFO: "Info",
        PROMO_CODE: "PromoCode",
        HELP_LINKS: "HelpLinks",
        LI_HOOK_INSURANCE: "LiHookInsurance",
        IMPORTANT_NOTE: "ImportantNote",
        BULLET_LIST: "BulletList"
      }
    };
  var Qr = function Qr(e) {
      var t = e.items,
        r = e.showNumber,
        l = void 0 === r ? t.length : r,
        A = e.enableShowLess,
        o = void 0 === A || A,
        a = (0, n.useState)(!0),
        i = a[0],
        c = a[1],
        u = (0, n.useState)([]),
        s = u[0],
        d = u[1],
        m = (0, n.useState)(null),
        E = m[0],
        g = m[1];
      return (0, n.useEffect)(function () {
        return t && (null == t ? void 0 : t.length) <= l ? (d(t), void g(null)) : i && t ? (d(t.slice(0, l) || []), void g(v("BUTTON_LINK_SHOW_MORE_COUNT", {
          count: t.length - l
        }))) : (d(t || []), void g(o ? v("BUTTON_LINK_SHOW_LESS") : null));
      }, [t, i]), {
        showItems: s,
        showItemsText: E,
        onTriggerShowItems: function onTriggerShowItems() {
          return c(!i);
        },
        resetShowLess: function resetShowLess() {
          return c(!0);
        }
      };
    },
    Nr = require("date-fns");
  var Hr = function Hr(e) {
      return /^\d{6}$/.test(e);
    },
    Fr = function Fr(e, t) {
      if (void 0 === t && (t = []), !e) return {
        invalid: !0,
        message: v("CC_E_API_POSTAL_FLOOR")
      };
      var n = 1 === e.length ? "0" + e : e;
      return t.find(function (e) {
        return e.floorNo === n;
      }) ? {
        invalid: !1,
        message: null
      } : {
        invalid: !0,
        message: v("CC_E_API_POSTAL_FLOOR")
      };
    },
    Xr = function Xr(e, t, n) {
      if (!e) return {
        invalid: !0,
        message: v("CC_E_API_POSTAL_UNIT")
      };
      var r = 1 === n.length ? "0" + n : n,
        l = 1 === e.length ? "0" + e : e;
      return t.find(function (e) {
        return e.unitNo === l && e.floorNo === r;
      }) ? {
        invalid: !1,
        message: null
      } : {
        invalid: !0,
        message: v("CC_E_API_POSTAL_UNIT")
      };
    },
    Vr = function Vr(e) {
      var t, n, r;
      if (e && (null === (t = Object.keys(e)) || void 0 === t ? void 0 : t.length)) {
        var l = function (e) {
            return {
              unitNumber: e.UnitNumber || e.unitNumber || "",
              floor: e.floor || "",
              blockOrHouseNum: e.HouseBlockNumber || e.blockOrHouseNum || "",
              streetName: "".concat(e.StreetName || e.streetName || "", ", "),
              buildingName: e.BuildingName || e.buildingName || "",
              postcode: e.ZipCode || e.postcode || "",
              storey: (null == e ? void 0 : e.Storey) ? "".concat(e.Storey, ", ") : ""
            };
          }(e),
          A = l.buildingName ? "".concat(l.buildingName, ", ") : "",
          o = (n = l.floor, (null == (r = l.unitNumber) ? void 0 : r.includes("#")) ? r : n && r ? "#".concat(n, "-").concat(r) : "");
        return "".concat(l.blockOrHouseNum, " ").concat(l.streetName).concat(o, " ").concat(A).concat(null == l ? void 0 : l.storey, "Singapore ").concat(l.postcode);
      }
      return "";
    },
    Gr = function Gr(e) {
      var t;
      return "".concat(e.POPStationName, " (").concat((t = (e.Distance / 1e3).toLocaleString("en-US", {
        maximumFractionDigits: 3
      }), "".concat(t, "km")), ")");
    };
  var zr = function zr(e) {
    var t = e.data,
      n = e.selected,
      l = e.onClickPopStation;
    return r().createElement(y.Selector, {
      "data-testid": "popstation-selector",
      alignment: "row",
      selected: t.KioskId === n,
      onClick: function onClick() {
        return l(t.KioskId);
      }
    }, r().createElement(y.Selector.Body, {
      align: "start",
      title: Gr(t),
      subtitle: Vr(t)
    }));
  };
  var Ur = function Ur(e, t) {
    return void 0 === t && (t = "MM/dd/yyyy"), (0, Nr.format)(e, t);
  };
  var jr = function jr(e) {
    for (var t = e.popstationTimeslots, l = e.onDateConfirmed, A = e.selectedTimeslot, o = (0, n.useRef)(), a = t.map(function (e) {
        return Ur(new Date(e));
      }), i = new Date(A || a[0]), c = new Date(a[0]), u = (0, n.useState)(i), s = u[0], d = u[1], m = new Date(a[a.length - 1]), E = [{
        before: c,
        after: m
      }], g = new Date(c); g <= m; g.setDate(g.getDate() + 1)) {
      -1 === a.indexOf(Ur(new Date(g))) && E.push(new Date(g));
    }
    return (0, n.useEffect)(function () {
      A && l(s);
    }, []), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.DatePicker.SingleDatePicker, {
      onConfirm: function onConfirm(e) {
        "function" == typeof l && l(e), o.current = e, d(e);
      },
      onBlur: function onBlur() {
        var e = o.current || i;
        d(new Date(e));
      },
      onClear: function onClear() {
        d(i);
      },
      bgColor: "haze",
      label: v("DATE_PICKER_LABEL"),
      value: s,
      disabledDays: E
    })));
  };
  var Jr,
    Yr = (0, y.withTheme)(h()(y.Text)(Jr || (Jr = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (e) {
      return e.coreTheme.cl_pri_d3;
    }));
  var Kr = function Kr(e) {
      var t,
        l,
        A,
        o,
        a,
        i,
        c = e.bagId,
        u = e.popstations,
        s = e.popstationTimeslots,
        d = e.onPopStationSelected,
        m = void 0 === d ? function () {} : d,
        E = (0, n.useContext)(ur),
        g = E.onSearchPopstation,
        f = E.onSearchPopstationTimeslot,
        p = E.bags,
        w = E.validateResult,
        h = E.configs,
        C = (0, n.useState)(),
        B = C[0],
        x = C[1],
        I = (0, n.useState)(null === (t = null == h ? void 0 : h.preSelection) || void 0 === t ? void 0 : t.postCode),
        b = I[0],
        O = I[1],
        T = (0, n.useRef)(),
        D = (0, n.useRef)(),
        S = Qr({
          items: u,
          showNumber: 3,
          enableShowLess: !1
        }),
        R = S.showItems,
        k = S.showItemsText,
        L = S.onTriggerShowItems,
        P = S.resetShowLess;
      (0, n.useEffect)(function () {
        (null == u ? void 0 : u.length) > 0 && U(j());
      }, [u]), (0, n.useEffect)(function () {
        !1 === (null == w ? void 0 : w.status) && J();
      }, [w]);
      var M = null === (o = null === (A = null === (l = null == p ? void 0 : p.find(function (e) {
          return e.id === c;
        })) || void 0 === l ? void 0 : l.pickup) || void 0 === A ? void 0 : A.find(function (e) {
          return e.type === Ir;
        })) || void 0 === o ? void 0 : o.explain,
        Q = (0, n.useState)(null === (a = null == h ? void 0 : h.preSelection) || void 0 === a ? void 0 : a.address),
        N = Q[0],
        H = Q[1],
        F = (0, n.useState)({
          status: !0,
          message: ""
        }),
        X = F[0],
        V = F[1];
      (0, n.useEffect)(function () {
        m({
          popStation: {
            postcode: b,
            kioskId: N
          },
          date: B || s[0]
        });
      }, [N, B, s]), (0, n.useEffect)(function () {
        P(), u && b && (T.current = b, J());
      }, [u]), (0, n.useEffect)(function () {
        var e,
          t = null === (e = null == h ? void 0 : h.preSelection) || void 0 === e ? void 0 : e.postCode;
        t && z(t);
      }, []);
      var G,
        z = function z(e) {
          g(e, c);
        },
        U = function U(e) {
          H(e), f(e, c);
        },
        j = function j() {
          var e = u.find(function (e) {
            var t;
            return e.KioskId === (null === (t = null == h ? void 0 : h.preSelection) || void 0 === t ? void 0 : t.address);
          }) || {};
          return e.KioskId || (null == u ? void 0 : u[0].KioskId);
        },
        J = function J(e) {
          if (void 0 === e && (e = !1), null == h ? void 0 : h.isPopstationLoading) return {
            status: !0,
            message: ""
          };
          var t = {
            status: !1,
            message: v("INVALID_POSTAL_CODE")
          };
          switch (!0) {
            case !b:
              return V({
                status: !1,
                message: v("ENTER_POSTAL_CODE")
              });
            case e && !Hr(b):
            case !e && (!Hr(b) || Array.isArray(u) && 0 === u.length):
              return V(t);
            default:
              return V({
                status: !0,
                message: ""
              });
          }
        };
      return r().createElement("div", {
        "data-testid": "popstation"
      }, r().createElement(y.Spacing, {
        type: "margin",
        bottom: 2,
        responsive: !1
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.TextInput, {
        bgColor: "haze",
        label: v("ADDRESS_FORM_POSTAL_CODE"),
        placeholder: v("ADDRESS_FORM_POSTAL_CODE_PLACEHOLDER"),
        loading: null == h ? void 0 : h.isPopstationLoading,
        maxLength: 6,
        ref: D,
        onChange: function onChange(e) {
          O(e.target.value), V({
            status: !0,
            message: ""
          });
        },
        value: b,
        error: !X.status,
        rightTextLink: {
          text: r().createElement(He, null),
          onClick: function onClick(e, t) {
            var n;
            (null === (n = D.current) || void 0 === n ? void 0 : n.value) && Hr(D.current.value) && z(D.current.value), J(!0);
          }
        }
      }), !1 === X.status && r().createElement(Yr, {
        type: "smallBody"
      }, X.message)))), u && T.current && !(null == h ? void 0 : h.isPopstationLoading) && r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.Text, {
        type: "header"
      }, (null == u ? void 0 : u.length) ? v("POPSTATION_AVAILABLE", {
        count: null == u ? void 0 : u.length,
        postalCode: T.current
      }) : v("POPSTATION_UNAVAILABLE", {
        postalCode: T.current
      })))), !!(null == R ? void 0 : R.length) && r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        type: "margin",
        topBottom: 2
      }, r().createElement(y.Row, null, R.map(function (e) {
        return r().createElement(y.Column, {
          xs: 12,
          key: e.KioskId
        }, r().createElement(zr, {
          data: e,
          selected: N,
          onClickPopStation: U
        }));
      }), k && r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.TextLink, {
        onClick: L
      }, k)))), (null == s ? void 0 : s.length) > 0 && !(null == h ? void 0 : h.isPopstationTimeslotLoading) && r().createElement(r().Fragment, null, r().createElement(jr, {
        onDateConfirmed: function onDateConfirmed(e) {
          x("".concat(e.getMonth() + 1, "/").concat(e.getDate(), "/").concat(e.getFullYear()));
        },
        popstationTimeslots: s,
        selectedTimeslot: null === (i = null == h ? void 0 : h.preSelection) || void 0 === i ? void 0 : i.timeslot
      }), M && (G = dr(M.icon), r().createElement(y.Spacing, {
        type: "margin",
        top: 1
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(Fe, {
        alignY: "top"
      }, M.icon && r().createElement(Ne, null, r().createElement(G, null)), r().createElement(y.Text, null, M.message)))))))));
    },
    Zr = require("@react-google-maps/api");
  var qr,
    Wr = h().div(qr || (qr = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      return !e.show && "opacity: 0; z-index: -1";
    }),
    _r = function _r(e) {
      var t = e.map,
        n = (void 0 === t ? {} : t).mapTerrain,
        r = void 0 === n ? {} : n;
      return [{
        featureType: "water",
        elementType: "geometry",
        stylers: [{
          color: null == r ? void 0 : r.waterGeometry
        }, {
          lightness: 17
        }]
      }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
          color: null == r ? void 0 : r.landscapeGeometry
        }, {
          lightness: 20
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
          color: r.roadHighwayGeometryFill
        }, {
          lightness: 17
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
          color: r.roadHighwayGeometryStroke
        }, {
          lightness: 29
        }, {
          weight: .2
        }]
      }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
          color: r.roadArterialGeometry
        }, {
          lightness: 18
        }]
      }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
          color: r.roadLocalGeometry
        }, {
          lightness: 16
        }]
      }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
          color: r.poiGeometry
        }, {
          lightness: 21
        }]
      }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
          color: r.poiParkGeometry
        }, {
          lightness: 21
        }]
      }, {
        elementType: "labels.text.stroke",
        stylers: [{
          visibility: "on"
        }, {
          color: r.labelsTextStroke
        }, {
          lightness: 16
        }]
      }, {
        elementType: "labels.text.fill",
        stylers: [{
          saturation: 36
        }, {
          color: r.labelsTextFill
        }, {
          lightness: 30
        }]
      }, {
        elementType: "labels.icon",
        stylers: [{
          visibility: "off"
        }]
      }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
          color: r.transitGeometry
        }, {
          lightness: 19
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
          color: r.administrativeGeometryFill
        }, {
          lightness: 20
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
          color: r.administrativeGeometryStroke
        }, {
          lightness: 17
        }, {
          weight: 1.2
        }]
      }];
    };
  var $r = require("react-dom");
  var el = [5, 10, 15],
    tl = "location-details-card",
    nl = "marker-label",
    rl = ["styles"];
  var ll = function ll(e) {
    e.styles;
    var t = Kt()(e, rl);
    return r().createElement("svg", Jt()({
      width: "20",
      height: "22",
      viewBox: "0 0 20 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.979 0c4.129 0 7.488 3.358 7.488 7.487 0 1.911-1.157 4.125-2.574 6.025l1.696-.002c.872 0 1.679.507 2.056 1.292l.043.104 1.012 2.897a2.797 2.797 0 01-.181 2.656 2.796 2.796 0 01-2.377 1.312H2.81a2.796 2.796 0 01-2.377-1.312c-.5-.795-.57-1.77-.194-2.626l.87-3.018a2.291 2.291 0 012.055-1.293l1.908-.002c-1.42-1.901-2.58-4.119-2.58-6.033C2.492 3.358 5.85 0 9.979 0zm6.611 15.51l-3.382.003c-1.393 1.473-2.716 2.463-3.23 2.463-.512 0-1.83-.987-3.222-2.457l-3.591.003a.285.285 0 00-.224.112l-.86 2.979a.802.802 0 00.045.78.801.801 0 00.684.378h14.332a.801.801 0 00.684-.378.802.802 0 00.045-.78l-.043-.103-1.003-2.873a.282.282 0 00-.235-.127zM9.979 2a5.494 5.494 0 00-5.487 5.487c0 3.131 4.067 7.128 5.48 8.281 1.433-1.172 5.495-5.159 5.495-8.28A5.494 5.494 0 009.979 2zm0 2.078a3.514 3.514 0 013.51 3.51 3.516 3.516 0 01-3.51 3.51 3.515 3.515 0 01-3.51-3.51 3.513 3.513 0 013.51-3.51zm0 2c-.832 0-1.51.678-1.51 1.51 0 .833.678 1.51 1.51 1.51.833 0 1.51-.677 1.51-1.51 0-.832-.677-1.51-1.51-1.51z",
      fill: "#5C50BB"
    }));
  };
  var Al = function Al(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    ol = (0, y.withTheme)(h().div(ml || (ml = Al(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(dl || (dl = Al(["\n    width: calc(100% - 32px);\n    position: absolute;\n    bottom: 24px;\n    display: block;\n    z-index: 2;\n    margin: 0 16px;\n\n    @media (min-width: ", ") {\n      width: calc(100% - 200px);\n      margin: 0px 100px;\n    }\n  "], ["\n    width: calc(100% - 32px);\n    position: absolute;\n    bottom: 24px;\n    display: block;\n    z-index: 2;\n    margin: 0 16px;\n\n    @media (min-width: ", ") {\n      width: calc(100% - 200px);\n      margin: 0px 100px;\n    }\n  "])), null == t ? void 0 : t.brk_sm);
    })),
    al = h().div(El || (El = Al(["\n  padding-top: 2px;\n  padding-right: 10px;\n"], ["\n  padding-top: 2px;\n  padding-right: 10px;\n"]))),
    il = h()(y.Text)(gl || (gl = Al(["\n  text-align: left;\n"], ["\n  text-align: left;\n"]))),
    cl = h()(y.Spacing)(fl || (fl = Al(["\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n"], ["\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n"]))),
    ul = h()(y.Text)(vl || (vl = Al(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(pl || (pl = Al(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), null == t ? void 0 : t.cl_sec_d1);
    });
  var sl = function sl(e) {
    var t = e.name,
      n = e.descriptionLiner,
      l = e.subDescriptionLiner,
      A = e.postalCode,
      o = e.directionsLinkText,
      a = (0, y.useTheme)().theme;
    return document.getElementsByClassName("location-details-card") ? (0, $r.createPortal)(r().createElement(ol, {
      coreTheme: a
    }, r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Column, {
      xs: 12,
      sm: 6,
      md: 5
    }, r().createElement(y.Card, {
      shadow: "sm",
      radius: "sm",
      padding: "sm"
    }, r().createElement(y.Card.Content, null, r().createElement(il, {
      type: "body",
      "data-testid": "location-name"
    }, t), n && r().createElement(il, {
      type: "smallBody",
      color: null == a ? void 0 : a.cl_ter_l2,
      "data-testid": "location-description-liner"
    }, "".concat(n)), l && r().createElement(il, {
      type: "smallBody",
      color: null == a ? void 0 : a.cl_ter_l2,
      "data-testid": "location-sub-description-liner"
    }, "".concat(l)), o && r().createElement(cl, {
      top: 1,
      onClick: function onClick() {
        var e = "".concat(t, ",").concat(A, ",Singapore");
        window.open("".concat("https://www.google.com/maps/search/", "?api=1&query=").concat(e), "_blank");
      },
      "data-testid": "location-directions-link"
    }, r().createElement(al, null, r().createElement("img", {
      src: ll
    })), r().createElement(ul, {
      type: "smallBody",
      fontWeight: "bold",
      coreTheme: a
    }, o))))))), document.getElementsByClassName("location-details-card")[0]) : r().createElement(r().Fragment, null);
  };
  var dl, ml, El, gl, fl, pl, vl;
  var wl = function wl(e) {
    var t,
      n = e.markerData,
      l = e.onClick,
      A = e.showLabel,
      o = e.markerLabelClassName;
    (0, y.useTheme)().theme, A && (t = {
      className: o,
      text: n.name
    });
    var a = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n.isSelected ? '\n<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M34.9243 16.6284C34.9243 8.37669 28.211 1.66669 19.961 1.66669C11.7127 1.66669 4.99933 8.37669 4.99933 16.6284C4.99933 26.6667 19.961 37.7384 19.961 37.7384C19.961 37.7384 34.9243 26.6667 34.9243 16.6284Z" fill="#151560"/>\n    <path d="M26.7727 16.8328C26.7727 13.0762 23.7177 10.0212 19.961 10.0212C16.206 10.0212 13.151 13.0762 13.151 16.8328C13.151 20.5878 16.206 23.6428 19.961 23.6428C23.7177 23.6428 26.7727 20.5878 26.7727 16.8328Z" fill="#F7F7F7"/>\n</svg>\n' : '\n<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M20.9546 9.977C20.9546 5.026 16.9266 1 11.9766 1C7.02757 1 2.99957 5.026 2.99957 9.977C2.99957 16 11.9766 22.643 11.9766 22.643C11.9766 22.643 20.9546 16 20.9546 9.977Z" fill="#9A8EF2"/>\n    <path d="M16.0636 10.0997C16.0636 7.8457 14.2306 6.0127 11.9766 6.0127C9.72362 6.0127 7.89062 7.8457 7.89062 10.0997C7.89062 12.3527 9.72362 14.1857 11.9766 14.1857C14.2306 14.1857 16.0636 12.3527 16.0636 10.0997Z" fill="#F7F7F7"/>\n</svg>\n'),
      i = n.isSelected ? new window.google.maps.Point(18, 63) : new window.google.maps.Point(12, 48);
    return r().createElement(Zr.Marker, {
      "data-testid": "google-map-marker",
      onClick: l,
      icon: {
        url: a,
        labelOrigin: i
      },
      position: n,
      label: t
    });
  };
  var _hl = function hl() {
      return _hl = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _hl.apply(this, arguments);
    },
    Cl = function Cl(e) {
      return e * (Math.PI / 180);
    },
    Bl = function Bl(e, t, n) {
      for (var r = null == e ? void 0 : e.map(function (e) {
          var n,
            r,
            l,
            A,
            o,
            a,
            i,
            c = (n = parseFloat(null == t ? void 0 : t.lat), r = parseFloat(null == t ? void 0 : t.lng), l = parseFloat(e.lat), A = parseFloat(e.lng), o = Cl(l - n), a = Cl(A - r), i = Math.sin(o / 2) * Math.sin(o / 2) + Math.cos(Cl(n)) * Math.cos(Cl(l)) * Math.sin(a / 2) * Math.sin(a / 2), 2 * Math.atan2(Math.sqrt(i), Math.sqrt(1 - i)) * 6371);
          return _hl(_hl({}, e), {
            distance: c
          });
        }), l = [], A = n || el, o = function o(e) {
          r && 0 === l.length && (l = null == r ? void 0 : r.filter(function (t) {
            return t.distance < A[e];
          }));
        }, a = 0; a < A.length; a++) {
        o(a);
      }
      return l.sort(function (e, t) {
        return e.distance - t.distance;
      });
    },
    _yl = function yl() {
      return _yl = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _yl.apply(this, arguments);
    };
  var xl = function xl(e) {
      var t = e.filters,
        l = e.title,
        A = e.buttonLabel,
        o = e.onFilterModalClose,
        a = e.onFiltersUpdated,
        i = (0, n.useState)(t),
        c = i[0],
        u = i[1];
      return (0, n.useEffect)(function () {
        u(t);
      }, [t]), r().createElement(y.Modal, {
        visible: !0,
        title: l,
        onClose: function onClose() {
          o();
        },
        "data-testid": "filter-modal"
      }, r().createElement(y.Modal.Content, null, c.map(function (e) {
        return r().createElement(y.Spacing, {
          bottom: 2,
          key: e.value
        }, r().createElement(y.Checkbox.Input, {
          label: e.name,
          onChange: function onChange(t, n) {
            !function (e, t) {
              var n = c.map(function (n) {
                return n.value === e.value ? _yl(_yl({}, n), {
                  selected: t
                }) : n;
              });
              u(n);
            }(e, n);
          },
          checked: e.selected,
          "data-testid": "checkbox-".concat(e.value)
        }));
      }), r().createElement(y.Spacing, {
        top: 1
      }, r().createElement(y.Button, {
        fullWidth: !0,
        onClick: function onClick() {
          c.filter(function (e) {
            return e.selected;
          }).map(function (e) {
            return e.value;
          }).length > 0 && a(c);
        },
        "data-testid": "filter-modal-button"
      }, A))));
    },
    Il = require("react-transition-group");
  var bl,
    Ol,
    Tl,
    Dl,
    Sl,
    Rl,
    kl,
    Ll,
    Pl,
    Ml,
    Ql,
    Nl,
    Hl,
    Fl,
    Xl,
    Vl,
    Gl = function Gl(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    zl = h().div(bl || (bl = Gl(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]))),
    Ul = h().div(Ol || (Ol = Gl(["\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n"], ["\n  display: flex;\n  cursor: pointer;\n  user-select: none;\n"]))),
    jl = (0, y.withTheme)(h()(y.Text)(Dl || (Dl = Gl(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(Tl || (Tl = Gl(["\n    flex: 1;\n    padding-right: ", "px;\n  "], ["\n    flex: 1;\n    padding-right: ", "px;\n  "])), t.space_4);
    })),
    Jl = (0, y.withTheme)(h().div(Rl || (Rl = Gl(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(Sl || (Sl = Gl(["\n    margin-top: 5px;\n    margin-left: 10px;\n    stroke: ", ";\n    @media (min-width: ", ") {\n      svg {\n        width: 22px;\n        height: 22px;\n        stroke: none;\n      }\n    }\n  "], ["\n    margin-top: 5px;\n    margin-left: 10px;\n    stroke: ", ";\n    @media (min-width: ", ") {\n      svg {\n        width: 22px;\n        height: 22px;\n        stroke: none;\n      }\n    }\n  "])), t.cl_sec_d1, t.brk_md);
    })),
    Yl = (0, y.withTheme)(h().div(Ll || (Ll = Gl(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(kl || (kl = Gl(["\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    padding-top: ", "px;\n  "], ["\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    padding-top: ", "px;\n  "])), t.space_4);
    })),
    Kl = h().div(Pl || (Pl = Gl(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"]))),
    Zl = function Zl(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    ql = h().div(Vl || (Vl = Zl(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.transitionState,
        n = e.translateYPos,
        r = e.animationDuration,
        l = function (e) {
          return (0, w.keyframes)(Ml || (Ml = Zl(["\n  from {\n    transform: translateY(", "px);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n"], ["\n  from {\n    transform: translateY(", "px);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n"])), e);
        }(n),
        A = function (e) {
          return (0, w.keyframes)(Ql || (Ql = Zl(["\n  from {\n    transform: translateY(0);\n  }\n\n  to {\n    transform: translateY(", "px);\n  }\n"], ["\n  from {\n    transform: translateY(0);\n  }\n\n  to {\n    transform: translateY(", "px);\n  }\n"])), e);
        }(n);
      switch (t) {
        case "entering":
          return (0, w.css)(Nl || (Nl = Zl(["\n          animation: ", " ease-out ", "ms;\n        "], ["\n          animation: ", " ease-out ", "ms;\n        "])), l, r);
        case "entered":
          return (0, w.css)(Hl || (Hl = Zl(["\n          transform: translateY(0);\n        "], ["\n          transform: translateY(0);\n        "])));
        case "exiting":
          return (0, w.css)(Fl || (Fl = Zl(["\n          animation: ", " ease-in ", "ms;\n        "], ["\n          animation: ", " ease-in ", "ms;\n        "])), A, r);
        case "exited":
          return (0, w.css)(Xl || (Xl = Zl(["\n          transform: translateY(", "px);\n        "], ["\n          transform: translateY(", "px);\n        "])), n);
      }
    }),
    _Wl = function Wl() {
      return _Wl = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Wl.apply(this, arguments);
    };
  var _l = function _l(e) {
    var t = e.renderHeading,
      l = e.showFilter,
      A = e.onFilterClick,
      o = e.locations,
      a = e.onLocationSelected,
      i = e.viewMoreLabel,
      c = e.viewLessLabel,
      u = e.initialSearchResultCount,
      s = (0, y.useTheme)().theme,
      d = (0, n.useState)(!1),
      m = d[0],
      E = d[1],
      g = (0, n.useState)(!0),
      f = g[0],
      p = g[1],
      v = (0, n.useState)([]),
      w = v[0],
      h = v[1],
      C = (0, n.useRef)(null),
      B = o.length > u;
    (0, n.useEffect)(function () {
      var e = o.map(function (e) {
        var t = (0, n.createRef)();
        return _Wl(_Wl({}, e), {
          nodeRef: t
        });
      });
      h(e);
    }, [o]);
    var x = function x(e, t) {
      var n = " (".concat(function (e, t) {
          if (void 0 === t && (t = ""), !e || isNaN(e)) return "";
          var n = parseFloat((Math.round(1e3 * e) / 1e3).toFixed(3));
          return "".concat(n, " ").concat(t);
        }(e.distance, "KM"), ")") || 0,
        l = "".concat(e.name).concat(n);
      return r().createElement(y.Spacing, {
        top: 2,
        responsive: !1,
        key: e.name,
        index: t
      }, r().createElement(y.Selector, {
        alignment: "row",
        selected: e.isSelected,
        onClick: function onClick() {
          a(t);
        },
        "data-testid": "location-selector"
      }, r().createElement(y.Selector.Body, {
        title: l,
        align: "start"
      }, e.descriptionLiner && r().createElement(y.Text, {
        type: "smallBody",
        color: s.cl_ter_l2
      }, e.descriptionLiner))));
    };
    return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      top: 2,
      responsive: !1
    }, r().createElement(zl, null, r().createElement(jl, {
      type: "boldBody",
      "data-testid": "search-results-heading"
    }, "function" == typeof t && t()), l && r().createElement(Ul, {
      onClick: A,
      "data-testid": "filter-icon"
    }, r().createElement(ce.Filter, {
      color: null == s ? void 0 : s.cl_sec_d1,
      size: 24
    })))), w.slice(0, u).map(function (e, t) {
      return r().createElement(Kl, {
        key: e.name,
        ref: e.nodeRef
      }, x(e, t));
    }), function () {
      var e = [];
      if (m && (e = w.slice(u).map(function (e, t) {
        return r().createElement(Il.CSSTransition, {
          timeout: 300,
          key: e.name,
          nodeRef: e.nodeRef
        }, function (n) {
          var l = function (e, t, n) {
            var r, l;
            return (null === (r = e[n - 1].nodeRef.current) || void 0 === r ? void 0 : r.offsetTop) - (null === (l = t.current) || void 0 === l ? void 0 : l.offsetTop) || 0;
          }(w, e.nodeRef, u);
          return r().createElement(ql, {
            transitionState: n,
            animationDuration: 300,
            translateYPos: l,
            ref: e.nodeRef
          }, x(e, t + u));
        });
      }), B)) {
        var t = r().createElement(Il.CSSTransition, {
          timeout: 300,
          key: "viewLessLink",
          onExited: function onExited() {
            p(!0);
          },
          nodeRef: C
        }, function (e) {
          var t = function (e, t, n) {
            var r,
              l,
              A = 0;
            return e.slice(n).forEach(function (e) {
              var t, n;
              (null === (t = e.nodeRef.current) || void 0 === t ? void 0 : t.offsetHeight) > A && (A = null === (n = e.nodeRef.current) || void 0 === n ? void 0 : n.offsetHeight);
            }), (null === (r = e[n - 1].nodeRef.current) || void 0 === r ? void 0 : r.offsetTop) + A - (null === (l = t.current) || void 0 === l ? void 0 : l.offsetTop) || 0;
          }(w, C, u);
          return r().createElement(ql, {
            transitionState: e,
            animationDuration: 300,
            translateYPos: t,
            ref: C
          }, r().createElement(Yl, {
            onClick: function onClick() {
              E(!1);
            }
          }, r().createElement(y.TextLink, {
            "data-testid": "view-less-label"
          }, c), r().createElement(Jl, null, r().createElement(ce.ArrowUp, {
            color: null == s ? void 0 : s.cl_sec_d1,
            size: 16,
            "data-testid": "arrow-up"
          }))));
        });
        e.push(t);
      }
      return r().createElement(Il.TransitionGroup, {
        appear: !0
      }, e);
    }(), B && f && r().createElement(Yl, {
      onClick: function onClick() {
        E(!0), p(!1);
      }
    }, r().createElement(y.TextLink, {
      "data-testid": "view-more-label"
    }, i), r().createElement(Jl, null, r().createElement(ce.ArrowDown, {
      color: null == s ? void 0 : s.cl_sec_d1,
      size: 16,
      "data-testid": "arrow-down"
    }))));
  };
  var $l = h().div(tA || (tA = function (e, t) {
    return Object.defineProperty ? Object.defineProperty(e, "raw", {
      value: t
    }) : e.raw = t, e;
  }(["\n  display: flex;\n  cursor: pointer;\n"], ["\n  display: flex;\n  cursor: pointer;\n"])));
  var eA = function eA(e) {
    var t = e.label,
      l = e.errorMessage,
      A = e.onSearch,
      o = e.preSearchTerm,
      a = void 0 === o ? "" : o,
      i = (0, n.useState)(a),
      c = i[0],
      u = i[1],
      s = (0, y.useTheme)().theme,
      d = (0, n.useCallback)(function (e) {
        13 === e.charCode && (e.preventDefault(), A && A(c));
      }, [A, c]),
      m = (0, n.useCallback)(function () {
        A && A(c);
      }, [A, c]),
      E = (0, n.useMemo)(function () {
        return r().createElement($l, {
          onClick: m,
          "data-testid": "search-icon"
        }, r().createElement(ce.Search, {
          color: null == s ? void 0 : s.cl_sec_d1,
          size: 22
        }));
      }, [m]),
      g = (0, n.useCallback)(function (e) {
        u(e.target.value);
      }, []);
    return r().createElement(y.TextInput, {
      type: "number",
      value: c,
      label: t,
      bgColor: "haze",
      suffix: E,
      onChange: g,
      error: !!l,
      hintMessage: l,
      onKeyPress: d,
      "data-testid": "search-input"
    });
  };
  var tA,
    nA = function nA(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _rA = function rA() {
      return _rA = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _rA.apply(this, arguments);
    },
    lA = (0, y.withTheme)(h().div(aA || (aA = nA(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t,
        n,
        r,
        l,
        A,
        o,
        a = e.coreTheme;
      return (0, w.css)(oA || (oA = nA(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    .", " {\n      text-align: center;\n      line-height: ", ";\n      letter-spacing: ", ";\n      width: 104px;\n      white-space: normal;\n      text-shadow: ", ";\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    .", " {\n      text-align: center;\n      line-height: ", ";\n      letter-spacing: ", ";\n      width: 104px;\n      white-space: normal;\n      text-shadow: ", ";\n    }\n  "])), nl, null === (n = null === (t = null == a ? void 0 : a.map) || void 0 === t ? void 0 : t.marker) || void 0 === n ? void 0 : n.labelLineHeight, null === (l = null === (r = null == a ? void 0 : a.map) || void 0 === r ? void 0 : r.marker) || void 0 === l ? void 0 : l.labelLetterSpacing, null === (o = null === (A = null == a ? void 0 : a.map) || void 0 === A ? void 0 : A.marker) || void 0 === o ? void 0 : o.labelTextShadow);
    }));
  var AA = function AA(e) {
    var t = e.locations,
      l = void 0 === t ? [] : t,
      A = e.searchConfig,
      o = e.filterConfig,
      a = e.locationDetailsConfig,
      i = e.defaultCenterCoordinates,
      c = e.zoomConfig,
      u = e.onLocationSelected,
      s = e.googleMapsApiKey,
      d = e.showMapWithoutResults,
      m = void 0 === d || d,
      E = e.searchRequiredError,
      g = void 0 === E ? "" : E,
      f = e.onLocationSearchError,
      p = void 0 === f ? function () {
        return null;
      } : f,
      v = e.preSelection,
      w = e.showMarkersWithoutSearch,
      h = void 0 === w || w,
      C = (0, y.useTheme)().theme,
      B = c || {},
      x = B.defaultZoom,
      I = void 0 === x ? 12 : x,
      b = B.focusedAreaZoom,
      O = void 0 === b ? 15 : b,
      T = B.labelHidingZoom,
      D = void 0 === T ? 14 : T,
      S = (0, Zr.useLoadScript)({
        googleMapsApiKey: s
      }).isLoaded,
      R = (0, y.useDevice)().isMobile,
      k = (0, n.useState)(g),
      L = k[0],
      P = k[1],
      M = (0, n.useState)(v),
      Q = M[0],
      N = M[1],
      H = (0, n.useState)(""),
      F = H[0],
      X = H[1],
      V = (0, n.useState)(null),
      G = V[0],
      z = V[1],
      U = (0, n.useState)(100),
      j = U[0],
      J = U[1],
      Y = (0, n.useState)(I),
      K = Y[0],
      Z = Y[1],
      q = (0, n.useState)([]),
      W = q[0],
      _ = q[1],
      $ = (0, n.useState)(!1),
      ee = $[0],
      te = $[1],
      ne = (0, n.useState)(l),
      re = ne[0],
      le = ne[1],
      Ae = (0, n.useState)(!0),
      oe = Ae[0],
      ae = Ae[1],
      ie = (0, n.useState)(),
      ce = ie[0],
      ue = ie[1],
      se = (0, n.useRef)(),
      de = (0, n.useRef)(null),
      me = (0, n.useRef)(null),
      Ee = function Ee(e) {
        var t,
          n = !!G || m;
        if (ae(n), e && se.current) {
          var r = se.current.offsetWidth,
            l = n ? (t = r) ? t / 16 * 9 : 0 : 0;
          J(l);
        }
      };
    (0, n.useEffect)(function () {
      Ee(S);
      var e = function e() {
        Ee(S);
      };
      return window.addEventListener("resize", e), function () {
        window.removeEventListener("resize", e);
      };
    }, [S, G]);
    var ge = (0, n.useMemo)(function () {
        return {
          mapTypeControl: !1,
          streetViewControl: !1,
          zoomControl: !R,
          styles: _r(C)
        };
      }, [R, C]),
      fe = (0, n.useMemo)(function () {
        return {
          height: "".concat(j, "px")
        };
      }, [j]),
      pe = (0, n.useCallback)(function (e) {
        var t;
        de.current = e, me.current = new window.google.maps.Geocoder();
        var n = document.createElement("div");
        n.setAttribute("class", tl), null === (t = de.current) || void 0 === t || t.getDiv().firstChild.appendChild(n), me.current && Q && Be(Q.searchTerm);
      }, []),
      ve = (0, n.useCallback)(function () {
        de.current && de.current.zoom && Z(de.current.zoom);
      }, []),
      we = (0, n.useCallback)(function () {
        var e,
          t,
          n = null === (e = de.current) || void 0 === e ? void 0 : e.getDiv().firstChild,
          r = null === (t = de.current) || void 0 === t ? void 0 : t.getDiv().firstChild.getElementsByClassName(tl)[0];
        n.clientHeight === window.innerHeight && n.clientWidth === window.innerWidth ? r.style.display = "block" : r.style.display = "none";
      }, []);
    (0, n.useEffect)(function () {
      var e = l.map(function (e) {
        return _rA(_rA({}, e), {
          isSelected: !1
        });
      });
      le(e);
    }, [l]), (0, n.useEffect)(function () {
      ae(!!G || m);
    }, [G, m]), (0, n.useEffect)(function () {
      p(L);
    }, [L]), (0, n.useEffect)(function () {
      P(g);
    }, [g]);
    var he = function he(e, t, n) {
        var r;
        void 0 === e && (e = []), void 0 === n && (n = "");
        var l = e.map(function (e, n) {
          return _rA(_rA({}, e), {
            isSelected: n === t
          });
        });
        le(l);
        var A = l[t];
        ue(A), null === (r = de.current) || void 0 === r || r.panTo({
          lng: A.lng,
          lat: A.lat
        }), K < O && Z(O), "function" == typeof u && u(_rA(_rA({}, A), {
          searchTerm: n || F
        }));
      },
      Ce = function Ce() {
        var e = l.map(function (e) {
          return _rA(_rA({}, e), {
            isSelected: !1
          });
        });
        le(e);
      },
      Be = function Be(e) {
        var t;
        if (z(null), 6 != (null == e ? void 0 : e.length)) return P((null == A ? void 0 : A.invalidPostalCodeLengthError) || "This must consist of 6 digits"), void Ce();
        X(e), null === (t = me.current) || void 0 === t || t.geocode({
          componentRestrictions: {
            country: "SG",
            postalCode: e
          }
        }, function (t, n) {
          var r;
          if ("OK" == n) {
            var o = t[0].geometry.location,
              a = o.lat,
              i = o.lng,
              c = {
                lat: a(),
                lng: i()
              },
              u = Bl(l, c, null == A ? void 0 : A.searchRadius);
            u && u.length > 0 && (null === (r = de.current) || void 0 === r || r.panTo({
              lng: u[0].lng,
              lat: u[0].lat
            }));
            var s = function (e, t) {
              if (void 0 === t && (t = []), !e) return 0;
              var n = e.selectedLocation,
                r = t.findIndex(function (e) {
                  return (null == e ? void 0 : e.lat) === n.lat && (null == e ? void 0 : e.lng) === n.lng;
                });
              return -1 === r ? 0 : r;
            }(Q, u);
            he(u, s, e);
            var d = function (e) {
                var t = {},
                  n = [];
                return null == e || e.forEach(function (e) {
                  var r;
                  null === (r = e.categories) || void 0 === r || r.forEach(function (e) {
                    var r = e.value,
                      l = e.name;
                    t[r] || (t[r] = {
                      name: l
                    }, n.push({
                      name: l,
                      value: r
                    }));
                  });
                }), n;
              }(u),
              m = [];
            d.forEach(function (e) {
              m.push(_rA(_rA({}, e), {
                selected: !0
              }));
            }), _(m), P(""), z(c);
          } else P((null == A ? void 0 : A.invalidPostalCodeError) || "Make sure this is a valid postal code"), Ce();
          N(null);
        });
      };
    if (!S) return r().createElement("div", null, "Loading...");
    var ye = h || !h && !!F;
    return r().createElement(r().Fragment, null, r().createElement(lA, null, A && r().createElement(y.Spacing, {
      bottom: 2,
      responsive: !1
    }, r().createElement(eA, {
      preSearchTerm: null == v ? void 0 : v.searchTerm,
      label: A.searchInputLabel,
      errorMessage: L,
      onSearch: function onSearch(e) {
        Be(e);
      }
    })), r().createElement(Wr, {
      show: oe,
      ref: se
    }, r().createElement(Zr.GoogleMap, {
      zoom: K,
      mapContainerStyle: fe,
      options: ge,
      onLoad: pe,
      onZoomChanged: ve,
      onBoundsChanged: we,
      center: i
    }, ye && r().createElement(r().Fragment, null, re.map(function (e, t) {
      return r().createElement(wl, {
        markerData: e,
        key: t,
        onClick: function onClick() {
          he(re, t);
        },
        showLabel: K >= D,
        markerLabelClassName: nl
      });
    })))), ee && r().createElement(xl, {
      filters: W,
      title: o.modalTitle,
      buttonLabel: o.modalButtonLabel,
      onFilterModalClose: function onFilterModalClose() {
        te(!1);
      },
      onFiltersUpdated: function onFiltersUpdated(e) {
        var t;
        _(e);
        var n = null == e ? void 0 : e.filter(function (e) {
            return e.selected;
          }).map(function (e) {
            return e.value;
          }),
          r = Bl(l, G, null == A ? void 0 : A.searchRadius).filter(function (e) {
            return !e.categories || e.categories.map(function (e) {
              return e.value;
            }).filter(function (e) {
              return n.includes(e);
            }).length > 0;
          });
        he(r, 0), null === (t = de.current) || void 0 === t || t.panTo({
          lng: r[0].lng,
          lat: r[0].lat
        }), te(!1);
      }
    }), de.current && (null == ce ? void 0 : ce.descriptionLiner) && r().createElement(sl, {
      name: null == ce ? void 0 : ce.name,
      descriptionLiner: null == ce ? void 0 : ce.descriptionLiner,
      subDescriptionLiner: null == ce ? void 0 : ce.subDescriptionLiner,
      postalCode: null == ce ? void 0 : ce.postalCode,
      directionsLinkText: a && a.directionsLinkText
    }), G && r().createElement(_l, {
      showFilter: !!o,
      onFilterClick: function onFilterClick() {
        te(!0);
      },
      locations: re,
      onLocationSelected: function onLocationSelected(e) {
        he(re, e);
      },
      renderHeading: function renderHeading() {
        var e = W.filter(function (e) {
          return e.selected;
        }).map(function (e) {
          return e.name;
        });
        return "function" == typeof (null == A ? void 0 : A.renderSearchResultsHeading) && A.renderSearchResultsHeading(re.length, e, F);
      },
      viewMoreLabel: A.viewMoreResultsLabel,
      viewLessLabel: A.viewLessResultsLabel,
      initialSearchResultCount: A.initialSearchResultCount
    })));
  };
  var oA,
    aA,
    _iA = function iA() {
      return _iA = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _iA.apply(this, arguments);
    },
    cA = r().memo(function (e) {
      var t = e.pickupLocations,
        l = e.googleMapKey,
        A = e.collectAtStoreValidity,
        o = e.onLocationSelected,
        a = e.onLocationSearchError,
        i = e.preSelection,
        c = (0, n.useMemo)(function () {
          return function (e) {
            return void 0 === e && (e = []), e.map(function (e) {
              var t = "".concat(e.postalCode, " ").concat(e.country);
              return {
                name: e.name,
                lat: +e.lat,
                lng: +e.lon,
                postalCode: t,
                descriptionLiner: "".concat(e.street, ", ").concat(e.building, ", ").concat(t),
                subDescriptionLiner: "",
                categories: [{
                  name: e.storeType,
                  value: e.shopType
                }],
                storeId: e.mtposId
              };
            });
          }(t);
        }, [t]),
        u = {
          renderSearchResultsHeading: function renderSearchResultsHeading(e, t, n) {
            return v("STORE_AVAILABLE", {
              numOfSearchResults: e,
              postalCode: n
            });
          },
          searchRadius: [25, 30],
          initialSearchResultCount: 3,
          searchInputLabel: v("STORE_LOCATION"),
          viewMoreResultsLabel: v("SEARCH_MORE"),
          viewLessResultsLabel: v("SEARCH_LESS"),
          invalidPostalCodeLengthError: v("INVALID_POSTAL_CODE"),
          invalidPostalCodeError: v("INVALID_POSTAL_CODE")
        },
        s = A ? null : v("INVALID_POSTAL_CODE"),
        d = i ? {
          preSelection: i
        } : {};
      return r().createElement("div", {
        "data-testid": "collect-at-store"
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12,
        sm: 12
      }, r().createElement(AA, _iA({}, d, {
        locations: c,
        googleMapsApiKey: l,
        defaultCenterCoordinates: {
          lat: 1.3308198,
          lng: 103.88769
        },
        zoomConfig: {
          defaultZoom: 12,
          focusedAreaZoom: 15,
          labelHidingZoom: 14
        },
        searchConfig: u,
        searchRequiredError: s,
        onLocationSelected: o,
        onLocationSearchError: a,
        showMarkersWithoutSearch: !1
      })))));
    });
  var uA = cA;
  var _sA = function sA() {
      return _sA = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _sA.apply(this, arguments);
    },
    dA = function dA(e, t, n) {
      if (n || 2 === arguments.length) for (var r, l = 0, A = t.length; l < A; l++) {
        !r && l in t || (r || (r = Array.prototype.slice.call(t, 0, l)), r[l] = t[l]);
      }
      return e.concat(r || Array.prototype.slice.call(t));
    };
  var mA = function mA(e) {
    var t,
      l,
      A = e.timeslots,
      o = e.collectAtStoreSlots,
      a = (0, n.useRef)(),
      i = (0, n.useContext)(ur),
      c = i.onDeliveryDateAndTimeSelection,
      u = i.fulfilmentValue,
      s = i.setFulfilmentValueData,
      d = i.configs,
      m = Object.keys(A),
      E = m[0],
      g = m.slice(1),
      f = g[g.length - 1],
      p = function p(e) {
        var t,
          n,
          r = null === (t = A[Ur(e)]) || void 0 === t ? void 0 : t[0];
        return (null === (n = A[Ur(e)]) || void 0 === n ? void 0 : n.find(function (e) {
          var t;
          return e === (null === (t = null == d ? void 0 : d.preSelection) || void 0 === t ? void 0 : t.selectedTime);
        })) || r;
      },
      w = function () {
        var e;
        return (null === (e = Object.keys(A)) || void 0 === e ? void 0 : e.find(function (e) {
          var t;
          return e === (null === (t = null == d ? void 0 : d.preSelection) || void 0 === t ? void 0 : t.timeslot);
        })) || E;
      }(),
      h = (0, n.useState)(new Date(w)),
      C = h[0],
      B = h[1],
      x = (0, n.useState)(p(C)),
      I = x[0],
      b = x[1],
      O = f || w,
      T = function (e, t) {
        if (!e || !t) return null;
        var n = (0, Nr.eachDayOfInterval)({
          start: new Date(e),
          end: new Date(t)
        });
        return null == n ? void 0 : n.map(function (e) {
          var t = new Date((null == e ? void 0 : e.getTime()) + 288e5);
          return null == t ? void 0 : t.getTime();
        });
      }(E, O),
      D = function (e) {
        var t = null == e ? void 0 : e.map(function (e) {
          var t = null == e ? void 0 : e.split("/"),
            n = t[0],
            r = t[1],
            l = t[2],
            A = "".concat(l, "-").concat(null == n ? void 0 : n.padStart(2, "0"), "-").concat(null == r ? void 0 : r.padStart(2, "0"), "T00:00:00.000Z"),
            o = new Date(A);
          return null == o ? void 0 : o.getTime();
        });
        return t;
      }(Object.keys(A).slice(0)),
      S = function (e, t) {
        return null == e ? void 0 : e.reduce(function (e, n) {
          if (!(null == t ? void 0 : t.includes(n))) {
            var r = new Date(n);
            e.push(r);
          }
          return e;
        }, []);
      }(T, D),
      R = dA(dA([], S, !0), [{
        before: new Date(E),
        after: new Date(O)
      }], !1),
      k = A && C && (null === (t = A[Ur(C)]) || void 0 === t ? void 0 : t.map(function (e) {
        return {
          text: e,
          value: e
        };
      }));
    (0, n.useEffect)(function () {
      var e = {
        selectedDate: C,
        selectedTime: I
      };
      c && c(e), function (e) {
        if (u.pickupType === br) {
          var t = (n = Ur(C), null == o ? void 0 : o.find(function (e) {
            return Ur(new Date(e.slotDate)) === n && e.slotDesc === I;
          }));
          s({
            collectAtStoreTimeSlot: _sA(_sA({}, e), {
              selectedTimeSlot: t
            }),
            collectAtStoreValidity: !0
          });
        } else s({
          deliverySelectedSlot: e
        });
        var n;
      }(e);
    }, [C, I, o]);
    var L = null === (l = null == k ? void 0 : k.find(function (e) {
        return e.value === I;
      })) || void 0 === l ? void 0 : l.value,
      P = p(C);
    !L && P && b(P);
    var M = L || P;
    return r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.DatePicker.SingleDatePicker, {
      bgColor: "haze",
      label: v("DELIVERY_DATE"),
      value: C,
      disabledDays: R,
      onChange: B,
      onConfirm: function onConfirm(e) {
        a.current = e, B(e);
        var t = A[Ur(e)];
        (null == t ? void 0 : t.length) && b(t[0]);
      },
      onClear: function onClear() {
        B(new Date(w));
      },
      onBlur: function onBlur() {
        var e = a.current || new Date(w);
        B(e);
      }
    })), r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.DropdownInput, {
      id: "delivery-time",
      bgColor: "haze",
      label: v("DELIVERY_TIME"),
      value: M,
      items: k,
      onChange: function onChange(e) {
        b(e.value);
      }
    })));
  };
  var _EA = function EA() {
      return _EA = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _EA.apply(this, arguments);
    },
    gA = function gA(e, t, n) {
      if (n || 2 === arguments.length) for (var r, l = 0, A = t.length; l < A; l++) {
        !r && l in t || (r || (r = Array.prototype.slice.call(t, 0, l)), r[l] = t[l]);
      }
      return e.concat(r || Array.prototype.slice.call(t));
    },
    fA = function fA(e) {
      return "string" == typeof e ? -1 !== Rr.indexOf(e) : e.some(fA);
    },
    _pA = function pA() {
      return _pA = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _pA.apply(this, arguments);
    };
  var vA = function vA(e) {
    var t,
      l = e.pickupLocations,
      A = (0, n.useContext)(ur),
      o = A.onCollectAtStoreSelection,
      a = A.googleMapKey,
      i = void 0 === a ? "" : a,
      c = A.collectAtStoreSlots,
      u = void 0 === c ? [] : c,
      s = A.fulfilmentValue,
      d = A.setFulfilmentValueData,
      m = A.configs,
      E = (0, n.useState)(),
      g = E[0],
      f = E[1],
      p = (0, n.useState)(""),
      v = p[0],
      w = p[1],
      h = (0, n.useState)(),
      C = h[0],
      B = h[1],
      x = (0, n.useCallback)(function (e) {
        w(e.searchTerm), f(e);
      }, []),
      I = (u || []).map(function (e) {
        return _EA(_EA({}, e), {
          slotDate: Ur(new Date(e.slotDate))
        });
      }).reduce(function (e, t) {
        var n;
        return t.slotDate in e ? e[t.slotDate] = gA(gA([], e[t.slotDate], !0), [t.slotDesc], !1) : e = _EA(_EA({}, e), ((n = {})[t.slotDate] = [t.slotDesc], n)), e;
      }, {}),
      b = g && Object.keys(I).length > 0 && !C,
      O = null === (t = null == m ? void 0 : m.preSelection) || void 0 === t ? void 0 : t.mapPreSelection,
      T = function T(e) {
        var t = _pA(_pA({}, e), {
          searchTerm: v
        });
        o && o(t), d({
          collectAtStoreTimeSlotStore: t
        });
      };
    return (0, n.useEffect)(function () {
      b || d({
        collectAtStoreTimeSlot: null
      });
    }, [b]), (0, n.useEffect)(function () {
      C && T(null);
    }, [C]), (0, n.useEffect)(function () {
      var e = l.find(function (e) {
        return e.mtposId === (null == g ? void 0 : g.storeId);
      });
      T(e);
    }, [g, o]), r().createElement("div", {
      "data-testid": "collect-at-store"
    }, r().createElement(uA, {
      preSelection: O,
      pickupLocations: l,
      googleMapKey: i,
      collectAtStoreValidity: s.collectAtStoreValidity,
      onLocationSelected: x,
      onLocationSearchError: B
    }), (null == m ? void 0 : m.isCollectAtSoreTimeSlotLoading) ? r().createElement(y.Spacing, {
      responsive: !1,
      leftRight: 1,
      top: 2,
      "data-testid": "skeleton-item"
    }, r().createElement(y.SkeletonLoader, {
      preset: "ListItem",
      loading: !0
    })) : b && r().createElement(mA, {
      timeslots: I,
      collectAtStoreSlots: u
    }));
  };
  var wA = ["styles"];
  var hA = function hA(e) {
    e.styles;
    var t = Kt()(e, wA);
    return r().createElement("svg", Jt()({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      fill: "#DEDAFA",
      d: "M4 8h15v14H4z"
    }), r().createElement("path", {
      d: "M20 23.4H3c-.6 0-1-.4-1-1v-15c0-.6.4-1 1-1h17c.6 0 1 .4 1 1v15c0 .5-.4 1-1 1zm-16-2h15v-13H4v13z",
      fill: "#3B3B3B"
    }), r().createElement("path", {
      d: "M11.5 23.4c-.6 0-1-.4-1-1V4.3c0-.4.2-.8.4-1 .4-.6.7-1 1.1-1.4 1.4-1.2 3.5-1.2 4.9 0 .6.6 1.1 1.7 1.1 2.7 0 1-.4 2.4-2.7 3.7-.5.3-1.1.1-1.4-.4-.3-.5-.1-1.1.4-1.4.8-.4 1.7-1.1 1.7-1.9 0-.5-.2-1-.5-1.2-.6-.5-1.6-.5-2.2 0-.2.2-.5.5-.7.8l-.1.1v18c0 .6-.4 1.1-1 1.1z",
      fill: "#3B3B3B"
    }), r().createElement("path", {
      d: "M8.5 8.3c-.2 0-.3 0-.5-.1-2-1.1-2.4-2.5-2.4-3.4 0-1 .4-1.9 1-2.5 1.3-1.1 3.2-1.1 4.5 0 .4.3.7.7 1 1.2.3.5.1 1.1-.3 1.4-.5.3-1.1.1-1.4-.4-.2-.3-.4-.5-.6-.7-.5-.4-1.3-.4-1.8 0-.3.2-.4.6-.4 1 0 .7.8 1.2 1.4 1.6.5.3.7.9.4 1.4-.2.3-.5.5-.9.5z",
      fill: "#3B3B3B"
    }));
  };
  var CA = ["styles"];
  var BA = function BA(e) {
      e.styles;
      var t = Kt()(e, CA);
      return r().createElement("svg", Jt()({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r().createElement("path", {
        fill: "#DEDAFA",
        d: "M8 12h8v3H8z"
      }), r().createElement("path", {
        fill: "#DEDAFA",
        d: "M15 12h2v7h-2z"
      }), r().createElement("path", {
        d: "M18.5 23H6.2C4.5 23 3 21.7 3 20V4c0-1.7 1.5-3 3.2-3h8c.8 0 1.6.3 2.2.9l4.5 4.2c.6.6.9 1.3.9 2.1V20c0 1.7-1.5 3-3.3 3zM6.2 3C5.6 3 5 3.4 5 4v16c0 .6.6 1 1.2 1h12.3c.7 0 1.2-.4 1.2-1V8.2c0-.3-.1-.5-.3-.7L15 3.3c-.2-.2-.5-.3-.8-.3h-8z",
        fill: "#3B3B3B"
      }), r().createElement("path", {
        d: "M16.3 19.9H8.4c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h7.9c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2zM8.4 12v6h7.9v-6H8.4z",
        fill: "#3B3B3B"
      }), r().createElement("path", {
        d: "M10.8 13.5c-.6 0-1-.4-1-1V11c0-.6.4-1 1-1s1 .4 1 1v1.5c0 .6-.5 1-1 1zM14 13.5c-.6 0-1-.4-1-1V11c0-.6.4-1 1-1s1 .4 1 1v1.5c0 .6-.4 1-1 1zM14 19.9c-.6 0-1-.4-1-1v-2.4H7.5c-.6 0-1-.4-1-1s.4-1 1-1H14c.6 0 1 .4 1 1v3.4c0 .6-.4 1-1 1z",
        fill: "#3B3B3B"
      }));
    },
    yA = "MOBILE",
    xA = "proceed_section";
  var _IA = function IA() {
      return _IA = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _IA.apply(this, arguments);
    },
    bA = {
      h6: function h6(e) {
        return r().createElement(y.Text, _IA({}, e, {
          type: "smallBody"
        }));
      }
    };
  var OA = function OA(e) {
      var t = e.items,
        l = (e.hideLastUndeline, e.buyflowType),
        o = e.showQtyInMobileView,
        a = void 0 !== o && o,
        i = e.initialDisplayCount,
        c = void 0 === i ? 2 : i,
        u = e["data-testid"],
        s = (0, y.useTheme)(),
        d = Qr({
          items: t,
          showNumber: l === yA ? null == t ? void 0 : t.length : c
        }),
        m = d.showItems,
        E = d.showItemsText,
        g = d.onTriggerShowItems,
        f = function f(e) {
          if (!(null == e ? void 0 : e.imageSrc) && !(null == e ? void 0 : e.icon)) return null;
          if (!e.icon && e.imageSrc) return r().createElement(Ge, {
            src: e.imageSrc,
            alt: e.name,
            "data-testid": "list-item-image"
          });
          var t = function t(e) {
            return r().createElement(Ue, null, r().createElement(ze, {
              "data-testid": "list-item-icon"
            }, e));
          };
          switch (e.icon) {
            case "rewards":
              return t(r().createElement(hA, null));
            case "simcard":
              return t(r().createElement(BA, null));
            default:
              return t(r().createElement(ce.Icon, {
                name: e.icon,
                size: 26,
                color: s.cl_sec_d1
              }));
          }
        };
      return r().createElement(r().Fragment, null, r().createElement(ae, {
        size: "large",
        dataSource: m,
        "data-testid": u,
        renderItem: function renderItem(e, t) {
          var l, o;
          return r().createElement(n.Fragment, {
            key: e.id
          }, r().createElement(ae.Item, {
            nounderline: !0
          }, r().createElement(ae.Item.Meta, {
            avatar: f(e),
            title: r().createElement(r().Fragment, null, r().createElement(je, {
              type: "body",
              maxLine: 2
            }, e.ribbon && r().createElement("span", null, "".concat(e.ribbon, " ")), e.name), a && r().createElement(Ze, null, r().createElement(je, {
              type: "body",
              maxLine: 1
            }, e.quantity))),
            highlightedText: e.highlightedText,
            description: r().createElement(A.DynamicComponent, {
              htmlString: e.descRed ? "<h6><span style='color:".concat(null === (o = null === (l = s.theme.color) || void 0 === l ? void 0 : l.text) || void 0 === o ? void 0 : o.alert, "'>{placeholder}</span></h6>") : "<h6>{placeholder}</h6>",
              componentsToMap: bA,
              userInputData: {
                placeholder: e.description || ""
              }
            }),
            bundleImages: e.bundleImages
          }), function (e) {
            return ("string" != typeof (t = e.price) ? !isNaN(t) && null !== t : t) ? r().createElement(r().Fragment, null, r().createElement(Ke, {
              right: 6
            }, r().createElement(y.Text, {
              type: "body"
            }, e.quantity)), r().createElement(qe, null, r().createElement(y.Text, {
              type: "boldBody",
              "data-testid": "price-display"
            }, function (e) {
              var t = e.freebie,
                n = e.price;
              return t ? v("TEXT_FREE") : "string" == typeof n ? n : ie(n);
            }(e)), e.priceDescription && r().createElement(y.Text, {
              type: "smallBody"
            }, e.priceDescription))) : r().createElement(y.Text, {
              type: "body"
            }, e.quantity);
            var t;
          }(e)), !function (e) {
            return m.length === e + 1;
          }(t) && !1 !== e.showDivider && r().createElement(y.Divider, null));
        }
      }), l !== yA && E && r().createElement(y.TextLink, {
        onClick: g,
        "data-testid": "show-more-link"
      }, E));
    },
    TA = function TA(e) {
      var t,
        l = e.note,
        A = l.title ? r().createElement(y.Text, {
          type: "boldBody"
        }, r().createElement("div", {
          dangerouslySetInnerHTML: {
            __html: l.title
          }
        })) : null,
        o = l.content ? r().createElement(y.Text, {
          type: "smallBody"
        }, r().createElement("div", {
          dangerouslySetInnerHTML: {
            __html: l.content
          }
        })) : null,
        a = null === (t = l.content) || void 0 === t ? void 0 : t.split("."),
        i = a && a.length > 0 ? r().createElement(y.Text, {
          type: "smallBody"
        }, r().createElement("div", {
          dangerouslySetInnerHTML: {
            __html: a[0]
          }
        })) : null,
        c = (0, n.useState)(i),
        u = c[0],
        s = c[1],
        d = (0, n.useState)(v("SEARCH_MORE")),
        m = d[0],
        E = d[1];
      return (null == l ? void 0 : l.content) ? r().createElement(y.StatusAlert, {
        type: "info",
        title: A,
        bodyContent: r().createElement("div", null, u, r().createElement(y.TextLink, {
          onClick: function onClick() {
            m === v("SEARCH_MORE") ? (s(o), E(v("SEARCH_LESS"))) : (s(i), E(v("SEARCH_MORE")));
          },
          inline: !0
        }, m))
      }) : null;
    };
  var DA = ["styles"];
  var SA = function SA(e) {
    e.styles;
    var t = Kt()(e, DA);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40 38.7h-1.8V20.9l.28-.14a4.38 4.38 0 002.1-2.06 4.72 4.72 0 00-.38-4c-.41-.92-.89-1.8-1.36-2.65l-.26-.46a155.22 155.22 0 00-1.16-2.14l-.14-.25a4.4 4.4 0 00-3.8-2.2H14.53a4.39 4.39 0 00-3.79 2.2l-.14.25c-.41.7-.81 1.41-1.2 2.12l-.26.43c-.44.81-1 1.72-1.37 2.66a4.78 4.78 0 00-.38 4 4.48 4.48 0 002.18 2.14l.28.13V38.7H8a1.1 1.1 0 000 2.2h32a1.1 1.1 0 000-2.2zm-17.13 0H12.06V21.45h.48a6.19 6.19 0 001.81-.36 7 7 0 001.65-.93l.35-.35.29.39a4.29 4.29 0 003 1.23h1.16c.491.003.979-.081 1.44-.25l.67-.23-.04 17.75zm13.13 0H25.11V21l.67.23c.461.168.949.253 1.44.25h1.11a4.28 4.28 0 003-1.22l.3-.29.35.24c.519.38 1.088.686 1.69.91.604.218 1.238.34 1.88.36H36V38.7z",
      fill: "#3B3B3B"
    }), r().createElement("path", {
      d: "M25 9.06v8.06a2.26 2.26 0 002.26 2.25h1.11a2.25 2.25 0 002.25-2.25V9.06H25z",
      fill: "#EFEDFD"
    }), r().createElement("path", {
      d: "M17.44 9.06v8.06a2.25 2.25 0 002.25 2.25h1.11a2.26 2.26 0 002.26-2.25V9.06h-5.62z",
      fill: "#9A8EF2"
    }), r().createElement("path", {
      d: "M15.55 17.54V9.06h-1a2.33 2.33 0 00-2 1.16l-.18.32c-.39.67-.77 1.34-1.14 2l-.27.49c-.47.84-.91 1.64-1.28 2.48a2.9 2.9 0 00-.38 2.33 3.14 3.14 0 002.37 1.46 3.833 3.833 0 002-.18 5.31 5.31 0 001.7-1.06l.24-.22-.06-.3z",
      fill: "#EFEDFD"
    }), r().createElement("path", {
      d: "M38.37 15.53c-.37-.83-.8-1.61-1.29-2.5l-.26-.47c-.37-.68-.75-1.34-1.18-2.09l-.14-.25a2.36 2.36 0 00-2-1.16h-1v8.81l.25.21a5.39 5.39 0 001.69 1.06 4 4 0 001.35.24c.221 0 .442-.02.66-.06a3.14 3.14 0 002.37-1.46 2.9 2.9 0 00-.45-2.33z",
      fill: "#9A8EF2"
    }), r().createElement("path", {
      d: "M18.84 27.76v2.79M29.11 27.76v2.79",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  };
  var RA = ["styles"];
  var kA = function kA(e) {
    e.styles;
    var t = Kt()(e, RA);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      d: "M37.45 12H15v24.34h28.06V17.62a5.61 5.61 0 00-5.6-5.62h-.01z",
      fill: "#fff",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), r().createElement("path", {
      d: "M14.89 12a5.61 5.61 0 00-5.61 5.61v18.73h11.23V17.62a5.61 5.61 0 00-5.6-5.62h-.02z",
      fill: "#9A8EF2",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), r().createElement("path", {
      fill: "#fff",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M25.06 36.51h4.68V44h-4.68z"
    }), r().createElement("path", {
      d: "M34.13 4v4.68h7.49l-.94-2.34.94-2.34h-7.49z",
      fill: "#EFEDFD",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), r().createElement("path", {
      d: "M34.13 14.3V8.68",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), r().createElement("path", {
      d: "M20.51 17.74H7.14a2.19 2.19 0 00-2.2 2.2v9.69a2.2 2.2 0 002.19 2.21h13.38v-14.1z",
      fill: "#fff",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), r().createElement("path", {
      clipRule: "evenodd",
      d: "M20.51 17.74H7.14a2.19 2.19 0 00-2.2 2.2v.35l7.74 5.44c.97.68 2.261.68 3.23 0l4.6-3.23v-4.76z",
      stroke: "#3B3B3B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };
  var LA = ["styles"];
  var PA = function PA(e) {
    e.styles;
    var t = Kt()(e, LA);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("rect", {
      x: "6.03",
      y: "8.98",
      width: "16.3",
      height: "12.39",
      rx: "2.09",
      fill: "#fff",
      stroke: "#3B3B3B",
      strokeWidth: "2"
    }), r().createElement("rect", {
      x: "6.03",
      y: "24.66",
      width: "16.3",
      height: "14.36",
      rx: "2.25",
      fill: "#fff",
      stroke: "#3B3B3B",
      strokeWidth: "2"
    }), r().createElement("rect", {
      x: "25.67",
      y: "8.98",
      width: "16.3",
      height: "12.39",
      rx: "2.09",
      fill: "#fff",
      stroke: "#3B3B3B",
      strokeWidth: "2"
    }), r().createElement("rect", {
      x: "25.67",
      y: "24.66",
      width: "16.3",
      height: "14.36",
      rx: "2.25",
      fill: "#9A8EF2",
      stroke: "#3B3B3B",
      strokeWidth: "2"
    }), r().createElement("path", {
      d: "M38.06 32.56v2.12",
      stroke: "#fff",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  };
  var MA = ["styles"];
  var QA = function QA(e) {
    e.styles;
    var t = Kt()(e, MA);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("circle", {
      cx: "24.2",
      cy: "11.3",
      r: "5.9",
      fill: "#EFEDFD"
    }), r().createElement("path", {
      d: "M30.5 9.8c-.5-3.5-3.8-5.9-7.3-5.4-2.8.4-5 2.6-5.4 5.4h12.7zM38.1 44.6H19.8l.9-19.9h15.5l1.9 19.9z",
      fill: "#9A8EF2"
    }), r().createElement("ellipse", {
      cx: "37.399",
      cy: "33.7",
      rx: "2",
      ry: "2.7",
      fill: "#EFEDFD"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.3 34.9l-.2-3.3c0-.7-.4-1.3-.9-1.7-.4-.2-.8-.4-1.3-.4l-.3-4.8c0-.8-.7-1.4-1.5-1.4h-2.8c-.2-3-2.3-5.4-5-5.4-1.6 0-3.1.9-3.9 2.3h-7.8c-4.3 0-7.8 3.5-7.8 7.8v5.4c0 2.7 2.2 4.9 4.9 4.9h4.6l-.2 3.9V42.8l.1 1v.2c.1.7.7 1.2 1.5 1.2h17.4c.4 0 .8-.2 1.1-.5.3-.3.4-.7.4-1.1l-.3-6.5c.5 0 .9-.2 1.2-.5.6-.4.9-1 .8-1.7zM28.5 20c1.5 0 2.8 1.5 2.9 3.4h-5.9c.2-1.9 1.4-3.4 3-3.4zM10.9 33.4c0 1.6 1.3 2.9 2.9 2.9v-.1h4.7l.7-11.5c0-.8.7-1.4 1.5-1.4h2.8c.053-.16.078-.347.105-.548a4.92 4.92 0 01.095-.552h-7c-3.2 0-5.8 2.6-5.8 5.8v5.4zm9.3 9.8l-.1-.6V42.3l1-17h14.6l.3 5c-1.1.7-1.7 1.9-1.6 3.2 0 1.3.8 2.4 1.9 3l.3 6.7H20.2zm18-8.1h.1l.1-.1-.2-3.3v-.1H38c-1.1.4-1.6 1-1.6 1.9.1 1.1 1.1 1.4 1.8 1.6z",
      fill: "#3B3B3B"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34.2 8.6h-3c-1.3-4-5.6-6.3-9.6-5-4 1.3-6.3 5.6-5 9.6 1.3 4 5.6 6.3 9.6 5 3.2-1 5.4-4 5.4-7.3v-.3h2.6c.6 0 1-.4 1-1s-.4-1-1-1zM24 5.2c2.2 0 4.3 1.3 5.2 3.4H18.8c.9-2.1 2.9-3.4 5.2-3.4zm.2 11.6c3.1-.1 5.5-2.8 5.4-5.9 0-.1 0-.2-.1-.3H18.3v.8c.1 3.1 2.8 5.5 5.9 5.4z",
      fill: "#3B3B3B"
    }));
  };
  var NA = ["styles"];
  var HA = function HA(e) {
    e.styles;
    var t = Kt()(e, NA);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      fill: "#9A8EF2",
      d: "M3.16 23.03h25.23v10.01H3.16z"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M41.12 16.13l3.38 5a5.41 5.41 0 01.91 3.01v7.12A3.39 3.39 0 0142 34.62h-.7a5.11 5.11 0 01-10 0H17.79a5.11 5.11 0 01-10 0h-2.9a2.31 2.31 0 01-2.29-1.86V11.65a2.32 2.32 0 012.33-2.31h22.68a2.33 2.33 0 012.33 2.31v2.82h7.48c1.71 0 2.587 0 3.7 1.66zm-1.67 13.55l.17.13.23.18c.054.042.105.089.15.14l.2.15.08.09a.52.52 0 01.1.11l.17.22.11.15.12.2.07.11a.41.41 0 000 .09c.078.136.148.276.21.42.062.147.115.297.16.45a.748.748 0 010 .11c.09.14.09.31.09.35v.11H42a1.5 1.5 0 001.49-1.45v-7.07a3.43 3.43 0 00-.6-2l-3.38-5c-.6-.84-.83-.84-1.75-.84h-7.58a.23.23 0 00-.24.22V32.6h1.54a.519.519 0 010-.11c.02-.105.048-.208.08-.31v-.15c.05-.15.09-.26.16-.42.07-.16.14-.3.22-.45l.07-.13.17-.27.09-.12.19-.25.14-.16a1.57 1.57 0 01.18-.19l.15-.14.19-.18.16-.13.22-.15.17-.12.23-.14.18-.09c.078-.05.162-.09.25-.12l.18-.08.21-.08h.09l.16-.05.24-.06h.23l.33-.05h.11a5.68 5.68 0 011 0H37l.3.12h.19l.28.07.2.06.25.1h.15l.29.17.18.11.23.13.18.12.2.15zm-23.31.13l-.14-.13-.21-.15-.18-.12-.22-.14-.19-.1-.3-.14-.15-.03-.24-.09H14.3l-.3-.16h-.2l-.32-.05H13.31a5.548 5.548 0 00-1 0h-.16l-.32.05H11.6l-.24.06-.16.05h-.1l-.2.08-.15.06c-.062 0-.124.042-.187.085a1.533 1.533 0 01-.053.035l-.18.09-.23.14-.18.12-.21.15-.16.13-.22.2-.13.12a1.536 1.536 0 00-.16.18l-.04.13-.08.09-.17.23-.11.15-.17.27-.08.13c-.07.14-.14.28-.21.45a3.606 3.606 0 00-.16.42V32.27a.61.61 0 01-.044.189.968.968 0 00-.036.12.31.31 0 000 .11H4.93a.42.42 0 01-.43-.42v-8.34H28v8.76H17.84v-.11a.661.661 0 00-.047-.207c-.012-.033-.023-.067-.033-.102v-.15a4.403 4.403 0 00-.17-.45c-.06-.14-.13-.28-.2-.42a.472.472 0 00-.06-.09l-.06-.11-.13-.2a.845.845 0 00-.07-.1l-.07-.06-.16-.22-.13-.14-.18-.2-.19-.13-.2-.19zM28 22.13V11.65a.43.43 0 00-.39-.43H4.93a.43.43 0 00-.43.43v10.48H28z",
      fill: "#3B3B3B"
    }));
  };
  var FA,
    XA,
    VA = function VA(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    GA = h()(y.Spacing)(FA || (FA = VA(["\n  display: flex;\n"], ["\n  display: flex;\n"]))),
    zA = h()(y.Spacing)(XA || (XA = VA(["\n  svg {\n    height: 22px;\n    width: 22px;\n  }\n"], ["\n  svg {\n    height: 22px;\n    width: 22px;\n  }\n"]))),
    UA = function UA(e, t) {
      var n;
      void 0 === t && (t = 0);
      var r = document.getElementById(e);
      if (r) {
        var l = (null === (n = r.getBoundingClientRect()) || void 0 === n ? void 0 : n.top) + window.scrollY + t;
        window.scrollTo({
          top: l,
          behavior: "smooth"
        });
      }
    };
  var jA = function jA(e) {
      var t = e.items,
        l = e.onSelect,
        A = (0, n.useContext)(ur),
        o = A.configs,
        a = A.onResetSelection,
        i = A.setFulfilmentValueData,
        c = (0, n.useMemo)(function () {
          return t.sort(function (e, t) {
            return e.disabled && !t.disabled ? 1 : !e.disabled && t.disabled ? -1 : 0;
          });
        }, [t]),
        u = (0, n.useCallback)(function () {
          var e = null == c ? void 0 : c.find(function (e) {
            var t;
            return e.selected || e.type === (null === (t = null == o ? void 0 : o.preSelection) || void 0 === t ? void 0 : t.selectedDeliveryMode);
          });
          return e || c.find(function (e) {
            return !e.disabled;
          });
        }, [c]),
        s = (0, n.useState)(function () {
          var e;
          return null === (e = u()) || void 0 === e ? void 0 : e.type;
        }),
        d = s[0],
        m = s[1];
      return (0, n.useEffect)(function () {
        (null == o ? void 0 : o.resetSelection) && (m(null), i({
          pickupType: null
        }));
      }, [null == o ? void 0 : o.resetSelection]), (0, n.useEffect)(function () {
        l(d);
      }, [d]), (0, n.useEffect)(function () {
        t.find(function (e) {
          return e.type === d;
        }) || m(u());
      }, [t]), r().createElement(y.Row, null, null == c ? void 0 : c.map(function (e) {
        var t, n;
        return r().createElement(y.Column, {
          "data-testid": "fulfilment-mode-".concat(e.type),
          key: e.type,
          xs: 12,
          md: 1 === c.length ? 12 : 6,
          onClick: function onClick() {
            !function (e) {
              e && !e.disabled && m(e.type);
            }(e), a && a(!1);
          }
        }, r().createElement("div", null, r().createElement(y.Selector, {
          alignment: "row",
          selected: e.type === d && !e.disabled,
          disabled: e.disabled
        }, r().createElement(y.Selector.Body, {
          align: "start",
          title: (null == e ? void 0 : e.title) || (null === (t = kr[e.type]) || void 0 === t ? void 0 : t.title),
          subtitle: (n = e.charges, 0 === parseInt(n) ? v("FREE") : n),
          disabled: e.disabled
        }), function (e) {
          switch (e) {
            case Ir:
              return r().createElement(PA, null);
            case yr:
              return r().createElement(HA, null);
            case br:
              return r().createElement(SA, null);
            case xr:
              return r().createElement(QA, null);
            case Or:
              return r().createElement(kA, null);
          }
        }(e.type)), function (e) {
          if (!e.description) return null;
          var t = dr(e.icon);
          return r().createElement(GA, {
            topBottom: "4px"
          }, e.icon && r().createElement(zA, {
            right: "6px",
            top: "4px"
          }, r().createElement(t, null)), r().createElement(y.Text, {
            type: "smallBody"
          }, e.description));
        }(e)));
      }));
    },
    JA = function JA(e) {
      var t = e.title,
        l = e.note,
        A = e.id,
        o = e.pickupOption,
        a = e.items,
        i = e.onHandlePickup,
        c = e.deliverySlot,
        u = (e.deliveryTimeslot, e.popstations),
        s = e.popstationTimeslots,
        d = e.showBagTitle,
        m = e.onPopStationSelected,
        E = void 0 === m ? function () {} : m,
        g = (0, n.useContext)(ur),
        f = g.onDeliveryModeSelection,
        p = g.onRetrieveAppointmentSlot,
        v = (0, n.useState)(),
        w = v[0],
        h = v[1];
      return (0, n.useEffect)(function () {
        f && f(w), w && i(A, w), w !== yr && w !== xr && w !== Or || p(A, w);
      }, [w]), r().createElement("div", {
        "data-testid": "bag"
      }, d && r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(Fe, {
        alignY: "center"
      }, r().createElement(Ne, null, r().createElement(ce.Shop, null)), r().createElement(y.Text, {
        type: "boldBody"
      }, t)))), r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(OA, {
        items: a
      }))), l ? r().createElement(y.Spacing, {
        type: "margin",
        bottom: 1
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(TA, {
        note: l
      })))) : null, r().createElement(y.Spacing, {
        type: "margin",
        bottom: 2,
        responsive: !1
      }, (null == o ? void 0 : o.length) > 0 && r().createElement(jA, {
        items: o,
        onSelect: h
      })), w && function () {
        var e, t;
        switch (w) {
          case xr:
          case yr:
            var n = null === (e = o.find(function (e) {
                return e.type === w;
              })) || void 0 === e ? void 0 : e.explain,
              l = dr(null == n ? void 0 : n.icon);
            return r().createElement(r().Fragment, null, c && r().createElement(mA, {
              timeslots: c
            }), (null == n ? void 0 : n.message) ? r().createElement(y.Row, null, r().createElement(y.Column, {
              xs: 12
            }, r().createElement(y.Spacing, {
              type: "margin",
              top: 2.5
            }, r().createElement(Fe, {
              alignY: "top"
            }, l && r().createElement(Ne, null, r().createElement(l, null)), r().createElement(y.Text, null, null == n ? void 0 : n.message))))) : r().createElement(r().Fragment, null));
          case Ir:
            return r().createElement(Kr, {
              onPopStationSelected: E,
              bagId: A,
              popstations: u,
              popstationTimeslots: s
            });
          case br:
            var a = o.find(function (e) {
              return e.type === w;
            });
            return (null === (t = null == a ? void 0 : a.pickupLocations) || void 0 === t ? void 0 : t.length) ? r().createElement(vA, {
              pickupLocations: a.pickupLocations
            }) : null;
          default:
            return;
        }
      }());
    };
  var YA,
    KA,
    ZA,
    qA,
    WA = function WA(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _A = h().div(YA || (YA = WA(["\n  display: flex;\n  justify-items: center;\n"], ["\n  display: flex;\n  justify-items: center;\n"]))),
    $A = (h().div(KA || (KA = WA(["\n  margin-bottom: 16px;\n"], ["\n  margin-bottom: 16px;\n"]))), h()(y.Column)(ZA || (ZA = WA(["\n  padding: 8px 0;\n"], ["\n  padding: 8px 0;\n"]))), h()(y.Spacing)(qA || (qA = WA(["\n  @media (max-width: ", ") {\n    padding-bottom: 8px;\n  }\n"], ["\n  @media (max-width: ", ") {\n    padding-bottom: 8px;\n  }\n"])), function (e) {
      return e.coreTheme.brk_xs;
    }), function () {
      return $A = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, $A.apply(this, arguments);
    }),
    eo = {
      invalid: !1,
      message: null
    };
  var to = function to(e) {
    var t = e.visible,
      l = e.onClose,
      A = e.selectedConfirmAddress,
      o = e.onCreateAddress,
      a = (0, n.useContext)(ur),
      i = a.onSearchAddress,
      c = a.confirmAddress,
      u = a.configs,
      s = a.validFloors,
      d = void 0 === s ? [] : s,
      m = (0, n.useRef)(null),
      E = A || c,
      g = (0, n.useState)(null == E ? void 0 : E.postcode),
      f = g[0],
      p = g[1],
      w = (0, n.useState)(null == E ? void 0 : E.floor),
      h = w[0],
      C = w[1],
      B = (0, n.useState)(eo),
      x = B[0],
      I = B[1],
      b = (0, n.useState)(eo),
      O = b[0],
      D = b[1],
      S = (0, n.useState)(null == E ? void 0 : E.unitNumber),
      R = S[0],
      k = S[1],
      L = (0, n.useState)({
        status: !0,
        message: ""
      }),
      P = L[0],
      M = L[1];
    (0, n.useEffect)(function () {
      6 === (null == f ? void 0 : f.length) && Q();
    }, [c, null == u ? void 0 : u.doneFetchingAddress]);
    var Q = function Q() {
        var e,
          t = null === (e = m.current) || void 0 === e ? void 0 : e.value;
        switch (!0) {
          case !t:
            return M({
              status: !1,
              message: v("ENTER_POSTAL_CODE")
            });
          case t && Hr(t) && !c && (null == u ? void 0 : u.doneFetchingAddress):
          case !Hr(t):
            return M({
              status: !1,
              message: v("INVALID_POSTAL_CODE")
            });
          default:
            return M({
              status: !0,
              message: ""
            });
        }
      },
      N = function N(e) {
        Hr(e) && (C(""), k(""), D(eo), I(eo), i(e)), Q();
      },
      H = function H(e) {
        k(e);
        var t = Xr(e, d, h);
        I(t);
      },
      F = function F(e) {
        C(e), k("");
        var t = Fr(e, d);
        D(t);
      };
    return r().createElement(y.Modal, {
      "data-testid": "add-another-address-modal",
      visible: t,
      title: v("ADDRESS_FORM_DELIVERY_ADDRESS"),
      onClose: l,
      backdropClosable: !1
    }, r().createElement(y.Modal.Content, null, r().createElement(T, {
      type: "margin",
      bottom: 3
    }, r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.TextInput, {
      "data-testid": "postcode-input",
      ref: m,
      bgColor: "haze",
      label: v("ADDRESS_FORM_POSTAL_CODE"),
      placeholder: v("ADDRESS_FORM_POSTAL_CODE_PLACEHOLDER"),
      maxLength: 6,
      rightTextLink: {
        text: r().createElement(He, {
          "data-testid": "search-icon"
        }),
        onClick: function onClick(e, t) {
          var n;
          N(null === (n = m.current) || void 0 === n ? void 0 : n.value);
        }
      },
      value: f,
      onChange: function onChange(e) {
        var t;
        !function (e) {
          p(e), 6 === (null == e ? void 0 : e.length) && N(e);
        }(null === (t = e.target) || void 0 === t ? void 0 : t.value);
      }
    }), !1 === P.status && r().createElement(Yr, {
      type: "smallBody"
    }, P.message)))), E && Object.values(E).some(function (e) {
      return e;
    }) && r().createElement(r().Fragment, null, r().createElement(y.Row, null, (null == E ? void 0 : E.blockOrHouseNum) && r().createElement(y.Column, {
      xs: 12,
      md: 6
    }, r().createElement(y.TextInput, {
      label: v("ADDRESS_FORM_HOUSE_AND_BLOCK"),
      value: null == E ? void 0 : E.blockOrHouseNum,
      disabled: !A
    })), (null == E ? void 0 : E.streetName) && r().createElement(y.Column, {
      xs: 12,
      md: 6
    }, r().createElement(y.TextInput, {
      label: v("ADDRESS_FORM_STREET"),
      value: null == E ? void 0 : E.streetName,
      disabled: !A
    })), (null == E ? void 0 : E.buildingName) && r().createElement(y.Column, {
      xs: 12,
      md: 12
    }, r().createElement(y.TextInput, {
      label: v("ADDRESS_FORM_BUILDING"),
      value: null == E ? void 0 : E.buildingName,
      disabled: !A
    }))), (null == E ? void 0 : E.floor) && (null == E ? void 0 : E.unitNumber) && r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 6,
      md: 6
    }, r().createElement(y.TextInput, {
      "data-testid": "floor",
      error: O.invalid,
      hintMessage: O.message,
      bgColor: "haze",
      label: v("ADDRESS_FORM_FLOOR"),
      value: h,
      onChange: function onChange(e) {
        var t;
        F(null === (t = e.target) || void 0 === t ? void 0 : t.value);
      }
    })), r().createElement(y.Column, {
      xs: 6,
      md: 6
    }, r().createElement(y.TextInput, {
      "data-testid": "unit-number",
      error: x.invalid,
      hintMessage: x.message,
      bgColor: "haze",
      label: v("ADDRESS_FORM_UNIT"),
      value: R,
      onChange: function onChange(e) {
        var t;
        H(null === (t = e.target) || void 0 === t ? void 0 : t.value);
      }
    }))), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(T, {
      top: 2,
      Bottom: 1
    }, r().createElement(y.Button, {
      "data-testid": "confirm-address",
      onClick: function onClick() {
        var e;
        if (c && (null === (e = Object.keys(c)) || void 0 === e ? void 0 : e.length)) return !(d.length > 0) || h && R ? void ((P.status && !x.invalid && !O.invalid || 0 === d.length) && o($A($A({}, c), {
          floor: 0 === d.length ? "" : h,
          unitNumber: 0 === d.length ? "" : R
        }))) : (H(R), void F(h));
      }
    }, v("CONFIRM"))))))));
  };
  var _no = function no() {
      return _no = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _no.apply(this, arguments);
    },
    ro = function ro(e) {
      var t,
        l = e.onAddressSelected,
        A = (0, n.useContext)(ur),
        o = A.onSearchAddress,
        a = A.address,
        i = A.existingAddresses,
        c = A.confirmAddress,
        u = A.configs,
        s = A.onConfirmNewAddress,
        d = void 0 === s ? function () {} : s,
        m = A.onCloseAddressModal,
        E = void 0 === m ? function () {} : m,
        g = A.handleFulfilmentPageData,
        f = A.fulfilmentPageData,
        p = A.validFloors,
        w = A.showInlineAddressForm,
        h = void 0 !== w && w,
        C = (0, n.useState)(),
        B = C[0],
        x = C[1],
        I = (0, n.useState)(!1),
        b = I[0],
        O = I[1],
        T = (0, n.useRef)(B),
        D = (0, n.useState)((null === (t = null == u ? void 0 : u.preSelection) || void 0 === t ? void 0 : t.postCode) || ""),
        S = D[0],
        R = D[1],
        k = (0, n.useState)({
          postalCode: {
            isValid: !0,
            message: ""
          },
          floor: {
            isValid: !0,
            message: ""
          },
          unit: {
            isValid: !0,
            message: ""
          }
        }),
        L = k[0],
        P = k[1];
      (0, n.useEffect)(function () {
        if (h && (null == f ? void 0 : f.validateForm)) {
          var e = null == f ? void 0 : f.deliveryAddress;
          if (X(null == e ? void 0 : e.postcode), null == p ? void 0 : p.length) {
            var t = function (e, t, n) {
              var r = t ? t.padStart(2, "0").toLowerCase() : "",
                l = e ? e.padStart(2, "0").toLowerCase() : "";
              return n.find(function (e) {
                return e.unitNo.toLowerCase() === r && e.floorNo.toLowerCase() === l;
              }) ? {
                valid: !0,
                floor: "",
                unit: ""
              } : {
                valid: !1,
                floor: v("CC_E_API_POSTAL_FLOOR"),
                unit: v("CC_E_API_POSTAL_UNIT")
              };
            }(null == e ? void 0 : e.floor, null == e ? void 0 : e.unitNumber, p);
            t.valid ? g({
              isAddressValid: t.valid
            }) : P(function (e) {
              return _no(_no({}, e), {
                floor: {
                  isValid: t.valid,
                  message: t.floor
                },
                unit: {
                  isValid: t.valid,
                  message: t.unit
                }
              });
            });
          }
        } else B && g({
          isAddressValid: !0
        });
      }, [null == f ? void 0 : f.validateForm]), (0, n.useEffect)(function () {
        h && S && (g({
          deliveryAddress: _no({}, null != a ? a : {})
        }), X(S));
      }, [a]), (0, n.useEffect)(function () {
        var e;
        e = c || M(), !h && Q(e);
      }, [c, i]);
      var M = function M() {
          if (i && i.data) return i.data.find(function (e) {
            var t, n;
            return e.postcode === (null === (t = null == u ? void 0 : u.preSelection) || void 0 === t ? void 0 : t.address) || e.addressId === (null === (n = null == u ? void 0 : u.preSelection) || void 0 === n ? void 0 : n.address);
          }) || i.data[0];
        },
        Q = function Q(e) {
          x(e), l(e);
        },
        N = function N() {
          O(!0), T.current = B, x(c || null);
        },
        H = function H(e) {
          O(!1), d(e);
        },
        F = function F() {
          O(!1), x(T.current), E();
        },
        X = function X(e) {
          var t = function (e) {
              var t,
                n = e.postalCode,
                r = e.address;
              return n ? Hr(n) ? (null === (t = Object.keys(r)) || void 0 === t ? void 0 : t.length) ? {
                isValid: !0,
                message: ""
              } : {
                isValid: !1,
                message: v("INVALID_POSTAL_CODE")
              } : {
                isValid: !1,
                message: v("STORE_POSTAL")
              } : {
                isValid: !1,
                message: v("ENTER_POSTAL_CODE_FOR_ADDRESS")
              };
            }({
              postalCode: e,
              address: a
            }),
            n = t.isValid,
            r = t.message;
          P(function (e) {
            return _no(_no({}, e), {
              postalCode: {
                isValid: n,
                message: r
              }
            });
          });
        };
      return r().createElement("div", {
        "data-testid": "address-form"
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.Spacing, {
        type: "margin",
        bottom: 1
      }, r().createElement(y.Text, {
        type: "header"
      }, v("ADDRESS_FORM_DELIVERY_ADDRESS"))))), i ? function () {
        var e;
        return r().createElement(r().Fragment, null, b && r().createElement(to, {
          visible: b,
          onClose: F,
          selectedConfirmAddress: B,
          onCreateAddress: H
        }), r().createElement(y.Row, null, null === (e = i.data) || void 0 === e ? void 0 : e.map(function (e) {
          return r().createElement(y.Column, {
            "data-testid": "address-".concat(e.postcode),
            key: e.postcode,
            xs: 12,
            onClick: function onClick() {
              Q(e);
            }
          }, r().createElement(y.Selector, {
            alignment: "row",
            selected: e.addressId === (null == B ? void 0 : B.addressId)
          }, r().createElement(y.Selector.Body, {
            align: "start",
            title: Vr(e)
          })));
        })), !c && i.canAddNewAddress && r().createElement(y.Row, null, r().createElement(y.Spacing, {
          top: 2,
          left: 1,
          responsive: !1
        }, r().createElement(y.TextLink, {
          onClick: N
        }, v("USE_ANOTHER_ADDRESS")))), i.information && r().createElement(y.Spacing, {
          top: 1
        }, r().createElement(y.Row, null, function () {
          var e;
          return null === (e = i.information) || void 0 === e ? void 0 : e.map(function (e) {
            return r().createElement(y.Spacing, {
              left: 1,
              bottom: 1,
              responsive: !1
            }, r().createElement(_A, null, r().createElement(y.Spacing, {
              right: 1,
              top: "4px",
              responsive: !1
            }, e.icon ? r().createElement(ce.Attention, {
              size: 24
            }) : null), r().createElement(y.Text, null, e.text)));
          });
        }())), c && r().createElement(y.Spacing, {
          top: 3
        }, r().createElement(y.Row, null, r().createElement(y.Spacing, {
          left: 1
        }, r().createElement(y.Text, null, v("ADDED_FOR_THIS_ADDRESS")))), r().createElement(y.Row, null, function (e) {
          return r().createElement(y.Column, {
            "data-testid": "address-".concat(e.postcode),
            key: e.postcode,
            xs: 12,
            onClick: function onClick() {
              Q(e);
            }
          }, r().createElement(y.Selector, {
            alignment: "row",
            selected: e.addressId === (null == B ? void 0 : B.addressId)
          }, r().createElement(y.Selector.Body, {
            align: "start",
            title: Vr(e)
          })));
        }(c)), r().createElement(y.Row, null, r().createElement(y.Spacing, {
          left: 1
        }, r().createElement(y.TextLink, {
          onClick: N
        }, v("CHANGE_ADDRESS"))))));
      }() : function () {
        var e,
          t,
          n,
          l,
          A,
          i,
          c = null == f ? void 0 : f.deliveryAddress;
        return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
          type: "margin",
          bottom: 1
        }, r().createElement(y.Row, null, r().createElement(y.Column, {
          xs: 12
        }, r().createElement(y.TextInput, {
          bgColor: "haze",
          key: "delivery-address",
          label: v("ADDRESS_FORM_POSTAL_CODE"),
          placeholder: v("ADDRESS_FORM_POSTAL_CODE_PLACEHOLDER"),
          maxLength: 6,
          onChange: function onChange(e) {
            var t = e.target.value;
            R(t), Hr(t) && t !== (null == a ? void 0 : a.postcode) && o(t), X(t);
          },
          value: S,
          error: !(null === (e = null == L ? void 0 : L.postalCode) || void 0 === e ? void 0 : e.isValid),
          hintMessage: null === (t = L.postalCode) || void 0 === t ? void 0 : t.message,
          rightTextLink: {
            text: r().createElement(He, null)
          }
        })))), c && Object.values(c).some(function (e) {
          return e;
        }) && r().createElement(r().Fragment, null, r().createElement(y.Row, null, (null == c ? void 0 : c.blockOrHouseNum) && r().createElement(y.Column, {
          xs: 12,
          md: 6
        }, r().createElement(y.TextInput, {
          label: v("ADDRESS_FORM_HOUSE_AND_BLOCK"),
          value: null == c ? void 0 : c.blockOrHouseNum,
          disabled: !0
        })), (null == c ? void 0 : c.streetName) && r().createElement(y.Column, {
          xs: 12,
          md: 6
        }, r().createElement(y.TextInput, {
          label: v("ADDRESS_FORM_STREET"),
          value: c.streetName,
          disabled: !0
        })), c.buildingName && r().createElement(y.Column, {
          xs: 12,
          md: 6
        }, r().createElement(y.TextInput, {
          label: v("ADDRESS_FORM_BUILDING"),
          value: c.buildingName,
          disabled: !0
        }))), (null == p ? void 0 : p.length) > 0 && r().createElement(y.Row, null, r().createElement(y.Column, {
          xs: 6,
          md: 6
        }, r().createElement(y.TextInput, {
          bgColor: "haze",
          value: c.floor,
          error: !(null === (n = null == L ? void 0 : L.floor) || void 0 === n ? void 0 : n.isValid),
          hintMessage: null === (l = null == L ? void 0 : L.floor) || void 0 === l ? void 0 : l.message,
          onChange: function onChange(e) {
            var t,
              n = e.target.value,
              r = !function (e) {
                var t = Fr(e, p);
                return P(function (e) {
                  return _no(_no({}, e), {
                    floor: {
                      isValid: !(null == t ? void 0 : t.invalid),
                      message: null == t ? void 0 : t.message
                    }
                  });
                }), t.invalid;
              }(e.target.value);
            g({
              deliveryAddress: _no(_no({}, c), {
                floor: n
              }),
              isAddressValid: r && (null == c ? void 0 : c.unitNumber) && (null === (t = null == L ? void 0 : L.unit) || void 0 === t ? void 0 : t.isValid)
            });
          },
          label: v("ADDRESS_FORM_FLOOR")
        })), r().createElement(y.Column, {
          xs: 6,
          md: 6
        }, r().createElement(y.TextInput, {
          bgColor: "haze",
          value: c.unitNumber,
          error: !(null === (A = null == L ? void 0 : L.unit) || void 0 === A ? void 0 : A.isValid),
          hintMessage: null === (i = null == L ? void 0 : L.unit) || void 0 === i ? void 0 : i.message,
          onChange: function onChange(e) {
            var t,
              n = e.target.value,
              r = !function (e, t) {
                var n = Xr(e, p, t);
                return P(function (e) {
                  return _no(_no({}, e), {
                    unit: {
                      isValid: !(null == n ? void 0 : n.invalid),
                      message: null == n ? void 0 : n.message
                    }
                  });
                }), n.invalid;
              }(n, c.floor);
            g({
              deliveryAddress: _no(_no({}, c), {
                unitNumber: n
              }),
              isAddressValid: r && (null == c ? void 0 : c.floor) && (null === (t = null == L ? void 0 : L.floor) || void 0 === t ? void 0 : t.isValid)
            });
          },
          label: v("ADDRESS_FORM_UNIT")
        })))));
      }());
    },
    _lo = function lo() {
      return _lo = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _lo.apply(this, arguments);
    };
  var Ao = function Ao(e) {
    var t = e.showBagTitle,
      A = e.onPopStationSelected,
      o = (0, n.useContext)(ur),
      a = o.bags,
      i = o.onDeliveryModeSelected,
      c = void 0 === i ? function () {} : i,
      u = o.setFulfilmentValueData,
      s = o.configs,
      d = (0, n.useState)({}),
      m = d[0],
      E = d[1],
      g = (null == s ? void 0 : s.resetSelection) || !1,
      f = function f(e, t) {
        c(t), u({
          pickupType: t,
          collectAtStoreTimeSlot: null
        }), E(function (n) {
          var r;
          return _lo(_lo({}, n), ((r = {})[e] = t, r));
        });
      };
    return (null == a ? void 0 : a.length) ? r().createElement("div", {
      "data-testid": "delivery-content"
    }, a.map(function (e, n) {
      var o = e.pickup,
        i = e.deliverySlot,
        c = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["pickup", "deliverySlot"]),
        u = n !== a.length - 1;
      return r().createElement(r().Fragment, null, r().createElement(JA, _lo({
        key: e.id
      }, c, {
        onPopStationSelected: A,
        title: v("BAG_NUMBER", {
          count: l(n + 1)
        }),
        pickupOption: o,
        deliverySlot: i,
        onHandlePickup: f,
        showBagTitle: t
      })), u && r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.Spacing, {
        topBottom: 3
      }, r().createElement(y.Divider, null)))));
    }), fA(Object.values(m)) && !g && r().createElement(r().Fragment, null, r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.Spacing, {
      topBottom: 3
    }, r().createElement(y.Divider, null)))), r().createElement(ro, {
      onAddressSelected: function onAddressSelected(e) {
        u({
          address: e
        });
      }
    }))) : null;
  };
  var oo,
    ao,
    io = function io(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _co = function co() {
      return _co = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _co.apply(this, arguments);
    },
    uo = (0, y.withTheme)(h()(y.Grid)(ao || (ao = io(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(oo || (oo = io(["\n    margin-bottom: 16px;\n    padding-top: 0px;\n    @media (min-width: ", ") {\n      padding-bottom: 80px;\n      padding-top: 8px;\n    }\n    @media (min-width: ", ") {\n      padding-bottom: 80px;\n      padding-top: 8px;\n    }\n  "], ["\n    margin-bottom: 16px;\n    padding-top: 0px;\n    @media (min-width: ", ") {\n      padding-bottom: 80px;\n      padding-top: 8px;\n    }\n    @media (min-width: ", ") {\n      padding-bottom: 80px;\n      padding-top: 8px;\n    }\n  "])), t.brk_md, t.brk_lg);
    })),
    so = function so(e) {
      var t = e.data,
        l = e.configs,
        A = e.callbacks,
        o = (0, n.useState)({
          status: !0
        }),
        a = o[0],
        i = o[1],
        c = (0, n.useState)({
          pickupType: "",
          collectAtStoreValidity: !0,
          collectAtStoreTimeSlot: null
        }),
        u = c[0],
        s = c[1],
        d = function d(e) {
          s(function (t) {
            return _co(_co({}, t), e);
          });
        },
        m = _co(_co(_co({}, A), t), {
          validateResult: a,
          configs: l,
          fulfilmentValue: u,
          setFulfilmentValueData: d
        }),
        E = l.showBagTitle;
      return r().createElement(ur.Provider, {
        value: m
      }, r().createElement(uo, {
        "data-testid": "fulfillment-section"
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12,
        md: 7
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.Spacing, {
        bottom: "8px"
      }, r().createElement(y.Text, {
        type: "pageTitle"
      }, v("PAGE_TITLE_DELIVERY"))))), r().createElement(Ao, {
        onPopStationSelected: function onPopStationSelected(e) {
          d({
            popStation: e
          });
        },
        showBagTitle: E
      }), r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12,
        md: 4
      }, r().createElement(y.Spacing, {
        top: 3,
        bottom: 2
      }, r().createElement(y.Button, {
        "data-testid": "proceed-fulfilment",
        onClick: function onClick() {
          l.isCollectAtSoreTimeSlotLoading || (function () {
            var e;
            u.pickupType !== br || (null === (e = u.collectAtStoreTimeSlotStore) || void 0 === e ? void 0 : e.name) || d({
              collectAtStoreValidity: !1
            });
          }(), i(function () {
            var e, t;
            return (null === (t = null === (e = null == u ? void 0 : u.popStation) || void 0 === e ? void 0 : e.popStation) || void 0 === t ? void 0 : t.postcode) ? {
              status: !0,
              message: ""
            } : {
              status: !1,
              message: ""
            };
          }()), null == A || A.onProceed(u));
        },
        fullWidth: !0
      }, v("BUTTON_PROCEED")))))))));
    };
  var mo = function mo(e) {
    var t = e.orderStatus,
      n = e.overrideIcon,
      l = v("ORDER_STATUS_TITLE"),
      A = v("ORDER_STATUS_BOLD_TEXT"),
      o = v("ORDER_STATUS_BODY_TEXT");
    return r().createElement(y.Row, null, t && r().createElement(y.Column, {
      xs: 12
    }, function (e) {
      if (r().isValidElement(n)) return n.props.size ? n : r().cloneElement(n, {
        size: "60"
      });
      switch (e) {
        case "success":
          return r().createElement(ce.Completed, {
            size: "60"
          });
        case "failure":
          return r().createElement(ce.Alert, {
            size: "60"
          });
        case "pending":
          return r().createElement(ce.InProgress, {
            size: "60"
          });
        default:
          return null;
      }
    }(t)), t && "ORDER_STATUS_TITLE" !== l ? r().createElement(y.Column, {
      xs: 12,
      noGutter: !0
    }, r().createElement(y.Text, {
      type: "sectionTitle"
    }, l)) : null, A && "ORDER_STATUS_BOLD_TEXT" !== A ? r().createElement(y.Column, {
      xs: 12,
      noGutter: !0
    }, r().createElement(y.Text, {
      type: "boldBody"
    }, A)) : null, o && "ORDER_STATUS_BODY_TEXT" !== o ? r().createElement(y.Column, {
      xs: 12,
      noGutter: !0
    }, r().createElement(y.Text, {
      type: "smallBody"
    }, o)) : null);
  };
  var Eo,
    go,
    fo = function fo(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    po = (0, w.keyframes)(Eo || (Eo = fo(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"]))),
    vo = h()(ce.Loading)(go || (go = fo(["\n  display: inline-block;\n  animation: ", " 2s linear infinite;\n"], ["\n  display: inline-block;\n  animation: ", " 2s linear infinite;\n"])), po);
  var wo = function wo() {
      var e = (0, y.useTheme)();
      return r().createElement(vo, {
        size: 24,
        color: e.cl_sec_d1
      });
    },
    ho = function ho(e) {
      var t = e.orderNo,
        l = e.isLoading,
        A = void 0 !== l && l,
        o = (0, n.useState)(v("ACTION_BUTTON_COPY")),
        a = o[0],
        i = o[1];
      return r().createElement("div", null, r().createElement(y.Card, {
        shadow: "sm",
        radius: "sm",
        padding: "sm"
      }, r().createElement(y.Card.Content, null, r().createElement(y.Row, null, r().createElement(y.Column, null, r().createElement(y.Row, null, r().createElement(y.Text, {
        type: "boldBody"
      }, A ? v("ORDER_INFO_TITLE_LOADING") : t)), r().createElement(y.Row, null, r().createElement(y.Text, {
        type: "smallBody"
      }, v(A ? "ORDER_INFO_SUBTITLE_LOADING" : "ORDER_INFO_SUBTITLE")))), r().createElement(y.Column, {
        xs: 3
      }, r().createElement(y.Row, {
        end: "xs"
      }, A ? r().createElement(wo, null) : r().createElement(y.TextLink, {
        onClick: function onClick(e) {
          var n, r;
          t && (i(v("ACTION_BUTTON_COPIED")), /MSIE|TRIDENT/.test(navigator.userAgent) ? null === (n = e.clipboardData) || void 0 === n || n.setData("Text", t) : null === (r = navigator.clipboard) || void 0 === r || r.writeText(t));
        },
        "data-testid": "copy-order-no"
      }, a)))))));
    };
  var Co = ["styles"];
  var Bo = function Bo(e) {
      e.styles;
      var t = Kt()(e, Co);
      return r().createElement("svg", Jt()({
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, t), r().createElement("path", {
        fill: "url(#prefix__pattern0)",
        d: "M0 0h32v32H0z"
      }), r().createElement("defs", null, r().createElement("pattern", {
        id: "prefix__pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, r().createElement("use", {
        xlinkHref: "#prefix__image0_5911_72303",
        transform: "matrix(.0005 0 0 .0005 0 -.001)"
      })), r().createElement("image", {
        id: "prefix__image0_5911_72303",
        width: "1984",
        height: "1988",
        xlinkHref: "data:image/png;base64,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"
      })));
    },
    yo = function yo(e) {
      e.customerEmail;
      var t = e.customerSupport || {},
        n = t.email,
        l = t.domesticNumber,
        A = t.availableTime,
        o = t.showContact,
        a = void 0 === o || o,
        i = t.whatsapp,
        c = t.whatsappAvailableTime,
        u = t.domesticNumberText;
      return r().createElement(r().Fragment, null, a && r().createElement(y.Layout.Stack, null, l && r().createElement(y.Row, {
        start: "xs"
      }, r().createElement(y.Column, {
        xs: 12,
        noGutter: !0
      }, r().createElement("a", {
        href: "tel:".concat(l)
      }, r().createElement(y.ListItem, {
        body: [{
          title: u || l
        }, {
          subTitle: A
        }],
        leftContent: r().createElement(y.ListItem.Icon, {
          icon: ce.PhoneContact
        })
      })))), n && r().createElement(y.Row, {
        start: "xs"
      }, r().createElement(y.Column, {
        xs: 12,
        noGutter: !0
      }, r().createElement("a", {
        href: "mailto:".concat(n)
      }, r().createElement(y.ListItem, {
        body: [{
          title: n
        }],
        leftContent: r().createElement(y.ListItem.Icon, {
          icon: ce.Mail
        })
      })))), i && r().createElement(y.Row, {
        start: "xs"
      }, r().createElement(y.Column, {
        xs: 12,
        noGutter: !0
      }, r().createElement("a", {
        target: "_blank",
        href: "https://wa.me/".concat(i)
      }, r().createElement(y.ListItem, {
        body: [{
          title: v("CHAT_ON_WHATS_APP")
        }, {
          subTitle: c
        }],
        leftContent: r().createElement(Bo, null)
      }))))));
    },
    xo = function xo(e) {
      var t = e.promotions;
      return t && t.length > 0 ? r().createElement(r().Fragment, null, r().createElement(y.Row, null, r().createElement(y.Text, {
        type: "boldBody"
      }, v("ORDER_PROMOTION_TITLE"))), r().createElement(y.Layout.Stack, null, t.map(function (e) {
        var t = e || {},
          n = t.title,
          l = t.subTitle,
          A = t.imgSrc,
          o = t.promoLink;
        return r().createElement(y.Row, {
          start: "xs"
        }, r().createElement(y.Column, {
          xs: 12,
          noGutter: !0
        }, r().createElement("a", {
          href: o
        }, r().createElement(y.ListItem, {
          body: [{
            title: n
          }, {
            subTitle: l
          }],
          leftContent: r().createElement(y.ListItem.Image, {
            src: A
          })
        }))));
      }))) : null;
    },
    Io = function Io(e) {
      var t = e.onClick;
      return r().createElement(r().Fragment, null, r().createElement(y.Card, {
        shadow: "sm",
        radius: "sm",
        padding: "sm"
      }, r().createElement(y.Card.Content, null, r().createElement(y.Column, null, r().createElement(y.Text, null, v("ORDER_FEEDBACK_TEXT"))), r().createElement(y.Column, null, r().createElement(y.Button, {
        secondary: !0,
        onClick: t
      }, v("ACTION_BUTTON_SHARE_FEEDBACK"))))));
    };
  var bo = function bo(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Oo = (0, y.withTheme)(h()(y.Row)(ko || (ko = bo(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  background: ", ";\n"], ["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  background: ", ";\n"])), function (e) {
      return e.isMobile ? "24px" : "46.4px";
    }, function (e) {
      return e.isMobile ? "32px" : "48px";
    }, function (e) {
      return e.coreTheme.cl_ter_l6;
    })),
    To = h().div(Lo || (Lo = bo(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 8px;\n  svg {\n    margin-right: 10px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 8px;\n  svg {\n    margin-right: 10px;\n  }\n"]))),
    Do = h().div(Po || (Po = bo(["\n  padding-bottom: 16px;\n"], ["\n  padding-bottom: 16px;\n"]))),
    So = h()(y.Text)(Mo || (Mo = bo(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
  var Ro = function Ro(e) {
    var t = e.customerSupport,
      n = e.customContent,
      l = (0, y.useDevice)().isMobile,
      A = t || {},
      o = A.overseaNumber,
      a = A.domesticNumber,
      i = A.availableTime,
      c = A.email;
    return r().createElement(Oo, {
      isMobile: l,
      center: "xs",
      className: "help-box-footer"
    }, r().createElement(y.Column, {
      noGutter: !0,
      xs: 10,
      lg: 9
    }, n ? r().createElement(r().Fragment, null, n) : r().createElement(r().Fragment, null, r().createElement(Do, null, r().createElement(y.Row, null, r().createElement(y.Text, {
      type: "sectionTitle"
    }, v("ORDER_HELP_TITLE"))), r().createElement(y.Row, null, r().createElement(y.Text, {
      type: "smallBody"
    }, v("ORDER_HELP_SUBTITLE")))), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12,
      md: 6,
      noGutter: !0
    }, r().createElement(y.Row, null, r().createElement(To, null, r().createElement(ce.PhoneContact, {
      size: "24",
      color: "black"
    }), r().createElement(y.Text, {
      type: "boldBody"
    }, v("ORDER_HELP_CALL_FROM_SINGAPORE")))), r().createElement(y.Row, null, r().createElement(So, {
      type: "smallBody"
    }, i)), r().createElement(y.Row, null, r().createElement(y.TextLink, {
      href: "tel:" + a
    }, a))), r().createElement(y.Column, {
      xs: 12,
      md: 6,
      noGutter: !0
    }, r().createElement(y.Row, null, r().createElement(To, null, r().createElement(ce.Mail, {
      size: "24",
      color: "black"
    }), r().createElement(y.Text, {
      type: "boldBody"
    }, v("ORDER_HELP_EMAIL")))), r().createElement(y.Row, null, r().createElement(y.TextLink, {
      href: "mailto:" + c
    }, c)))), !!o && r().createElement(y.Row, null, r().createElement(y.Text, {
      type: "boldBody"
    }, v("ORDER_HELP_CALL_FROM_OVERSEAS")), r().createElement(y.TextLink, {
      href: "tel:" + o
    }, o)))));
  };
  var ko, Lo, Po, Mo;
  var Qo = function Qo(e) {
    var t = e.customerEmail,
      n = void 0 === t ? "" : t,
      l = e.customContent,
      A = void 0 === l ? null : l;
    return r().createElement(y.Row, {
      start: "xs"
    }, r().createElement(y.Column, {
      xs: 12,
      noGutter: !0
    }, r().createElement(y.Text, {
      type: "header"
    }, v("ORDER_WHAT_NEXT_TITLE"))), r().createElement(y.Column, {
      xs: 12,
      noGutter: !0
    }, A ? r().createElement(r().Fragment, null, A) : r().createElement(y.Text, {
      type: "smallBody"
    }, v("ORDER_WHAT_NEXT_TEXT", {
      customerEmail: n
    }))));
  };
  var No = function No(e) {
      var t = e.title,
        n = e.data,
        l = void 0 === n ? [] : n;
      return r().createElement(y.Row, {
        start: "xs"
      }, r().createElement(y.Column, {
        noGutter: !0,
        xs: 12
      }, r().createElement(y.Spacing, {
        bottom: .1
      }, r().createElement(y.Text, {
        type: "header"
      }, t)), l.map(function (e) {
        return r().createElement(y.Spacing, {
          top: 1
        }, r().createElement(y.TextLink, {
          "data-testid": "help-link",
          onClick: e.url ? function () {
            return window.open(e.url, "_blank");
          } : e.onClick
        }, e.text));
      })));
    },
    Ho = function Ho(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Fo = h().img(zo || (zo = Ho(["\n  width: 596px;\n  height: 176px;\n"], ["\n  width: 596px;\n  height: 176px;\n"]))),
    Xo = h().img(Uo || (Uo = Ho(["\n  width: 312px;\n  height: 174px;\n"], ["\n  width: 312px;\n  height: 174px;\n"]))),
    Vo = (0, y.withTheme)(h()(y.Text)(jo || (jo = Ho(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (e) {
      return e.coreTheme.cl_ter_l3;
    }));
  var Go = function Go(e) {
    var t = e.promocode,
      l = void 0 === t ? {} : t,
      A = l.distributePromoCode,
      o = l.distributeLoading;
    if (!A) return null;
    var a = A.redumptionEndDate,
      i = A.imagePath,
      c = A.text,
      u = A.couponCode,
      s = A.campaignGroup,
      d = (0, n.useState)(v("THANK_YOU_COPY")),
      m = d[0],
      E = d[1],
      g = parseInt(a),
      f = new Date(g).toLocaleDateString("en-UK", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      }),
      p = (0, y.useDevice)().isMobile,
      w = "".concat(i).concat(s, "_desktop.jpg"),
      h = "".concat(i).concat(s, "_mobile.jpg");
    return r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Column, {
      noGutter: !0,
      xs: 12
    }, r().createElement(y.Divider, null), r().createElement(y.Spacing, {
      top: 4,
      bottom: 2
    }, r().createElement(y.Text, {
      type: "header"
    }, v("THANK_YOU_A_LITTLE_SOMETHING_FOR_YOU"))), r().createElement(y.Column, null, r().createElement(y.Row, {
      center: "xs"
    }, p ? r().createElement(Xo, {
      src: h,
      alt: "Image of Singtel Bill"
    }) : r().createElement(Fo, {
      src: w,
      alt: "Image of Singtel Bill"
    })), r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Spacing, {
      top: 2
    }, r().createElement(y.Text, {
      type: "boldBody"
    }, c)))), r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Text, {
      type: "smallBody"
    }, v("THANK_YOU_VALID_UNTIL_DATE", {
      endDate: f
    }))), r().createElement(y.Spacing, {
      top: 2,
      bottom: 3
    }, r().createElement(y.Card, {
      shadow: "sm",
      radius: "sm",
      padding: "sm"
    }, r().createElement(y.Card.Content, null, r().createElement(y.Row, null, r().createElement(y.Column, null, r().createElement(y.Row, null, o ? v("THANK_YOU_LOADING_PROMO_CODE") : r().createElement(y.Text, {
      type: "boldBody"
    }, u)), r().createElement(y.Row, null, r().createElement(Vo, {
      type: "smallBody"
    }, v("THANK_YOU_PROMO_CODE")))), r().createElement(y.Column, {
      xs: 3
    }, r().createElement(y.Row, {
      end: "xs"
    }, o ? r().createElement(wo, null) : r().createElement(y.TextLink, {
      onClick: function onClick(e) {
        var t, n;
        u && (E(v("THANK_YOU_COPIED")), /MSIE|TRIDENT/.test(navigator.userAgent) ? null === (t = e.clipboardData) || void 0 === t || t.setData("Text", u) : null === (n = navigator.clipboard) || void 0 === n || n.writeText(u));
      },
      "data-testid": "copy-promo-no"
    }, m)))))))));
  };
  var zo,
    Uo,
    jo,
    Jo = h().div(Ko || (Ko = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  background-color: #f0f0f0;\n  text-align: left;\n  border-radius: 10px;\n"], ["\n  background-color: #f0f0f0;\n  text-align: left;\n  border-radius: 10px;\n"])));
  var Yo = function Yo(e) {
    var t = e.importantNote,
      n = (0, y.useDevice)().isMobile,
      l = t.title,
      A = t.content;
    return r().createElement(y.Spacing, {
      top: n ? 0 : 1
    }, r().createElement(Jo, null, r().createElement(y.Spacing, {
      topBottom: 2,
      leftRight: 2
    }, r().createElement(y.Spacing, {
      bottom: n ? .5 : .1
    }, r().createElement(y.Text, {
      type: "boldBody"
    }, l)), r().createElement(y.Text, {
      type: "smallBody"
    }, A))));
  };
  var Ko,
    Zo = function Zo(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    qo = h().img($o || ($o = Zo(["\n  width: 596px;\n  height: 176px;\n"], ["\n  width: 596px;\n  height: 176px;\n"]))),
    Wo = h().img(ea || (ea = Zo(["\n  width: 312px;\n  height: 174px;\n"], ["\n  width: 312px;\n  height: 174px;\n"])));
  var _o = function _o(e) {
    var t = e.lihook;
    if (!t) return null;
    var n = t.desktopImgSrc,
      l = t.mobileImgSrc,
      A = (0, y.useDevice)().isMobile;
    return r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Column, {
      noGutter: !0,
      xs: 12
    }, r().createElement(y.Divider, null), r().createElement(y.Spacing, {
      top: 4,
      bottom: 2
    }, r().createElement(y.Text, {
      type: "header"
    }, v("THANK_YOU_MAY_ALSO_CONSIDER"))), r().createElement(y.Column, null, r().createElement(y.Row, {
      center: "xs"
    }, A ? l && r().createElement(Wo, {
      src: l,
      alt: "Image of Singtel Bill"
    }) : n && r().createElement(qo, {
      src: n,
      alt: "Image of Singtel Bill"
    })), r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Spacing, {
      top: 2
    }, r().createElement(y.Text, {
      type: "boldBody"
    }, v("THANK_YOU_COMPLIMENTARY_BILL_RELIEF"))))), r().createElement(y.Row, {
      center: "xs"
    }, r().createElement(y.Text, {
      type: "smallBody"
    }, v("THANK_YOU_MOBILE_BILLS_COVERED")))));
  };
  var $o,
    ea,
    ta,
    na,
    ra,
    la,
    Aa,
    oa,
    aa = function aa(e) {
      var t = e.title,
        n = e.data;
      return r().createElement(y.Row, {
        start: "xs"
      }, r().createElement(y.Column, {
        noGutter: !0,
        xs: 12
      }, r().createElement(y.Spacing, {
        bottom: 1,
        responsive: !1
      }, r().createElement(y.Text, {
        type: "header",
        "data-testid": "title"
      }, t)), null == n ? void 0 : n.map(function (e, t) {
        return r().createElement(y.BulletList, {
          key: t,
          "data-testid": "bullet-list-item-".concat(t)
        }, e);
      })));
    },
    ia = function ia(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    ca = h()(y.Row)(ta || (ta = ia(["\n  padding: 1rem 0;\n"], ["\n  padding: 1rem 0;\n"]))),
    ua = (h()(y.Column)(na || (na = ia(["\n  padding: 0.75rem 0;\n"], ["\n  padding: 0.75rem 0;\n"]))), function (e) {
      var t = e.configs,
        n = e.data,
        l = e.callbacks,
        A = e.localisation,
        o = (0, y.useDevice)().isMobile,
        a = n.customContent,
        i = n.orderNo,
        c = n.customerEmail,
        u = n.customerSupport,
        s = void 0 === u ? {} : u,
        d = n.promotions,
        m = void 0 === d ? [] : d,
        E = n.helpLinks,
        g = void 0 === E ? {
          data: [],
          title: ""
        } : E,
        f = n.bulletList,
        w = void 0 === f ? {
          data: [],
          title: ""
        } : f,
        h = n.isLoading,
        C = void 0 !== h && h,
        B = n.promocode,
        x = void 0 === B ? {} : B,
        I = n.importantNote,
        b = n.lihook,
        O = t.orderStatus,
        T = void 0 === O ? "success" : O,
        D = t.overrideIcon,
        S = t.displayMapping,
        R = void 0 === S ? [{
          itemType: Mr.SECTION_TYPES.ORDER_STATUS
        }, {
          itemType: Mr.SECTION_TYPES.ORDER_INFO
        }, {
          itemType: Mr.SECTION_TYPES.IMPORTANT_NOTE
        }, {
          itemType: Mr.SECTION_TYPES.NEXT_STEP
        }, {
          itemType: Mr.SECTION_TYPES.PROMOTION_CARD
        }, {
          itemType: Mr.SECTION_TYPES.FEEDBACK_CARD
        }, {
          itemType: Mr.SECTION_TYPES.BACK_HOME
        }, {
          itemType: Mr.SECTION_TYPES.HELP_BOX
        }, {
          itemType: Mr.SECTION_TYPES.PROMO_CODE
        }, {
          itemType: Mr.SECTION_TYPES.LI_HOOK_INSURANCE
        }, {
          itemType: Mr.SECTION_TYPES.BULLET_LIST
        }] : S;
      p(A);
      var k = l.onClickBackBtn,
        L = l.onClickFeedbackBtn;
      return r().createElement(y.Layout.Stack, {
        space: 2
      }, R.map(function (e) {
        switch ((e || {}).itemType) {
          case Mr.SECTION_TYPES.ORDER_STATUS:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 12,
              lg: 6
            }, r().createElement(y.Spacing, {
              bottom: 1
            }, r().createElement(mo, {
              orderStatus: T,
              overrideIcon: D
            }))));
          case Mr.SECTION_TYPES.ORDER_INFO:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(ho, {
              orderNo: i,
              isLoading: C
            })));
          case Mr.SECTION_TYPES.IMPORTANT_NOTE:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(Yo, {
              importantNote: I
            })));
          case Mr.SECTION_TYPES.WHAT_NEXT:
            return r().createElement(y.Spacing, {
              top: 1
            }, r().createElement(ca, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(Qo, {
              customContent: a && a[Mr.SECTION_TYPES.WHAT_NEXT],
              customerEmail: c
            }))));
          case Mr.SECTION_TYPES.NEXT_STEP:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(yo, {
              customerEmail: c,
              customerSupport: s
            })));
          case Mr.SECTION_TYPES.YOU_MAY_NEED_TO_KNOW:
            return r().createElement(y.Spacing, {
              bottom: o ? 3 : 4
            }, r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(No, {
              title: g.title,
              data: g.data
            }))));
          case Mr.SECTION_TYPES.FEEDBACK_CARD:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(Io, {
              onClick: L
            })));
          case Mr.SECTION_TYPES.BACK_HOME:
            return r().createElement(y.Spacing, {
              bottom: o ? 4 : 5
            }, r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10
            }, r().createElement(y.Button, {
              fullWidth: o,
              secondary: !0,
              onClick: k
            }, v("ACTION_BUTTON_BACK_TO_HOME")))));
          case Mr.SECTION_TYPES.HELP_BOX:
            return r().createElement(Ro, {
              customContent: a && a[Mr.SECTION_TYPES.HELP_BOX],
              customerSupport: s
            });
          case Mr.SECTION_TYPES.PROMOTION_CARD:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(xo, {
              promotions: m
            })));
          case Mr.SECTION_TYPES.PROMO_CODE:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(Go, {
              promocode: x
            })));
          case Mr.SECTION_TYPES.INFO:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(y.Row, {
              start: "xs"
            }, r().createElement(y.Column, {
              xs: 10,
              noGutter: !0
            }, r().createElement(y.Text, {
              type: "smallBody"
            }, v("ORDER_STATUS_INFO", {
              customerEmail: c
            }))))));
          case Mr.SECTION_TYPES.LI_HOOK_INSURANCE:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(_o, {
              lihook: b
            })));
          case Mr.SECTION_TYPES.BULLET_LIST:
            return r().createElement(y.Row, {
              center: "xs"
            }, r().createElement(y.Column, {
              noGutter: !0,
              xs: 10,
              md: 6
            }, r().createElement(aa, {
              title: w.title,
              data: w.data
            })));
          default:
            return null;
        }
      }));
    }),
    sa = function sa(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    da = h()(y.Spacing)(ra || (ra = sa(["\n  background-color: #fff;\n  z-index: 10;\n  position: relative;\n"], ["\n  background-color: #fff;\n  z-index: 10;\n  position: relative;\n"]))),
    ma = (h().div(la || (la = sa(["\n  display: flex;\n"], ["\n  display: flex;\n"]))), h().div(Aa || (Aa = sa(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])))),
    Ea = h().span(oa || (oa = sa(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"]))),
    ga = ["styles"];
  var fa = function fa(e) {
    e.styles;
    var t = Kt()(e, ga);
    return r().createElement("svg", Jt()({
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, t), r().createElement("rect", {
      width: "64",
      height: "64",
      rx: "8",
      fill: "#257CE1"
    }), r().createElement("rect", {
      x: "1.6",
      y: "12.8",
      width: "59.2",
      height: "45.382",
      rx: "7",
      fill: "url(#prefix__pattern0)"
    }), r().createElement("path", {
      fill: "#257CE1",
      d: "M6.667 56.727h48v2.909h-48z"
    }), r().createElement("defs", null, r().createElement("pattern", {
      id: "prefix__pattern0",
      patternContentUnits: "objectBoundingBox",
      width: "1",
      height: "1"
    }, r().createElement("use", {
      xlinkHref: "#prefix__image0_14_859",
      transform: "matrix(.00073 0 0 .00095 -.046 0)"
    })), r().createElement("image", {
      id: "prefix__image0_14_859",
      width: "1500",
      height: "1053",
      xlinkHref: "data:image/png;base64,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"
    })));
  };
  var pa = function pa(e) {
    var t = e.onMembershipErrorStatusChange,
      l = e.hasMembershipError,
      A = e.membershipData,
      o = (0, y.useDevice)().isMobile,
      a = A.title,
      i = A.subTitle,
      c = A.note,
      u = A.isComingFromApp,
      s = (0, n.useRef)(null),
      d = function d() {
        return A.type, r().createElement(fa, {
          size: 64
        });
      },
      m = function m(e) {
        var n = (e.target.value + "").trim();
        E(n) ? (t(!1), A.value = n, A.isValid = !0) : (t(!0), A.isValid = !1);
      },
      E = function E(e) {
        return !(isNaN(Number(e)) || 8 !== e.length);
      },
      g = function g() {
        var e, n;
        (null === (e = s.current) || void 0 === e ? void 0 : e.value) && !E(null === (n = s.current) || void 0 === n ? void 0 : n.value) ? t(!0) : t(!1);
      },
      f = function f() {
        return r().createElement(r().Fragment, null, c && r().createElement(y.Spacing, {
          top: 1
        }, r().createElement(y.Text, {
          type: "smallBody"
        }, c)));
      };
    return r().createElement(Le, null, u ? function (e) {
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        bottom: 0
      }, r().createElement(y.Layout.Inline, null, d(), function (e) {
        return r().createElement(y.Spacing, {
          left: 1,
          top: o ? 1 : 0
        }, r().createElement(y.Text, {
          type: "smallBody"
        }, e), r().createElement(y.Text, {
          type: "smallBody"
        }, i));
      }(e))), f());
    }(a) : function (e) {
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        bottom: 2
      }, r().createElement(y.Layout.Inline, null, d(), function (e) {
        return r().createElement(y.Spacing, {
          left: 1,
          top: o ? 1 : 0
        }, r().createElement(y.Text, {
          type: "boldBody"
        }, e), r().createElement(y.Text, {
          type: "smallBody"
        }, i));
      }(e))), r().createElement(y.TextInput, {
        "data-testid": "membership-input",
        ref: s,
        onBlur: g,
        maxLength: 8,
        error: l,
        hintMessage: l && v("ENTER_VALID_MEMBERSHIP_ID"),
        onChange: m,
        label: v("MEMBERSHIP_ID"),
        displayFormat: ""
      }), f());
    }(a));
  };
  var va = pa;
  var wa = function wa(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    ha = h()(y.Spacing)(ya || (ya = wa(["\n  display: flex;\n"], ["\n  display: flex;\n"]))),
    Ca = (0, y.withTheme)(h()(y.Spacing)(xa || (xa = wa(["\n  @media (max-width: ", ") {\n    padding-bottom: 8px;\n  }\n"], ["\n  @media (max-width: ", ") {\n    padding-bottom: 8px;\n  }\n"])), function (e) {
      return e.coreTheme.brk_xs;
    }));
  var Ba = function Ba(e) {
    var t = e.visible,
      l = e.items,
      A = e.onClose,
      o = e.onConfirmOrder,
      a = void 0 === o ? function () {} : o,
      i = (0, n.useState)(""),
      c = i[0],
      u = i[1];
    (0, n.useEffect)(function () {
      var e = null == l ? void 0 : l.find(function (e) {
        return e.selected;
      });
      s(e || l && l[0]);
    }, [l]);
    var s = function s(e) {
      e && u(e.type);
    };
    return r().createElement(y.Modal, {
      "data-testid": "place-order-modal",
      visible: t,
      title: v("PLACE_ORDER_TITLE"),
      onClose: A,
      scrollable: !0
    }, r().createElement(y.Modal.Content, null, r().createElement(Ca, {
      bottom: 1
    }, r().createElement(r().Fragment, null, null == l ? void 0 : l.map(function (e) {
      var t, n;
      return r().createElement(y.Row, null, r().createElement(y.Column, {
        "data-testid": "payment-mode-".concat(e.type),
        key: e.type,
        xs: 12,
        md: 12,
        onClick: function onClick() {
          return s(e);
        }
      }, r().createElement("div", null, r().createElement(y.Selector, {
        alignment: "row",
        selected: e.type === c
      }, r().createElement(y.Selector.Body, {
        align: "start",
        title: (null == e ? void 0 : e.title) || (null === (t = Sr[e.type]) || void 0 === t ? void 0 : t.title),
        subtitle: (n = e, n.description ? r().createElement(ha, {
          topBottom: "4px"
        }, r().createElement(y.Text, {
          type: "smallBody"
        }, n.description)) : null)
      }), function (e) {
        switch (e) {
          case Tr:
            return r().createElement(fr, null);
          case Dr:
            return r().createElement(vr, null);
        }
      }(e.type)))));
    }), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12
    }, r().createElement(y.Spacing, {
      topBottom: 1
    }, r().createElement(y.Button, {
      "data-testid": "confirm-payment-method",
      onClick: function onClick() {
        a(c);
      }
    }, v("CONFIRM_PAYMENT_METHOD_BUTTON")))))))));
  };
  var ya,
    xa,
    _Ia = function Ia() {
      return _Ia = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Ia.apply(this, arguments);
    },
    ba = function ba(e) {
      var t = e.data,
        l = e.ui,
        A = void 0 === l ? {} : l,
        o = e.configs,
        a = e.callbacks,
        i = e.localisation,
        c = t.upfront,
        u = t.monthly,
        s = t.addition,
        d = (t.tradein, t.voucher, t.discount),
        m = t.total,
        E = (t.note, t.outOfStockItem),
        g = t.personalInfo,
        f = t.billingAddress,
        w = t.eSimDeliveryOptions,
        h = t.deliveryOptions,
        C = t.paymentOptions,
        x = t.promoCodeResult,
        I = t.productsList,
        b = t.orderSummaryData,
        O = t.paymentInfo,
        T = t.membershipData,
        D = t.afterDiscount,
        S = o.buyflowType,
        R = o.sectionTitle,
        k = void 0 === R ? {
          show: !0
        } : R,
        L = o.bagItemsSection,
        P = void 0 === L ? {
          showDivider: !0
        } : L,
        M = o.promoCodeSection,
        Q = void 0 === M ? {
          show: !0
        } : M,
        N = o.totalWithPromoSection,
        H = void 0 === N ? {
          show: !0
        } : N,
        F = o.discountSection,
        X = void 0 === F ? {
          showDivider: !0
        } : F,
        V = o.totalSection,
        G = void 0 === V ? {
          showDivider: !1,
          top: 0,
          bottom: 0
        } : V,
        z = o.paymentInfoSection,
        U = void 0 === z ? {
          showDivider: !1,
          top: 3,
          bottom: 0
        } : z,
        j = o.placeOrderButton,
        J = void 0 === j ? {
          loading: !1
        } : j,
        Y = o.showOutOfStock,
        K = void 0 !== Y && Y,
        Z = o.stickyBoundaryElement,
        q = _Ia(_Ia(_Ia({}, a), t), {
          configs: o
        }),
        W = (0, y.useDevice)().isMobile,
        _ = (0, n.useState)(!1),
        $ = _[0],
        ee = _[1],
        te = (0, n.useRef)(null),
        ne = (0, y.useWindowSize)(),
        re = (0, n.useState)(g),
        le = re[0],
        Ae = (re[1], (0, n.useState)(!1)),
        oe = Ae[0],
        ae = Ae[1],
        ie = (0, n.useState)(""),
        ce = ie[0],
        ue = ie[1],
        se = (0, n.useState)(!1),
        de = se[0],
        me = se[1],
        Ee = (0, n.useState)(!1),
        ge = Ee[0],
        fe = Ee[1];
      (0, n.useEffect)(function () {
        var e;
        ne.height > (null === (e = null == te ? void 0 : te.current) || void 0 === e ? void 0 : e.offsetHeight) ? ee(!0) : ee(!1);
      }, [ne]), p(i);
      var pe = a.onSectionClicked,
        ve = void 0 === pe ? function () {} : pe,
        we = a.onPlaceOrder,
        he = void 0 === we ? function () {} : we,
        Ce = a.applyPromo,
        Be = A.Tnc,
        ye = A.Stepper,
        xe = function xe(e, t) {
          ae(t);
        },
        Ie = function Ie(e) {
          he(e, c);
        },
        be = function be(e) {
          fe(e);
        },
        Oe = function Oe() {
          oe && !ge ? (null == b ? void 0 : b.isZeroUpfront) || (null == b ? void 0 : b.ignorePaymentMethodPopup) ? (me(!1), (null == b ? void 0 : b.isZeroUpfront) ? Ie("no-payment") : Ie(b.defaultPaymentType)) : me(!0) : (W && UA(xA), ue(v("ORDER_SUMMARY_TNC_ERROR_MESSAGE")));
        };
      (0, n.useEffect)(function () {
        oe && ue("");
      }, [oe, ce]);
      var Te = function Te(e) {
          return void 0 === e && (e = !1), r().createElement("div", {
            id: e ? xA : null
          }, e && r().createElement(y.Spacing, {
            bottom: 3
          }, r().createElement(y.Divider, null)), Re(), ke(), Be && r().createElement(y.Spacing, {
            top: e ? 3 : 2,
            bottom: e ? 0 : 2
          }, r().createElement(y.Checkbox.InputGroup, {
            error: ce
          }, r().createElement(y.Checkbox.Input, {
            onChange: xe,
            label: Be
          }))), r().createElement(y.Spacing, {
            top: e ? 4 : 0
          }, r().createElement(y.Button, {
            "data-testid": "place-order",
            text: v("PROCEED"),
            fullWidth: !0,
            onClick: function onClick() {
              return Oe();
            },
            loading: (null == J ? void 0 : J.loading) || !1
          })));
        },
        De = function De(e, t, n) {
          void 0 === n && (n = !0);
          var l = e.action,
            A = e.title || t,
            o = l && n ? r().createElement(y.TextLink, {
              "data-testid": "section-cta",
              onClick: function onClick() {
                ve(l.type);
              }
            }, l.text) : null;
          return r().createElement(r().Fragment, null, r().createElement(ma, null, r().createElement(y.Text, {
            type: "boldBody"
          }, A), o), r().createElement(y.Spacing, {
            top: 1
          }, e.content.map(function (e) {
            if (e && Array.isArray(e)) return r().createElement(y.Text, {
              type: "body"
            }, e.map(function (e) {
              var t = e.text,
                n = e.nowrap;
              return void 0 !== n && n ? r().createElement(Ea, null, "".concat(t, " ")) : "".concat(t, " ");
            }));
            if (e && "object" == typeof e) {
              var t = e;
              return r().createElement(y.Spacing, {
                top: 2
              }, r().createElement(y.Text, {
                type: t.style
              }, t.text));
            }
            return r().createElement(y.Text, {
              type: "body"
            }, e);
          })));
        },
        Se = function Se(e) {
          var t = e.content,
            n = e.hasDivider,
            l = void 0 === n || n,
            A = e.topBottom,
            o = void 0 === A ? 3 : A,
            a = e.top,
            i = e.bottom,
            c = isNaN(a) ? o : a,
            u = isNaN(i) ? o : i;
          return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
            top: c,
            bottom: u
          }, t), l && r().createElement(y.Divider, null));
        },
        Re = function Re() {
          return Se({
            content: r().createElement(Ot, {
              data: m
            }),
            top: (null == G ? void 0 : G.top) || 0,
            bottom: (null == G ? void 0 : G.bottom) || 0,
            hasDivider: (null == G ? void 0 : G.showDivider) || !1
          });
        },
        ke = function ke() {
          if (!O) return null;
          var e = r().createElement(r().Fragment, null, r().createElement(y.Text, {
            type: "header",
            fontWeight: "bold",
            "data-testid": "payment-info-title"
          }, v("PAYMENT_INFO_TITLE")), r().createElement(y.Spacing, {
            top: 1
          }, r().createElement(y.Text, {
            type: "body",
            "data-testid": "payment-info-description"
          }, O.description)));
          return Se({
            content: e,
            hasDivider: U.showDivider || !1,
            top: isNaN(U.top) ? 3 : U.top,
            bottom: isNaN(U.bottom) ? 0 : U.bottom
          });
        };
      return r().createElement(r().Fragment, null, r().createElement(ur.Provider, {
        value: q
      }, !(null == b ? void 0 : b.isZeroUpfront) && de && r().createElement(Ba, {
        visible: de,
        items: C,
        onClose: function onClose() {
          return me(!1);
        },
        onConfirmOrder: Ie
      }), r().createElement(y.Column, _Ia({}, Pr, {
        noGutter: !0
      }), r().createElement(da, null, r().createElement(B(), {
        disabled: !1
      }, r().createElement(y.Card, {
        padding: "lg",
        radius: "false"
      }, r().createElement(Nn, {
        data: m
      }, r().createElement(y.Button, {
        "data-testid": "place-order",
        text: v("PROCEED"),
        fullWidth: !0,
        onClick: function onClick() {
          return Oe();
        },
        loading: (null == J ? void 0 : J.loading) || !1
      })))))), ye, r().createElement(Je, {
        "data-testid": "order-summary-section"
      }, r().createElement("div", {
        className: "fs-unmask stickyBoundary"
      }, r().createElement(y.Row, {
        between: "md",
        noGutter: !0
      }, r().createElement(y.Column, {
        xs: 12,
        md: 7,
        noGutter: !0
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        noGutter: !0
      }, r().createElement(y.Spacing, {
        bottom: 1
      }, r().createElement(y.Text, {
        type: "pageTitle"
      }, v("ORDER_SUMMARY_PAGE_TITLE"))))), function () {
        var e;
        return K && (null === (e = null == E ? void 0 : E.dataSource) || void 0 === e ? void 0 : e.length) ? r().createElement(y.Spacing, {
          top: 1
        }, r().createElement(Un, {
          outOfStockItem: E
        })) : null;
      }(), function () {
        if (!le) return null;
        var e = De(le, v("PERSONAL_DETAILS"));
        return Se({
          content: e
        });
      }(), function () {
        if (!f) return null;
        var e = De(f, v("BILLING_ADDRESS"));
        return Se({
          content: e,
          hasDivider: !1
        });
      }(), function () {
        if (!(null == k ? void 0 : k.show)) return null;
        var e = r().createElement(y.Text, {
          type: "sectionTitle02",
          fontWeight: "bold",
          "data-testid": "section-title"
        }, v("YOUR_ORDER"));
        return Se({
          content: e
        });
      }(), function () {
        if (!w) return null;
        var e = De(w, v("E_SIM_DELIVERY"));
        return Se({
          content: e
        });
      }(), function () {
        if (!h) return null;
        var e = h.showChangeOption,
          t = void 0 === e || e,
          n = De(h, v("DOORSTEP_DELIVERY"), t);
        return Se({
          content: n
        });
      }(), function () {
        if (!(null == I ? void 0 : I.length)) return null;
        var e = r().createElement(OA, {
          items: I,
          hideLastUndeline: !0,
          buyflowType: S,
          initialDisplayCount: null == P ? void 0 : P.initialDisplayCount,
          showQtyInMobileView: !0,
          "data-testid": "bag-items-list"
        });
        return Se({
          content: e,
          hasDivider: null == P ? void 0 : P.showDivider,
          topBottom: .5,
          top: null == P ? void 0 : P.top,
          bottom: null == P ? void 0 : P.bottom
        });
      }(), d ? r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 3
      }, r().createElement(ct, {
        data: d
      })), (null == X ? void 0 : X.showDivider) && r().createElement(y.Divider, {
        "data-testid": "discount-section-divider"
      })) : null, D, function () {
        var e;
        if (!(null === (e = o.membership) || void 0 === e ? void 0 : e.show)) return null;
        var t = r().createElement(pa, {
          onMembershipErrorStatusChange: be,
          hasMembershipError: ge,
          membershipData: T
        });
        return Se({
          content: t
        });
      }(), (null == Q ? void 0 : Q.show) ? r().createElement(Xn, {
        promoCodeResult: x,
        applyPromo: Ce
      }) : null, function () {
        if (!(null == H ? void 0 : H.show)) return null;
        var e = (null == x ? void 0 : x.price) ? {
          promoCode: null == x ? void 0 : x.appliedPromoCode,
          price: null == x ? void 0 : x.price
        } : null;
        return r().createElement(Gn, {
          total: m,
          upFrontCosts: null == c ? void 0 : c.dataSource,
          promoDetails: e
        });
      }(), function () {
        if (!u) return null;
        var e = r().createElement(bt, {
          data: {
            title: v("SECTION_TITLE_MONTHLY_BILL"),
            dataSource: u.dataSource,
            totalText: v("MONTHLY_TOTAL"),
            totalAmount: u.totalAmount,
            footer: u.footer
          }
        });
        return Se({
          content: e,
          hasDivider: !1,
          topBottom: 0
        });
      }(), function () {
        if (!s) return null;
        var e = r().createElement(bt, {
          data: {
            title: v("SECTION_TITLE_ADDITION_BILL"),
            description: v("SECTION_DESCRIPTION_ADDITION_BILL"),
            dataSource: s.dataSource,
            totalText: v("ADDITION_TOTAL"),
            totalAmount: s.totalAmount,
            footer: s.footer
          }
        });
        return Se({
          content: e,
          hasDivider: !1,
          topBottom: 1
        });
      }()), r().createElement(y.Column, {
        xs: 12,
        md: 4,
        noGutter: !0
      }, r().createElement(y.Row, null, r().createElement(y.Column, _Ia({}, Lr, {
        "data-testid": "desktop-summary"
      }), r().createElement(B(), {
        topOffset: 32,
        stickyStyle: {
          transform: "translateY(32px)"
        },
        disabled: !$,
        hideOnBoundaryHit: !1,
        boundaryElement: Z
      }, r().createElement(y.Card, {
        padding: "lg",
        ref: te
      }, r().createElement(y.Card.Content, null, r().createElement(Ye, null, Te()))))), r().createElement(y.Column, _Ia({
        noGutter: !0
      }, Pr, {
        "data-testid": "mobile-summary"
      }), Te(!0)))))))));
    },
    Oa = function Oa(e) {
      var t = e.title,
        n = e.description,
        l = e.type,
        A = e.content,
        o = e.boldContent,
        a = e.action,
        i = e.icon,
        c = e.image,
        u = e.onClick;
      return r().createElement(Sa, null, (t || n) && r().createElement("div", {
        style: {
          flex: 1,
          display: "flex"
        },
        onClick: u
      }, i && r().createElement("div", {
        style: {
          marginRight: 15,
          alignSelf: "baseline"
        }
      }, "string" == typeof i ? r().createElement(ce.Icon, {
        name: i,
        size: 26
      }) : i), c && r().createElement("div", {
        style: {
          marginRight: 15
        }
      }, "string" == typeof c ? r().createElement("img", {
        src: c,
        alt: "",
        width: "66px",
        height: "88px"
      }) : c), r().createElement("div", null, t && r().createElement(y.Text, {
        type: "strikeThrough" !== l ? l : "body"
      }, t), n && r().createElement(y.Text, {
        type: "smallBody"
      }, n))), A && r().createElement("div", null, r().createElement(y.Text, {
        type: "strikeThrough" !== l ? l : "body",
        strikeThrough: "strikeThrough" === l
      }, A)), (o || a) && r().createElement("div", null, o && r().createElement(y.Text, {
        type: "boldBody"
      }, o), a && r().createElement("div", null, a)));
    };
  var Ta = Oa;
  var Da,
    Sa = h().div(Da || (Da = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  display: flex;\n  width: 100%;\n  flex-wrap: nowrap;\n\n  > div:not(:last-child) {\n    padding-right: 16px;\n  }\n\n  > div:not(:first-child):last-child {\n    text-align: right;\n    min-width: 90px;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-wrap: nowrap;\n\n  > div:not(:last-child) {\n    padding-right: 16px;\n  }\n\n  > div:not(:first-child):last-child {\n    text-align: right;\n    min-width: 90px;\n  }\n"])));
  var Ra = function Ra(e) {
    var t = e.dataSource,
      n = void 0 === t ? [] : t;
    return r().createElement(r().Fragment, null, n.map(function (e) {
      return r().createElement("div", {
        "data-testid": "detail-block"
      }, r().createElement(y.Spacing, {
        topBottom: 3
      }, r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        bottom: 1
      }, r().createElement(Ta, {
        type: "boldBody",
        title: e.title,
        action: e.action
      })), e.content.map(function (e) {
        return r().createElement(y.Text, {
          type: "body"
        }, e);
      }))), r().createElement(y.Divider, null));
    }));
  };
  var _ka = function ka() {
      return _ka = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _ka.apply(this, arguments);
    },
    La = (0, y.withTheme)(h().div(Ma || (Ma = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  padding: 16px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n"], ["\n  padding: 16px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n"])), function (e) {
      var t = e.type,
        n = e.coreTheme;
      return "primary" === t ? "background-color: ".concat(n.cl_pri_l3, ";") : "secondary" === t ? "background-color: ".concat(n.cl_sec_l2, ";") : "tertiary" === t ? "background-color: ".concat(n.cl_ter_l6, ";") : "";
    }, function (e) {
      var t = e.padding;
      return "\n  padding: ".concat(t, ";\n  ");
    }));
  var Pa = function Pa(e) {
    var t = e.dataSource,
      n = void 0 === t ? [] : t;
    return r().createElement("div", {
      "data-testId": "bill-block"
    }, r().createElement(y.Spacing, {
      topBottom: 2
    }, n.map(function (e) {
      return r().createElement(r().Fragment, null, (e.title || e.description) && r().createElement(y.Spacing, {
        topBottom: 2
      }, e.title && r().createElement(Ta, {
        type: "sectionTitle02",
        title: e.title
      }), e.description && r().createElement(Ta, {
        type: "body",
        title: e.description
      })), r().createElement(y.Spacing, {
        bottom: 3
      }, r().createElement(La, {
        "data-testid": "color-container",
        type: "tertiary"
      }, e.dataSource.map(function (t, n) {
        return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
          topBottom: 2
        }, r().createElement(Ta, _ka({}, t))), n < e.dataSource.length - 1 && r().createElement(y.Divider, null));
      })), e.footer && r().createElement(y.Spacing, {
        top: 2
      }, r().createElement(Ta, {
        type: "body",
        title: e.footer
      }))));
    })));
  };
  var Ma,
    _Qa = function Qa() {
      return _Qa = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Qa.apply(this, arguments);
    },
    Na = (0, y.withTheme)(h().div(Fa || (Fa = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  padding: 16px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n"], ["\n  padding: 16px;\n  border-radius: 8px;\n  width: 100%;\n  box-sizing: border-box;\n\n  ", "\n\n  ", "\n"])), function (e) {
      var t = e.type,
        n = e.coreTheme;
      return "primary" === t ? "background-color: ".concat(n.cl_pri_l3, ";") : "secondary" === t ? "background-color: ".concat(n.cl_sec_l2, ";") : "tertiary" === t ? "background-color: ".concat(n.cl_ter_l6, ";") : "";
    }, function (e) {
      var t = e.padding;
      return "\n  padding: ".concat(t, ";\n  ");
    }));
  var Ha = function Ha(e) {
    var t = e.dataSource,
      n = void 0 === t ? [] : t;
    return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      topBottom: 2
    }, r().createElement(Na, {
      type: "secondary"
    }, n.map(function (e) {
      return e.dataSource.map(function (e) {
        return r().createElement(Ta, _Qa({}, e));
      });
    }))), " ", r().createElement(y.Divider, null));
  };
  var Fa,
    _Xa = function Xa() {
      return _Xa = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Xa.apply(this, arguments);
    };
  var Va = function Va(e) {
    var t = e.dataSource,
      n = void 0 === t ? [] : t;
    return r().createElement(r().Fragment, null, n.map(function (e) {
      return r().createElement("div", {
        "data-testid": za.ITEM
      }, r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(Ta, {
        type: "sectionTitle02",
        title: e.title
      })), r().createElement(y.Divider, null), e.dataSource.map(function (e) {
        return e.displayType === za.DETAIL ? r().createElement(Ra, {
          dataSource: [e]
        }) : e.displayType === za.PROMO ? r().createElement(Ha, {
          dataSource: [e]
        }) : r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
          topBottom: 2
        }, e.group ? e.dataSource.map(function (e) {
          return r().createElement(Ta, _Xa({}, e));
        }) : r().createElement(Ta, _Xa({}, e))), r().createElement(y.Divider, null));
      }));
    }));
  };
  var _Ga = function Ga() {
      return _Ga = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Ga.apply(this, arguments);
    },
    za = {
      DETAIL: "detail-block",
      BILL: "bill-block",
      ITEM: "item-block",
      PROMO: "promo-block",
      CHECKOUT: "checkout-block"
    },
    Ua = function Ua(e) {
      var t = e.data;
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        bottom: 2
      }, t.dataSource.map(function (e) {
        return "checkbox" === e.type ? r().createElement(y.Spacing, {
          topBottom: 2
        }, r().createElement(y.Checkbox.Input, {
          label: e.content,
          onChange: e.action
        })) : r().createElement(Ta, _Ga({}, e));
      })), Array.isArray(t.action) ? t.action.map(function (e) {
        return r().createElement(y.Spacing, {
          bottom: 1
        }, e);
      }) : t.action);
    },
    ja = function ja(e) {
      var t = e.data,
        n = _Ga({}, t),
        l = [],
        A = [],
        o = [],
        a = [];
      return Object.keys(t).forEach(function (e) {
        t[e].displayType === za.DETAIL ? l.push(t[e]) : t[e].displayType === za.BILL ? A.push(t[e]) : t[e].displayType === za.ITEM ? o.push(t[e]) : t[e].displayType === za.CHECKOUT && a.push(t[e]);
      }), r().createElement(r().Fragment, null, r().createElement(ur.Provider, {
        value: n
      }, r().createElement(Je, {
        "data-testid": "order-summary-section"
      }, r().createElement("div", {
        className: "fs-unmask"
      }, r().createElement(y.Row, {
        between: "md",
        noGutter: !0
      }, r().createElement(y.Column, {
        xs: 12,
        md: 7,
        noGutter: !0
      }, l.length > 0 && r().createElement("div", {
        "data-testid": za.DETAIL,
        style: {
          marginTop: -32
        }
      }, r().createElement(Ra, {
        dataSource: l
      })), o.length > 0 && r().createElement(Va, {
        dataSource: o
      }), A.length > 0 && r().createElement(Pa, {
        dataSource: A
      })), r().createElement(y.Column, {
        xs: !1,
        md: 4,
        noGutter: !0
      }, a.length > 0 && r().createElement(B(), {
        stickyStyle: {
          top: 32
        },
        disabled: !1
      }, r().createElement(y.Card, {
        padding: "lg"
      }, r().createElement(y.Card.Content, null, r().createElement(Ua, {
        data: a[0]
      }))))), r().createElement(y.Column, {
        xs: 12,
        md: !1,
        noGutter: !0
      }, a.length > 0 && r().createElement(r().Fragment, null, r().createElement(y.Divider, null), r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(Ua, {
        data: a[0]
      })))))))));
    },
    _Ja = function Ja() {
      return _Ja = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Ja.apply(this, arguments);
    };
  var _Ya = function Ya() {
    return _Ya = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var l in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }
      return e;
    }, _Ya.apply(this, arguments);
  };
  var _Ka = function Ka() {
    return _Ka = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var l in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }
      return e;
    }, _Ka.apply(this, arguments);
  };
  var _Za = function Za() {
    return _Za = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var l in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }
      return e;
    }, _Za.apply(this, arguments);
  };
  var qa = function qa(e) {
    var t = e.showDivider,
      n = void 0 === t || t,
      l = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, ["showDivider"]),
      A = l.title,
      o = l.content,
      a = l.action,
      i = l.helperText;
    return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      topBottom: 2
    }, r().createElement(y.Spacing, {
      bottom: .5
    }, r().createElement(y.Row, {
      between: "xs"
    }, r().createElement(y.Text, {
      type: "boldBody"
    }, A), a && r().createElement(y.TextLink, {
      onClick: null == a ? void 0 : a.onClick
    }, null == a ? void 0 : a.text))), o.map(function (e) {
      return r().createElement(y.Text, {
        type: "body",
        tag: "div"
      }, e);
    }), i && r().createElement(r().Fragment, null, o.length > 0 && r().createElement(y.Spacing, {
      top: 2
    }), r().createElement(y.Text, {
      type: "smallBody"
    }, i))), n && r().createElement(y.Divider, null));
  };
  var _Wa = function Wa() {
    return _Wa = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var l in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }
      return e;
    }, _Wa.apply(this, arguments);
  };
  var _a,
    $a,
    ei = "TITLE",
    ti = "INFO",
    ni = "ITEMS",
    ri = "DISCOUNT",
    li = "MEMBERSHIP",
    Ai = "PROMO_CODE",
    oi = "SUBTOTAL",
    ai = "TOTAL",
    ii = [ei, ti, ni, ri, oi, li, Ai, ai],
    ci = ((_a = {})[ei] = "title", _a[ti] = "info", _a[ni] = "productsList", _a[ri] = "discount", _a[oi] = "subtotal", _a[li] = "membershipData", _a[Ai] = "promoCode", _a[ai] = "total", _a),
    ui = (($a = {})[ei] = function (e) {
      var t = e.showDivider,
        n = void 0 === t || t,
        l = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["showDivider"]),
        A = l.text,
        o = l.icon,
        a = void 0 === o ? "shop" : o;
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 1
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(Fe, {
        alignY: "center"
      }, r().createElement(Ne, null, r().createElement(ce.Icon, {
        size: 28,
        name: a
      })), r().createElement(y.Text, {
        type: "boldBody"
      }, A))))), n && r().createElement(y.Divider, null));
    }, $a[ti] = qa, $a[ni] = function (e) {
      var t = e.showDivider,
        n = void 0 === t || t,
        l = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["showDivider"]);
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: .5
      }, r().createElement(OA, _Ka({}, l))), n && r().createElement(y.Divider, null));
    }, $a[ri] = function (e) {
      var t = e.showDivider,
        n = void 0 === t || t,
        l = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["showDivider"]);
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(ct, _Za({
        hasColorContainer: !0
      }, l))), n && r().createElement(y.Divider, null));
    }, $a[oi] = function (e) {
      var t = e.list,
        n = void 0 === t ? [] : t,
        l = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["list"]),
        A = l.finalAmount,
        o = l.showDivider,
        a = void 0 === o || o;
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 2
      }, n.map(function (e) {
        return r().createElement(Oa, _Ya({}, e));
      }), r().createElement(Oa, {
        title: r().createElement(y.Text, {
          type: "boldBody"
        }, v("SUBTOTAL")),
        boldContent: ie(A)
      })), a && r().createElement(y.Divider, null));
    }, $a[li] = function (e) {
      var t = e.showDivider,
        l = void 0 === t || t,
        A = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["showDivider"]),
        o = (0, n.useState)(!1),
        a = o[0],
        i = o[1];
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(va, {
        onMembershipErrorStatusChange: function onMembershipErrorStatusChange(e) {
          i(e);
        },
        hasMembershipError: a,
        membershipData: _Wa({}, A)
      })), l && r().createElement(y.Divider, null));
    }, $a[Ai] = function (e) {
      var t = e.showDivider,
        n = void 0 === t || t,
        l = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["showDivider"]);
      return r().createElement(r().Fragment, null, r().createElement(Fn, _Ja({}, l)), n && r().createElement(y.Divider, null));
    }, $a[ai] = function (e) {
      var t = e.list,
        n = void 0 === t ? [] : t,
        l = e.showDivider,
        A = void 0 === l || l,
        o = function (e, t) {
          var n = {};
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var l = 0;
            for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
              t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
            }
          }
          return n;
        }(e, ["list", "showDivider"]),
        a = o.finalAmount,
        i = o.originalAmount;
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement("div", {
        "data-testid": "total-promo-section"
      }, n.map(function (e, t) {
        var n = e.name,
          l = e.amount;
        return r().createElement(y.Row, {
          between: "xs",
          key: t
        }, r().createElement(y.Text, {
          type: "body"
        }, n), r().createElement(y.Text, {
          type: "body"
        }, ie(l)));
      }), r().createElement(y.Row, {
        between: "xs"
      }, r().createElement(y.Text, {
        type: "boldBody"
      }, v("ORDER_TOTAL")), r().createElement(y.Text, {
        type: "boldBody"
      }, ie(a))), r().createElement(y.Row, {
        end: "xs"
      }, i && r().createElement(Qe, {
        strikeThrough: !0
      }, ie(i))))), A && r().createElement(y.Divider, null));
    }, $a),
    _si = function si() {
      return _si = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _si.apply(this, arguments);
    };
  var di = function di(e) {
    var t = e.showDivider,
      n = void 0 === t || t,
      l = e.note,
      A = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, ["showDivider", "note"]);
    return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      topBottom: 2
    }, r().createElement(bt, {
      data: _si({}, A)
    }), l && r().createElement(y.Text, null, l)), n && r().createElement(y.Divider, null));
  };
  var mi = function mi(e) {
    var t = e.showDivider,
      n = void 0 === t || t,
      l = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, ["showDivider"]),
      A = l.title,
      o = l.description,
      a = l.items,
      i = l.action;
    return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      top: 2,
      bottom: 2
    }, r().createElement(y.Text, {
      type: "header"
    }, A), o && r().createElement(y.Spacing, {
      topBottom: 1,
      responsive: !1
    }, r().createElement(y.Text, {
      type: "body"
    }, o)), a.map(function (e) {
      return r().createElement(y.BulletList, {
        size: "small"
      }, e);
    }), i && r().createElement(y.Spacing, {
      top: 1,
      responsive: !1
    }, r().createElement(y.TextLink, {
      onClick: i.onClick
    }, i.text))), n && r().createElement(y.Divider, null));
  };
  var Ei = {
      CreditCard: "CreditCard",
      SingtelBill: "SingtelBill"
    },
    gi = {
      VISA: "VISA",
      MASTERCARD: "MASTERCARD"
    },
    fi = {
      VIEW: "VIEW",
      SELECTOR: "SELECTOR"
    },
    pi = ["styles"];
  var vi = function vi(e) {
    e.styles;
    var t = Kt()(e, pi);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "30",
      viewBox: "0 0 48 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      d: "M46 0H2a2 2 0 00-2 2v26a2 2 0 002 2h44a2 2 0 002-2V2a2 2 0 00-2-2z",
      fill: "#26337A"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 10l-1.924 10H20l1.924-10H25zm3.91 0c.903 0 1.629.212 2.09.406l-.316 2.1-.21-.11a3.866 3.866 0 00-1.745-.372c-.914 0-1.336.43-1.337.833-.005.455.495.753 1.31 1.202 1.346.69 1.968 1.528 1.96 2.632C30.642 18.7 29.05 20 26.599 20c-1.047-.012-2.055-.247-2.599-.516l.326-2.169.3.154c.767.362 1.264.508 2.198.508.67 0 1.39-.297 1.396-.946.004-.424-.302-.727-1.21-1.202-.885-.463-2.059-1.24-2.044-2.632C24.98 11.315 26.603 10 28.91 10zm8.062 0L39 20h-2.326s-.23-1.15-.305-1.5h-1.073l-.675-.002h-.443l-.208-.001h-.37l-.153-.001h-.288c-.097.27-.527 1.504-.527 1.504H30l3.722-9.17c.263-.653.712-.83 1.313-.83h1.937zM21 10l-4.017 9.998-2.7.002L12 11.24c1.62.868 3.068 2.602 3.533 4.201l.268 1.388L18.297 10H21zm14.212 2.697c-.127.375-.348.981-.334.955l-.45 1.265-.119.332-.429 1.2h2.08l-.033-.17c-.145-.728-.546-2.719-.546-2.719l-.17-.863z",
      fill: "#FFFFFE"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.346 10h-3.319l-.027.19c2.582.762 4.29 2.6 5 4.81l-.721-4.224c-.125-.583-.486-.756-.933-.776z",
      fill: "#EC982D"
    }));
  };
  var wi = ["styles"];
  var hi = function hi(e) {
    e.styles;
    var t = Kt()(e, wi);
    return r().createElement("svg", Jt()({
      width: "40",
      height: "26",
      viewBox: "0 0 40 26",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      d: "M38.333.5H1.667C.747.5 0 1.246 0 2.167v21.666c0 .92.746 1.667 1.667 1.667h36.666c.92 0 1.667-.746 1.667-1.667V2.167C40 1.247 39.254.5 38.333.5z",
      fill: "#121212"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.036 18.098h5.833v-10.2h-5.833v10.2z",
      fill: "#FF5F00"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.407 13.002c-.002-1.99.937-3.87 2.546-5.1-2.895-2.213-7.086-1.724-9.36 1.092-2.276 2.817-1.773 6.895 1.122 9.108a6.813 6.813 0 008.238 0c-1.61-1.229-2.548-3.11-2.546-5.1z",
      fill: "#EB001B"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.74 13.002c0 3.582-2.985 6.486-6.667 6.486a6.786 6.786 0 01-4.12-1.387c2.895-2.213 3.398-6.291 1.123-9.108a6.58 6.58 0 00-1.123-1.092c2.895-2.214 7.086-1.726 9.361 1.09a6.375 6.375 0 011.426 4.011zM30.803 17.593v-.827h-.086l-.116.59-.116-.59h-.103v.827h.058v-.62l.108.537h.075l.108-.538v.627l.072-.006zm-.64 0v-.686h.13v-.136h-.323v.142h.13v.686l.063-.006z",
      fill: "#F79E1B"
    }));
  };
  var Ci = ["styles"];
  var Bi = function Bi(e) {
    e.styles;
    var t = Kt()(e, Ci);
    return r().createElement("svg", Jt()({
      width: "48",
      height: "30",
      viewBox: "0 0 48 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      d: "M46 0H2a2 2 0 00-2 2v26a2 2 0 002 2h44a2 2 0 002-2V2a2 2 0 00-2-2z",
      fill: "#E1E1E1"
    }), r().createElement("path", {
      d: "M48 6H0v6h48V6z",
      fill: "#565656"
    }));
  };
  var yi = ["styles"];
  var xi = function xi(e) {
    e.styles;
    var t = Kt()(e, yi);
    return r().createElement("svg", Jt()({
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), r().createElement("path", {
      d: "M32.166.832H7.833a2 2 0 00-2 2v34.333a2 2 0 002 2h24.333a2 2 0 002-2V2.832a2 2 0 00-2-2z",
      fill: "#E1E1E1"
    }), r().createElement("path", {
      d: "M12 27h16m-16 4h16",
      stroke: "#565656",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), r().createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.232 8c.587 0 1.064.457 1.064 1.021v.37c1.427.345 2.679 1.382 2.701 3.028.006.564-.463 1.027-1.051 1.034-.602.004-1.07-.444-1.077-1.008-.01-.793-.926-1.11-1.553-1.136l-.084.005-.125-.007h.125c-.476 0-1.462 0-1.867.37-.243.222-.306.617-.14.88.28.448 1.012.679 1.74.877l.901.238c1.011.29 2.105.714 2.734 1.716.682 1.09.475 2.524-.495 3.411-.528.484-1.186.717-1.81.83v.35c0 .564-.476 1.021-1.063 1.021-.589 0-1.064-.457-1.064-1.021v-.285c-1.609-.215-3.141-1.291-3.165-3.113-.007-.565.462-1.027 1.05-1.035.603.036 1.071.445 1.079 1.008.01.83 1.01 1.139 1.637 1.139.12 0 .274 0 .443-.007H20.25c.49-.021 1.092-.095 1.387-.364.241-.222.305-.617.14-.881-.255-.405-.899-.635-1.497-.807l-.887-.234c-1.095-.298-2.31-.704-2.992-1.79-.683-1.088-.474-2.522.495-3.41.662-.605 1.526-.818 2.272-.894v-.285c0-.564.476-1.021 1.065-1.021z",
      fill: "#565656"
    }));
  };
  var Ii,
    bi,
    Oi,
    Ti,
    Di = function Di(e) {
      switch (e.type) {
        case Ei.SingtelBill:
          return r().createElement(xi, {
            "data-testid": "singtelBillIcon"
          });
        case Ei.CreditCard:
          switch (e.cardType) {
            case gi.VISA:
              return r().createElement(vi, {
                "data-testid": "visaIcon"
              });
            case gi.MASTERCARD:
              return r().createElement(hi, {
                "data-testid": "mastercardIcon"
              });
            default:
              return r().createElement(Bi, {
                "data-testid": "genericCreditCardIcon"
              });
          }
        default:
          return null;
      }
    },
    Si = function Si(e) {
      var t,
        n,
        r = e.subLabel || "";
      switch (e.type) {
        case Ei.CreditCard:
          return "".concat(r).concat((void 0 === n && (n = "*"), (t = e.cardNumber) ? "".concat(n.repeat(4), " ").concat(t) : ""));
        case Ei.SingtelBill:
          return "".concat(r).concat(function (e, t) {
            return void 0 === t && (t = "*"), e ? "".concat(t.repeat(4)).concat(e) : "";
          }(e.accountNumber));
        default:
          return "";
      }
    },
    Ri = function Ri(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _ki = function ki() {
      return _ki = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _ki.apply(this, arguments);
    },
    Li = h().div(Ii || (Ii = Ri(["\n  display: flex;\n"], ["\n  display: flex;\n"]))),
    Pi = h()(y.Spacing)(bi || (bi = Ri(["\n  flex: 1;\n"], ["\n  flex: 1;\n"]))),
    Mi = h()(y.Spacing)(Oi || (Oi = Ri(["\n  flex: 1;\n  text-align: right;\n"], ["\n  flex: 1;\n  text-align: right;\n"]))),
    Qi = function Qi(e) {
      var t = e.disabled,
        n = e.selected,
        l = e.onClick,
        A = e.label,
        o = e.leftSideNote,
        a = e.rightSideNote;
      return r().createElement(r().Fragment, null, r().createElement(y.Selector, {
        alignment: "row",
        disabled: t,
        selected: n,
        onClick: l,
        "data-testid": "paymentMethodSelector"
      }, r().createElement(y.Selector.Body, {
        title: A,
        subtitle: Si(e),
        disabled: t,
        align: "start",
        "data-testid": "paymentMethodSelectorLabel"
      }), Di(e)), r().createElement(Li, null, o && r().createElement(Pi, {
        "data-testid": "paymentMethodSelectorLeftSideNote",
        top: .5,
        responsive: !1
      }, r().createElement(y.Text, {
        type: "smallBody"
      }, o)), a && r().createElement(Mi, {
        "data-testid": "paymentMethodSelectorRightSideNote",
        top: .5,
        responsive: !1
      }, r().createElement(y.Text, {
        type: "smallBody"
      }, a))));
    },
    Ni = function Ni(e) {
      var t = e.paymentMethods;
      return Array.isArray(t) ? r().createElement(r().Fragment, null, t.map(function (e, t) {
        return r().createElement(y.Spacing, {
          top: 0 !== t ? 2 : 0,
          responsive: !1,
          "data-testid": "paymentMethodSelectorContainer"
        }, r().createElement(Qi, _ki({}, e, {
          key: e.label
        })));
      })) : null;
    },
    Hi = h().div(Ti || (Ti = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }(["\n  opacity: ", ";\n"], ["\n  opacity: ", ";\n"])), function (e) {
      return e.disabled ? .5 : 1;
    }),
    Fi = function Fi(e) {
      var t = (0, y.useTheme)().theme;
      return r().createElement(r().Fragment, null, r().createElement(y.Layout.Inline, {
        align: "spaceBetween",
        alignY: "center"
      }, r().createElement(y.Layout.Inline, {
        alignY: "center",
        space: 2,
        "data-testid": "paymentMethodViewMode"
      }, Di(e), r().createElement(Hi, {
        "data-testid": "paymentMethodDeailsContainer",
        disabled: e.inactive
      }, r().createElement(y.Text, {
        "data-testid": "paymentMethodLabel"
      }, e.label), r().createElement(y.Text, {
        color: t.cl_ter_l2,
        type: "smallBody",
        "data-testid": "paymentMethodSubLabel"
      }, Si(e)))), e.action && r().createElement(y.TextLink, {
        "data-testid": "actionLink",
        onClick: e.action.onClick
      }, e.action.text)), e.note && r().createElement(y.Spacing, {
        top: 1,
        responsive: !1
      }, r().createElement(y.Text, {
        type: "smallBody"
      }, e.note)));
    },
    _Xi = function Xi() {
      return _Xi = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Xi.apply(this, arguments);
    };
  var Vi = function Vi(e) {
    var t = e.displayMode,
      n = e.header,
      l = e.description,
      A = e.notification,
      o = e.showDivider;
    return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
      top: 2
    }, n && r().createElement(y.Spacing, {
      bottom: 2,
      responsive: !1
    }, r().createElement(y.Text, {
      type: "header",
      fontWeight: "bold",
      "data-testid": "paymentInfoTitle"
    }, n)), l && r().createElement(y.Spacing, {
      bottom: 2,
      responsive: !1
    }, r().createElement(y.Text, {
      type: "body",
      "data-testid": "paymentInfoDescription"
    }, l)), A && r().createElement(y.Spacing, {
      bottom: 2,
      responsive: !1,
      "data-testid": "paymentInfoNotification"
    }, r().createElement(y.StatusAlert, _Xi({}, A))), t === fi.SELECTOR ? r().createElement(Ni, {
      paymentMethods: e.paymentMethods
    }) : r().createElement(Fi, _Xi({}, e.paymentMethod))), o && r().createElement(y.Spacing, {
      topBottom: 2,
      "data-testid": "paymentSectionDivider"
    }, r().createElement(y.Divider, null)));
  };
  var _Gi = function Gi() {
      return _Gi = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Gi.apply(this, arguments);
    },
    zi = function zi(e) {
      var t = e.total,
        n = e.placeOrderBtnHandling,
        l = e.placeOrderButton;
      return r().createElement(da, null, r().createElement(B(), {
        disabled: !1
      }, r().createElement(y.Card, {
        padding: "lg",
        radius: "false"
      }, r().createElement(Nn, {
        data: _Gi({}, t)
      }, r().createElement(y.Button, {
        "data-testid": "place-order",
        text: v("PROCEED"),
        onClick: n,
        loading: (null == l ? void 0 : l.loading) || !1
      })))));
    },
    Ui = function Ui(e) {
      var t = e.paymentInfo,
        l = e.total,
        A = e.checkboxErrorMsg,
        o = e.onTncChanged,
        a = e.tncChecked,
        i = e.hideTnc,
        c = e.placeOrderBtnHandling,
        u = e.placeOrderButton,
        s = e.readOnly,
        d = void 0 !== s && s,
        m = e.checkoutNote,
        E = e.stickyBoundaryElement,
        g = (0, n.useState)(!1),
        f = g[0],
        p = g[1],
        w = (0, n.useRef)(null),
        h = (0, y.useWindowSize)(),
        C = (0, y.useTheme)();
      (0, n.useEffect)(function () {
        var e;
        h.height > (null === (e = null == w ? void 0 : w.current) || void 0 === e ? void 0 : e.offsetHeight) ? p(!0) : p(!1);
      }, [h]);
      var x = function x() {
        return r().createElement("div", null, r().createElement(y.Spacing, {
          bottom: 2
        }, r().createElement(Ot, {
          data: l
        })), l.showDivider && r().createElement(y.Divider, null), t && r().createElement(Vi, _Gi({}, t)), !d && !i && r().createElement(y.Checkbox.InputGroup, {
          error: A
        }, r().createElement(y.Checkbox.Input, {
          "data-testid": "tnc-checkbox",
          checked: a,
          onChange: o,
          label: r().createElement(y.Text, null, v("ORDER_SUMMARY_TNC_LABEL"))
        })), !d && r().createElement(y.Spacing, {
          topBottom: 2
        }, r().createElement(y.Button, {
          "data-testid": "place-order",
          text: v("PROCEED"),
          fullWidth: !0,
          onClick: c,
          loading: (null == u ? void 0 : u.loading) || !1
        }), !!m && r().createElement(y.Spacing, {
          top: 1,
          responsive: !1,
          style: {
            textAlign: "center"
          }
        }, r().createElement(y.Text, {
          type: "smallBody",
          color: C.cl_ter_l2
        }, m))));
      };
      return r().createElement(y.Row, null, r().createElement(y.Column, _Gi({}, Lr, {
        "data-testid": "desktop-summary"
      }), r().createElement(B(), {
        topOffset: 32,
        stickyStyle: {
          transform: "translateY(32px)"
        },
        disabled: !f,
        hideOnBoundaryHit: !1,
        boundaryElement: E
      }, r().createElement(y.Card, {
        padding: "lg",
        ref: w
      }, r().createElement(y.Card.Content, null, r().createElement(Ye, null, r().createElement(x, null)))))), r().createElement(y.Column, _Gi({
        noGutter: !0
      }, Pr, {
        "data-testid": "mobile-summary"
      }), r().createElement("div", {
        id: xA
      }, r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(x, null)))));
    },
    _ji = function ji() {
      return _ji = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _ji.apply(this, arguments);
    },
    Ji = function Ji(e) {
      var t = e.data,
        l = t.infos,
        A = t.orders,
        o = t.bills,
        a = t.comingUp,
        i = t.total,
        c = t.paymentInfo,
        u = t.checkoutNote,
        s = e.configs,
        d = s.placeOrderButton,
        m = void 0 === d ? {
          loading: !1
        } : d,
        E = s.showOrderTitle,
        g = void 0 === E || E,
        f = s.hideTnc,
        w = void 0 !== f && f,
        h = s.readOnly,
        C = void 0 !== h && h,
        B = s.stickyBoundaryElement,
        x = void 0 === B ? ".stickyBoundary" : B,
        I = e.callbacks.onPlaceOrder,
        b = void 0 === I ? function () {} : I,
        O = e.localisation;
      p(O);
      var T = (0, y.useTheme)(),
        D = ii,
        S = (0, n.useState)(!1),
        R = S[0],
        k = S[1],
        L = (0, n.useState)(""),
        P = L[0],
        M = L[1];
      (0, n.useEffect)(function () {
        R && M("");
      }, [R, P]);
      var Q = (0, n.useCallback)(function (e) {
        var t = e.fromStickyTop,
          n = void 0 !== t && t;
        w || R ? b() : (k(!1), n && UA(xA), M(v("ORDER_SUMMARY_TNC_ERROR_MESSAGE")));
      }, [R, b]);
      return r().createElement(r().Fragment, null, !C && r().createElement(y.Column, {
        xs: 12,
        md: !1,
        noGutter: !0
      }, r().createElement(zi, {
        total: i,
        placeOrderBtnHandling: function placeOrderBtnHandling() {
          return Q({
            fromStickyTop: !0
          });
        },
        placeOrderButton: m
      })), r().createElement(Je, {
        "data-testid": "order-summary-section"
      }, r().createElement("div", {
        className: "fs-unmask stickyBoundary"
      }, r().createElement(y.Row, {
        between: "md",
        noGutter: !0
      }, r().createElement(y.Column, {
        xs: 12,
        md: 7,
        noGutter: !0
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        noGutter: !0
      }, r().createElement(y.Spacing, {
        bottom: 1
      }, r().createElement(y.Text, {
        type: "pageTitle"
      }, v("ORDER_SUMMARY_PAGE_TITLE"))), null == l ? void 0 : l.map(function (e) {
        return r().createElement(qa, _ji({}, e));
      }), g && (null == A ? void 0 : A.length) > 0 && r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 1,
        "data-testid": "order-title-section"
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.Text, {
        type: "sectionTitle02"
      }, v("YOUR_ORDER"))))), r().createElement(y.Divider, null)), null == A ? void 0 : A.map(function (e) {
        return D.map(function (t) {
          var n = ci[t],
            l = e[n];
          if (l) {
            var A = ui[t];
            return r().createElement(A, _ji({}, l));
          }
        });
      }), null == o ? void 0 : o.map(function (e) {
        return r().createElement(di, _ji({}, e));
      }), a && r().createElement(mi, _ji({}, a))))), r().createElement(y.Column, {
        xs: 12,
        md: 4,
        noGutter: !0
      }, r().createElement(Ui, {
        paymentInfo: c,
        total: i,
        checkboxErrorMsg: P && r().createElement(y.Text, {
          type: "smallBody",
          color: T.cl_pri_d2
        }, P),
        tncChecked: R,
        onTncChanged: function onTncChanged() {
          return k(!R);
        },
        hideTnc: w,
        placeOrderBtnHandling: function placeOrderBtnHandling() {
          return Q({
            fromStickyTop: !1
          });
        },
        placeOrderButton: m,
        readOnly: C,
        checkoutNote: u,
        stickyBoundaryElement: x
      }))))));
    };
  var Yi = e.p + "e27cab0057f7016891e87ca34daa12a7.png";
  var Ki,
    Zi,
    qi = function qi(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Wi = h().img(Ki || (Ki = qi(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"]))),
    _i = h()(y.Text)(Zi || (Zi = qi(["\n  a {\n    display: inline;\n  }\n"], ["\n  a {\n    display: inline;\n  }\n"]))),
    $i = function $i(e) {
      var t = e.data,
        n = e.callbacks,
        l = n.onClickGIA,
        A = n.onClickLinks,
        o = n.onClickCTA,
        a = t || {},
        i = a.footer,
        c = a.links,
        u = a.loading,
        s = a.header,
        d = a.banner;
      return r().createElement(r().Fragment, null, r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(Wi, {
        src: d || Yi,
        alt: "Logo",
        "data-testid": "pdpa-banner"
      })), t ? r().createElement(r().Fragment, null, r().createElement(y.Spacing, null, r().createElement(y.Text, {
        type: "body"
      }, !!i && !!i.link && !!i.text1 && !!i.text2 && r().createElement(r().Fragment, null, i.text1, " ", !!i.link.value && !!i.link.text && r().createElement(y.TextLink, {
        "data-testid": "link-footer-text1",
        inline: !0,
        onClick: function onClick() {
          return l(i.link.value);
        }
      }, i.link.text), i.text2))), r().createElement(y.Spacing, {
        top: 2
      }, r().createElement(y.Text, {
        type: "body"
      }, s.text)), c.map(function (e, t) {
        return r().createElement(y.Spacing, {
          top: 1,
          key: t
        }, r().createElement(_i, {
          type: "body"
        }, "•", "  ", r().createElement(y.TextLink, {
          "data-testid": "link-".concat(t),
          onClick: function onClick() {
            return A(e.value);
          }
        }, r().createElement(y.TextLink.Text, null, e.text))));
      }), r().createElement(y.Spacing, {
        topBottom: 2
      }, r().createElement(y.Button, {
        "data-testid": "proceed",
        fullWidth: !0,
        text: v("CTA_INSURANCE_PDPA"),
        loading: u,
        onClick: o
      }))) : null);
    };
  var _ec = function ec() {
    return _ec = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var l in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }
      return e;
    }, _ec.apply(this, arguments);
  };
  var tc,
    nc,
    rc = {
      ITEMS: "ITEMS",
      NOTIFICATION: "NOTIFICATION",
      METHODS: "METHODS",
      FORM: "FORM",
      TITLE: "TITLE",
      NOTES: "NOTES",
      DIVIDER: "DIVIDER",
      POP_STATION_RESULTS: "POP_STATION_RESULTS"
    },
    lc = [rc.TITLE, rc.ITEMS, rc.NOTIFICATION, rc.METHODS, rc.DIVIDER],
    Ac = ((tc = {})[rc.ITEMS] = "items", tc[rc.NOTIFICATION] = "notification", tc[rc.METHODS] = "methods", tc[rc.TITLE] = "title", tc),
    oc = ((nc = {})[rc.ITEMS] = function (e) {
      var t = e.list;
      return r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(OA, {
        items: t
      })));
    }, nc[rc.NOTIFICATION] = function (e) {
      var t = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, []);
      return r().createElement(y.Spacing, {
        type: "margin",
        bottom: 1
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(TA, {
        note: t
      }))));
    }, nc[rc.METHODS] = function (e) {
      var t = e.orderId,
        l = e.pickupOptions,
        A = void 0 === l ? [] : l,
        o = e.callbacks,
        a = e.data,
        i = e.configs,
        c = (0, n.useContext)(ur),
        u = c.fulfilmentPageData,
        s = c.handleFulfilmentPageData,
        d = (0, n.useState)([]),
        m = d[0],
        E = d[1],
        g = (0, n.useCallback)(function (e) {
          var n, r;
          if ((null == o ? void 0 : o.onPickupChange) && o.onPickupChange(t, e), s(_ec(_ec({}, u), ((n = {})[t] = {
            fulfilmentMethod: e
          }, n))), w({
            pickupType: e
          }), e === Ir) E([]);else {
            var l = null === (r = A.find(function (t) {
              return t.type === e;
            })) || void 0 === r ? void 0 : r.explain;
            l && E(l);
          }
          !function (e) {
            var n, r, l, A;
            n = void 0, r = void 0, A = function A() {
              return function (e, t) {
                var n,
                  r,
                  l,
                  A,
                  o = {
                    label: 0,
                    sent: function sent() {
                      if (1 & l[0]) throw l[1];
                      return l[1];
                    },
                    trys: [],
                    ops: []
                  };
                return A = {
                  next: a(0),
                  throw: a(1),
                  return: a(2)
                }, "function" == typeof Symbol && (A[Symbol.iterator] = function () {
                  return this;
                }), A;
                function a(a) {
                  return function (i) {
                    return function (a) {
                      if (n) throw new TypeError("Generator is already executing.");
                      for (; A && (A = 0, a[0] && (o = 0)), o;) {
                        try {
                          if (n = 1, r && (l = 2 & a[0] ? r.return : a[0] ? r.throw || ((l = r.return) && l.call(r), 0) : r.next) && !(l = l.call(r, a[1])).done) return l;
                          switch (r = 0, l && (a = [2 & a[0], l.value]), a[0]) {
                            case 0:
                            case 1:
                              l = a;
                              break;
                            case 4:
                              return o.label++, {
                                value: a[1],
                                done: !1
                              };
                            case 5:
                              o.label++, r = a[1], a = [0];
                              continue;
                            case 7:
                              a = o.ops.pop(), o.trys.pop();
                              continue;
                            default:
                              if (!((l = (l = o.trys).length > 0 && l[l.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                o = 0;
                                continue;
                              }
                              if (3 === a[0] && (!l || a[1] > l[0] && a[1] < l[3])) {
                                o.label = a[1];
                                break;
                              }
                              if (6 === a[0] && o.label < l[1]) {
                                o.label = l[1], l = a;
                                break;
                              }
                              if (l && o.label < l[2]) {
                                o.label = l[2], o.ops.push(a);
                                break;
                              }
                              l[2] && o.ops.pop(), o.trys.pop();
                              continue;
                          }
                          a = t.call(e, o);
                        } catch (e) {
                          a = [6, e], r = 0;
                        } finally {
                          n = l = 0;
                        }
                      }
                      if (5 & a[0]) throw a[1];
                      return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                      };
                    }([a, i]);
                  };
                }
              }(this, function (n) {
                switch (n.label) {
                  case 0:
                    return e !== yr && e !== xr ? [3, 2] : [4, null == o ? void 0 : o.getDeliverySlots(t)];
                  case 1:
                    n.sent(), n.label = 2;
                  case 2:
                    return [2];
                }
              });
            }, new ((l = void 0) || (l = Promise))(function (e, t) {
              function o(e) {
                try {
                  i(A.next(e));
                } catch (e) {
                  t(e);
                }
              }
              function a(e) {
                try {
                  i(A.throw(e));
                } catch (e) {
                  t(e);
                }
              }
              function i(t) {
                var n;
                t.done ? e(t.value) : (n = t.value, n instanceof l ? n : new l(function (e) {
                  e(n);
                })).then(o, a);
              }
              i((A = A.apply(n, r || [])).next());
            });
          }(e);
        }, []),
        f = (0, n.useState)({
          pickupType: "",
          collectAtStoreValidity: !0,
          collectAtStoreTimeSlot: null
        }),
        p = f[0],
        v = f[1],
        w = function w(e) {
          v(function (t) {
            return _ec(_ec({}, t), e);
          });
        },
        h = {
          onDeliveryDateAndTimeSelection: function onDeliveryDateAndTimeSelection(e) {
            var n;
            s(((n = {})[t] = _ec(_ec({}, null == u ? void 0 : u[t]), e), n));
          },
          fulfilmentValue: p,
          setFulfilmentValueData: w,
          configs: i,
          onSearchPopstation: function onSearchPopstation(e) {
            null == o || o.onPostalCodeSearch(t, e);
          },
          onSearchPopstationTimeslot: null == o ? void 0 : o.getPopstationTimeslot,
          bags: [{
            id: t,
            pickup: A
          }],
          validateResult: {
            status: !(null == u ? void 0 : u.validateForm)
          }
        };
      return r().createElement(r().Fragment, null, r().createElement(sr, _ec({}, h), r().createElement(y.Spacing, {
        type: "margin",
        bottom: 2,
        responsive: !1
      }, !!A.length && r().createElement(y.Spacing, {
        type: "margin",
        bottom: 2,
        responsive: !1
      }, r().createElement(jA, {
        items: A,
        onSelect: g
      })), (null == p ? void 0 : p.pickupType) && function () {
        var e;
        switch (p.pickupType) {
          case xr:
          case yr:
            var n = Object.keys((null == a ? void 0 : a.deliverySlots) || {}).length > 0;
            return r().createElement(r().Fragment, null, n && r().createElement(mA, {
              timeslots: a.deliverySlots
            }));
          case Ir:
            return r().createElement(Kr, {
              onPopStationSelected: function onPopStationSelected(e) {
                var n;
                s(_ec(_ec({}, u), ((n = {})[t] = _ec(_ec({}, null == u ? void 0 : u[t]), e), n)));
              },
              bagId: t,
              popstations: null !== (e = null == a ? void 0 : a.popStations) && void 0 !== e ? e : [],
              popstationTimeslots: a.popstationTimeslots
            });
          default:
            return r().createElement(r().Fragment, null);
        }
      }(), r().createElement(r().Fragment, null, m.length > 0 && m.map(function (e) {
        return r().createElement(y.Row, null, r().createElement(y.Column, {
          xs: 12
        }, r().createElement(y.Spacing, {
          type: "margin",
          top: 2.5
        }, r().createElement(Fe, {
          alignY: "top"
        }, (null == e ? void 0 : e.icon) && r().createElement(ce.Icon, {
          size: 28,
          name: e.icon
        }), r().createElement(y.Text, null, null == e ? void 0 : e.message)))));
      })))));
    }, nc[rc.TITLE] = function (e) {
      var t = e.text,
        n = e.icon || "shop";
      return r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(Fe, {
        alignY: "center"
      }, r().createElement(Ne, null, r().createElement(ce.Icon, {
        size: 28,
        name: n
      })), r().createElement(y.Text, {
        type: "boldBody"
      }, t))));
    }, nc[rc.DIVIDER] = function () {
      return r().createElement(y.Spacing, {
        top: 2,
        bottom: 2
      }, r().createElement(y.Divider, null));
    }, nc),
    _ac = function ac() {
      return _ac = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _ac.apply(this, arguments);
    },
    ic = function ic(e) {
      var t = e.orders,
        l = e.addressModel,
        A = e.layout,
        o = e.callbacks.onProceed,
        a = A || lc,
        i = (0, n.useState)(!1),
        c = i[0],
        u = i[1],
        s = (0, n.useState)({
          validateForm: !1,
          isAddressValid: !1,
          deliveryAddress: null == l ? void 0 : l.address
        }),
        d = s[0],
        m = s[1],
        E = (0, n.useCallback)(function (e) {
          m(function (t) {
            return _ac(_ac({}, t), e);
          });
        }, []),
        g = _ac(_ac(_ac({}, e), l), {
          fulfilmentPageData: d,
          handleFulfilmentPageData: E
        });
      return (0, n.useEffect)(function () {
        var e = Object.keys(d).some(function (e) {
          var t, n;
          return (null === (t = null == d ? void 0 : d[e]) || void 0 === t ? void 0 : t.fulfilmentMethod) === yr || (null === (n = null == d ? void 0 : d[e]) || void 0 === n ? void 0 : n.fulfilmentMethod) === xr;
        });
        u(e);
      }, [d]), r().createElement(sr, _ac({}, g), r().createElement(y.Grid, null, r().createElement(y.Row, null, r().createElement(y.Column, {
        noGutter: !0,
        xs: 12,
        md: 7
      }, r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12
      }, r().createElement(y.Spacing, {
        bottom: "8px"
      }, r().createElement(y.Text, {
        type: "pageTitle"
      }, v("PAGE_TITLE_DELIVERY"))))), t.map(function (e) {
        return a.map(function (t) {
          var n = Ac[t],
            l = _ac(_ac({}, e[n]), {
              orderId: e.orderId
            }),
            A = oc[t];
          return r().createElement(A, _ac({}, l));
        });
      }), c && r().createElement(r().Fragment, null, r().createElement(ro, {
        onAddressSelected: function onAddressSelected(e) {
          E({
            deliveryAddress: e
          });
        }
      })), r().createElement(y.Row, null, r().createElement(y.Column, {
        xs: 12,
        md: 4
      }, r().createElement(y.Spacing, {
        top: 3,
        bottom: 2
      }, r().createElement(y.Button, {
        "data-testid": "proceed-fulfilment",
        onClick: function onClick() {
          m(function (e) {
            return _ac(_ac({}, e), {
              validateForm: !d.validateForm
            });
          }), function () {
            var e, t;
            return !(c && ((null === (e = null == l ? void 0 : l.validFloors) || void 0 === e ? void 0 : e.length) && !d.isAddressValid || !(null === (t = null == d ? void 0 : d.deliveryAddress) || void 0 === t ? void 0 : t.postcode)) || Object.keys(d).some(function (e) {
              var t, n, r;
              return "popstation" === (null === (t = null == d ? void 0 : d[e]) || void 0 === t ? void 0 : t.fulfilmentMethod) && !(null === (r = null === (n = null == d ? void 0 : d[e]) || void 0 === n ? void 0 : n.popStation) || void 0 === r ? void 0 : r.kioskId);
            }));
          }() && o(d);
        },
        fullWidth: !0
      }, v("BUTTON_PROCEED")))))))));
    },
    _cc = function cc() {
      return _cc = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _cc.apply(this, arguments);
    };
  var uc = function uc(e) {
    var t = e.type,
      n = void 0 === t ? "primary" : t,
      l = e.text,
      A = e.onClick,
      o = e.fullWidth,
      a = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, ["type", "text", "onClick", "fullWidth"]);
    return r().createElement(y.Button, _cc({
      "data-testid": "ActionButton",
      fullWidth: o,
      secondary: "secondary" === n,
      onClick: A
    }, a), l);
  };
  var sc,
    dc,
    mc,
    Ec,
    gc,
    fc,
    pc,
    vc,
    wc,
    hc,
    Cc = function Cc(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Bc = (0, w.css)(dc || (dc = Cc(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      return e.clickable && (0, w.css)(sc || (sc = Cc(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
    }),
    yc = function yc(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    xc = (0, w.css)(mc || (mc = yc(["\n  overflow: hidden;\n  border-radius: 6px;\n\n  & > * {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  overflow: hidden;\n  border-radius: 6px;\n\n  & > * {\n    width: 100%;\n    height: 100%;\n  }\n"]))),
    Ic = h().div(Ec || (Ec = yc(["\n  height: 56px;\n  width: 56px;\n  margin-right: 1rem;\n  align-self: flex-start;\n  margin-top: 6px;\n  flex-shrink: 0;\n\n  ", "\n  ", "\n"], ["\n  height: 56px;\n  width: 56px;\n  margin-right: 1rem;\n  align-self: flex-start;\n  margin-top: 6px;\n  flex-shrink: 0;\n\n  ", "\n  ", "\n"])), xc, Bc),
    bc = h().div(gc || (gc = yc(["\n  height: 45px;\n  width: 45px;\n  border-radius: 6px;\n  margin-right: 8px;\n\n  ", "\n"], ["\n  height: 45px;\n  width: 45px;\n  border-radius: 6px;\n  margin-right: 8px;\n\n  ", "\n"])), xc),
    Oc = h().div(pc || (pc = yc(["\n  display: flex;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n\n  ", "\n"])), function (e) {
      return e.align && (0, w.css)(fc || (fc = yc(["\n      justify-content: ", ";\n    "], ["\n      justify-content: ", ";\n    "])), e.align);
    }),
    Tc = h()(y.Text)(wc || (wc = yc(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), Bc, function (e) {
      var t = e.align;
      return t && (0, w.css)(vc || (vc = yc(["\n      text-align: ", ";\n    "], ["\n      text-align: ", ";\n    "])), t);
    }),
    Dc = h().div(hc || (hc = yc(["\n  display: inline-flex;\n  ", ";\n"], ["\n  display: inline-flex;\n  ", ";\n"])), Bc),
    _Sc = function Sc() {
      return _Sc = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Sc.apply(this, arguments);
    };
  var Rc = function Rc(e) {
    var t = e.onClick,
      n = function (e, t) {
        var n = {};
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var l = 0;
          for (r = Object.getOwnPropertySymbols(e); l < r.length; l++) {
            t.indexOf(r[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[l]) && (n[r[l]] = e[r[l]]);
          }
        }
        return n;
      }(e, ["onClick"]),
      l = n.title,
      A = n.leftTitle,
      o = n.subtitle,
      a = n.thumbnail,
      i = n.icons,
      c = n.rawData,
      u = (0, y.useTheme)().theme,
      s = t ? {
        onClick: function onClick() {
          return t(c || n);
        },
        clickable: !!t
      } : {};
    return r().createElement("div", {
      "data-testid": "InfoListElement"
    }, r().createElement(Oc, null, a && r().createElement(Ic, _Sc({
      "data-testid": "ElementThumbnail"
    }, s), a), r().createElement("div", {
      style: {
        width: "100%"
      }
    }, r().createElement(Oc, {
      align: "space-between"
    }, r().createElement(Tc, _Sc({
      type: "boldBody"
    }, s), l), r().createElement(Tc, _Sc({
      type: "boldBody",
      align: "right"
    }, s), A)), i && r().createElement(y.Spacing, {
      topBottom: 1,
      responsive: !1
    }, r().createElement(Dc, _Sc({}, s, {
      "data-testid": "ElementIcons"
    }), i.map(function (e, t) {
      return r().createElement(bc, {
        key: t
      }, e);
    }))), o && r().createElement("div", {
      "data-testid": "ElementSubtitle"
    }, o.map(function (e, t) {
      return r().createElement(y.Text, {
        key: t,
        type: "smallBody",
        color: u.cl_ter_l2
      }, e);
    })))));
  };
  var kc = function kc(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _Lc = function Lc() {
      return _Lc = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Lc.apply(this, arguments);
    },
    Pc = (0, y.withTheme)(h()(y.Text)(Hc || (Hc = kc(["\n  ", "\n"], ["\n  ", "\n"])), function (e) {
      var t = e.coreTheme;
      return (0, w.css)(Nc || (Nc = kc(["\n    text-align: center;\n    @media (min-width: ", ") {\n      text-align: left;\n    }\n  "], ["\n    text-align: center;\n    @media (min-width: ", ") {\n      text-align: left;\n    }\n  "])), t.brk_xs);
    })),
    Mc = h()(y.Spacing)(Fc || (Fc = kc(["\n  border-radius: 8px;\n  background-color: ", ";\n"], ["\n  border-radius: 8px;\n  background-color: ", ";\n"])), function (e) {
      return e.bgColor;
    });
  var Qc = function Qc(e) {
    var t = e.data,
      n = e.config,
      l = void 0 === n ? {} : n,
      A = t.pageTitle,
      o = t.title,
      a = t.icons,
      i = t.thumbnail,
      c = t.info,
      u = t.notification,
      s = l.action,
      d = (0, y.useDevice)().isMobile,
      m = (0, y.useTheme)().theme;
    return r().createElement(y.Grid, null, r().createElement(y.Row, null, r().createElement(y.Column, {
      mdOffset: 2,
      xs: 12,
      md: 8
    }, r().createElement(y.Spacing, {
      bottom: 3
    }, r().createElement(y.Text, {
      type: "pageTitle"
    }, A)))), u && r().createElement(y.Row, null, r().createElement(y.Column, {
      mdOffset: 2,
      xs: 12,
      md: 8
    }, r().createElement(Mc, {
      "data-testid": "BasicDetailsNotification",
      type: "margin",
      bottom: 1,
      bgColor: m.cl_ter_l6,
      responsive: !1
    }, r().createElement(y.Spacing, {
      topBottom: 2,
      leftRight: 2
    }, r().createElement(y.Text, {
      tag: "div",
      type: "smallBody"
    }, u))))), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12,
      md: 8,
      mdOffset: 2
    }, r().createElement(Rc, {
      title: o,
      thumbnail: i,
      icons: a
    }))), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12,
      md: 8,
      mdOffset: 2
    }, r().createElement(y.Spacing, {
      bottom: 3,
      "data-testid": "BasicDetailsInfo"
    }, c.map(function (e) {
      return r().createElement(y.Layout.Inline, {
        key: e.label,
        align: "spaceBetween"
      }, r().createElement(y.Text, {
        type: "boldBody"
      }, e.label), r().createElement(y.Text, null, e.value));
    })))), s && r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12,
      md: 8,
      mdOffset: 2
    }, r().createElement(uc, _Lc({}, s, {
      fullWidth: d
    })), s.description && r().createElement(y.Spacing, {
      top: 1,
      responsive: !1
    }, r().createElement(Pc, {
      type: "smallBody"
    }, s.description)))));
  };
  var Nc,
    Hc,
    Fc,
    Xc = function Xc(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    _Vc = function Vc() {
      return _Vc = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Vc.apply(this, arguments);
    },
    Gc = h().div(jc || (jc = Xc(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (e) {
      return e.fullwidth ? "100%" : "calc(100% - 16px)";
    }),
    zc = h()(Oc)(Jc || (Jc = Xc(["\n  width: 16px;\n  padding-left: 1rem;\n  ", "\n\n  svg {\n    pointer-events: none;\n  }\n"], ["\n  width: 16px;\n  padding-left: 1rem;\n  ", "\n\n  svg {\n    pointer-events: none;\n  }\n"])), Bc);
  var Uc = function Uc(e) {
    var t = e.item,
      n = e.onClick,
      l = e.iconActionProps,
      A = e.showDivider,
      o = void 0 === A || A;
    return r().createElement(y.Spacing, {
      bottom: 2,
      "data-testid": "InfoListItem"
    }, r().createElement(Oc, null, r().createElement(Gc, {
      fullwidth: !(null == l ? void 0 : l.icon)
    }, r().createElement(Rc, _Vc({}, t, {
      onClick: n
    }))), (null == l ? void 0 : l.icon) && r().createElement(zc, _Vc({
      "data-testid": "InfoListItemIcon",
      align: "flex-end",
      clickable: !!l.onClick
    }, l.onClick && {
      onClick: function onClick() {
        return l.onClick(t.rawData || t);
      }
    }), r().createElement(ce.Icon, {
      name: l.icon,
      color: l.color
    }))), t.description && r().createElement(y.Spacing, {
      "data-testid": "ElementDescription",
      top: 1,
      responsive: !1
    }, t.description), o && r().createElement(y.Spacing, {
      top: 2,
      "data-testid": "InfoListItemDivider"
    }, r().createElement(y.Divider, null)));
  };
  var jc,
    Jc,
    Yc = {
      iconActionProps: {
        icon: "arrow_right"
      }
    },
    _Kc = function Kc() {
      return _Kc = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var l in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
          }
        }
        return e;
      }, _Kc.apply(this, arguments);
    };
  var Zc = function Zc(e) {
    var t = e.data,
      n = e.callbacks,
      l = void 0 === n ? {} : n,
      A = e.config,
      o = void 0 === A ? Yc : A,
      a = t.items,
      i = t.pageTitle,
      c = o.iconActionProps,
      u = _Kc(_Kc({}, Yc.iconActionProps), c);
    return r().createElement(y.Grid, {
      "data-testid": "InfoList"
    }, r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12,
      md: 8,
      mdOffset: 2
    }, r().createElement(y.Spacing, {
      bottom: 3,
      responsive: !1
    }, r().createElement(y.Text, {
      type: "pageTitle"
    }, i)))), r().createElement(y.Row, null, r().createElement(y.Column, {
      xs: 12,
      md: 8,
      mdOffset: 2
    }, a.map(function (e, t) {
      return r().createElement(Uc, _Kc({
        key: t,
        item: e
      }, l.onListItemClick && {
        onClick: function onClick(e) {
          return l.onListItemClick(e);
        }
      }, {
        showDivider: t < a.length - 1,
        iconActionProps: _Kc({
          icon: u.icon,
          color: u.color
        }, (u.onClick || l.onListItemClick) && {
          onClick: function onClick(e) {
            (u.onClick || l.onListItemClick)(e);
          }
        })
      }));
    }))));
  };
  var qc = exports;
  for (var Wc in t) {
    qc[Wc] = t[Wc];
  }
  t.__esModule && Object.defineProperty(qc, "__esModule", {
    value: !0
  });
})();